webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/TydSuG/%3F1721451108686&title=Heidegger%20and%20Kabbalah%2C%20New%20Jewish%20Philosophy%20and%20Thought&summary=While%20many%20scholars%20have%20noted%20Martin%20Heidegger%27s%20indebtedness%20to%20Christian%20mystical%20sources%2C%20as%20well%20as%20his%20affinity%20with%20Taoism%20and%20Buddhism%2C%20Elliot%20R.%20Wolfson%20expands%20connections%20between%20Heidegger%27s%20thought%20and%20kabbalistic%20material.%20By%20arguing%20th&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/TydSuG/%3F1721451108686",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=While%20many%20scholars%20have%20noted%20Martin%20Heidegger%27s%20indebtedness%20to%20Christian%20mystical%20sources%2C%20as%20well%20as%20his%20affinity%20with%20Taoism%20and%20Budd%0Dhttps://textcafe.co/books/TydSuG/%3F1721451108686&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/TydSuG/%3F1721451108686&posttype=link&caption=While%20many%20scholars%20have%20noted%20Martin%20Heidegger%27s%20indebtedness%20to%20Christian%20mystical%20sources%2C%20as%20well%20as%20his%20affinity%20with%20Taoism%20and%20Buddhism%2C%20Elliot%20R.%20Wolfson%20expands%20connections%20between%20Heidegger%27s%20thought%20and%20kabbalistic%20material.%20By%20arguing%20th",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/TydSuG/%3F1721451108686&description=While%20many%20scholars%20have%20noted%20Martin%20Heidegger%27s%20indebtedness%20to%20Christian%20mystical%20sources%2C%20as%20well%20as%20his%20affinity%20with%20Taoism%20and%20Buddhism%2C%20Elliot%20R.%20Wolfson%20expands%20connections%20between%20Heidegger%27s%20thought%20and%20kabbalistic%20material.%20By%20arguing%20th&media=https://textcafe.co/books/TydSuG/tc-custom/9780253042583.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9780253042583&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=546uDwAAQBAJ&amp;rdid=book-546uDwAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9780253042583').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/TydSuG/tc-custom/9780253042583.jpg?1721451108686',
        alt: 'Heidegger and Kabbalah, New Jewish Philosophy and Thought'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "text/9780253042569_Contents", "text/9780253042569_Halftitle_1", "text/9780253042569_Introduction", "text/9780253042569_Chapter_1", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/TydSuG/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_9780253042569_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_text_9780253042569_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_text_9780253042569_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_9780253042569_Halftitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_text_9780253042569_Halftitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_text_9780253042569_Halftitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_text_9780253042569_Frontmatter_1__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_text_9780253042569_Frontmatter_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_text_9780253042569_Frontmatter_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_9780253042569_Titlepage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_text_9780253042569_Titlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_text_9780253042569_Titlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_9780253042569_Copyright__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_text_9780253042569_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_text_9780253042569_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_9780253042569_Dedication__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_text_9780253042569_Dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_text_9780253042569_Dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_9780253042569_Frontmatter_2__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_text_9780253042569_Frontmatter_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_text_9780253042569_Frontmatter_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_9780253042569_Contents__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_text_9780253042569_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_text_9780253042569_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_9780253042569_Halftitle_1__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_text_9780253042569_Halftitle_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_text_9780253042569_Halftitle_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_9780253042569_Introduction__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_text_9780253042569_Introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_text_9780253042569_Introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_9780253042569_Chapter_1__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_text_9780253042569_Chapter_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_text_9780253042569_Chapter_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_text_9780253042569_Chapter_2__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_text_9780253042569_Chapter_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_text_9780253042569_Chapter_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_text_9780253042569_Chapter_3__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_text_9780253042569_Chapter_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_text_9780253042569_Chapter_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_text_9780253042569_Chapter_4__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_text_9780253042569_Chapter_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_text_9780253042569_Chapter_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_text_9780253042569_Chapter_5__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_text_9780253042569_Chapter_5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_text_9780253042569_Chapter_5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_text_9780253042569_Chapter_6__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_text_9780253042569_Chapter_6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_text_9780253042569_Chapter_6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_text_9780253042569_Chapter_7__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_text_9780253042569_Chapter_7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_text_9780253042569_Chapter_7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_text_9780253042569_Chapter_8__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_text_9780253042569_Chapter_8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_text_9780253042569_Chapter_8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_text_9780253042569_Bibliography__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_text_9780253042569_Bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_text_9780253042569_Bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_text_9780253042569_Index__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_text_9780253042569_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_text_9780253042569_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_text_9780253042569_Abouttheauthor__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_text_9780253042569_Abouttheauthor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_text_9780253042569_Abouttheauthor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_last__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_last__);
/*jshint esversion: 6 */




























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/text/9780253042569_Contents",
    "name": "text/9780253042569_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_text_9780253042569_Contents___default.a
  }, {
    "path": "/text/9780253042569_Halftitle_1",
    "name": "text/9780253042569_Halftitle_1",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_text_9780253042569_Halftitle_1___default.a
  }, {
    "path": "/text/9780253042569_Introduction",
    "name": "text/9780253042569_Introduction",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_text_9780253042569_Introduction___default.a
  }, {
    "path": "/text/9780253042569_Chapter_1",
    "name": "text/9780253042569_Chapter_1",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_text_9780253042569_Chapter_1___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_25__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elliot R. Wolfson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('P', [_vm._v("Elliot R. Wolfson is the Marsha and Jay Glazer Endowed Chair in Jewish Studies at the University of California, Santa Barbara. He is author of many books including, most recently, "), _c('I', [_vm._v("Giving Beyond the Gift: Apophasis and Overcoming Theomania")]), _vm._v(" and "), _c('I', [_vm._v("The Duplicity of Philosophy's Shadow: Heidegger, Nazism, and the Jewish Other")]), _vm._v(".")], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TydSuG/tc-custom/9780253042583.jpg?1721451108686",
      "alt": "This image is the cover for the book Heidegger and Kabbalah, New Jewish Philosophy and Thought"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heidegger and Kabbalah, New Jewish Philosophy and Thought\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p'), _c('p', [_vm._v("While many scholars have noted Martin Heidegger's indebtedness to Christian mystical sources, as well as his affinity with Taoism and Buddhism, Elliot R. Wolfson expands connections between Heidegger's thought and kabbalistic material. By arguing that the Jewish esoteric tradition impacted Heidegger, Wolfson presents an alternative way of understanding the history of Western philosophy. Wolfson's comparison between Heidegger and kabbalah sheds light on key concepts such as hermeneutics, temporality, language, and being and nothingness, while yielding surprising reflections on their common philosophical ground. Given Heidegger's involvement with National Socialism and his use of antisemitic language, these innovative readings are all the more remarkable for their juxtaposition of incongruent fields of discourse. Wolfson's entanglement with Heidegger and kabbalah not only enhances understandings of both but, more profoundly, serves as an ethical corrective to their respective ethnocentrism and essentialism. Wolfson masterfully illustrates the redemptive capacity of thought to illuminate common ground in seemingly disparate philosophical traditions.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toctit"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('b', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253042569_Introduction"
    }
  }, [_vm._v("Introduction: Belonging Together of the Foreign")])]), _vm._v(" "), _c('div', {
    staticClass: "top2"
  }, [_c('p', {
    staticClass: "toc_1a",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253042569_Chapter_1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spb"
  }, [_vm._v("Hermeneutic Circularity: Tradition as Genuine Repetition of Futural Past")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1a",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042569_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spb"
  }, [_vm._v("Inceptual Thinking and Nonsystematic Atonality")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1a",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042569_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spb"
  }, [_vm._v("Heidegger’s Seyn/Nichts and Kabbalistic Ein Sof")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1a",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042569_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spb"
  }, [_vm._v("Ṣimṣum, Lichtung, and Bestowing Refusal")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1a",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042569_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spb"
  }, [_vm._v("Autogenesis, Nihilating Leap, and Otherness of the Not-Other")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1a",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042569_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spb"
  }, [_vm._v("Temporalizing and Granting Time-Space")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1a",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042569_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spb"
  }, [_vm._v("Disclosive Language: Poiēsis and Apophatic Occlusion of Occlusion")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1a",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253042569_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spb"
  }, [_vm._v("Ethnolinguistic Enrootedness and Invocation of Historical Destiny")])])]), _vm._v(" "), _c('div', {
    staticClass: "top2"
  }, [_c('p', {
    staticClass: "toc_1n1",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253042569_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1n1",
    attrs: {
      "id": "ind"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/text/9780253042569_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  })])])])])])])])])])])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Half Title"
    }
  }, [_c('figure', [_c('p', {
    staticClass: "halftitle"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_vm._v("Heidegger and Kabbalah"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  })])])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "h3a"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253042569_Contents#int"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "h40"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253042569_Contents#int"
    }
  }, [_c('i', [_vm._v("Belonging Together of the Foreign")])])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("The un-rest of questioning is not empty uncertainty; instead, it is the opening-up and guarding of that rest which, as the gathering together into what is most question-worthy (the event), awaits the simple intimacy of the call and endures the extreme wrath of the abandonment by being.")]), _vm._v(" "), _c('p', {
    staticClass: "epi1a"
  }, [_vm._v("Heidegger, "), _c('i', [_vm._v("Contributions to Philosophy (Of the Event)")])]), _vm._v(" "), _c('p', {
    staticClass: "epia"
  }, [_vm._v("To flee into the identical is not dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "epi0"
  }, [_vm._v("To venture into discordance in order to say the Same is the danger.")]), _vm._v(" "), _c('p', {
    staticClass: "epi1"
  }, [_vm._v("Heidegger, “Letter on ‘Humanism’”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Martin Heidegger is incontestably considered by intellectual foe and friend alike as one of the most influential philosophers of the twentieth century and perhaps one of the greatest thinkers of all time, and this in spite of the controversy surrounding his allegiance to National Socialism and despite, even more damaging, his inability to acknowledge his mistakes publicly and to show remorse or compassion for the victims of the extermination camps."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_1",
      "id": "intfn1"
    }
  }, [_vm._v("1")])]), _vm._v(" I have explored the topic of Heidegger’s flirtation with the right-wing politics of Nazism in a separate monograph."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_2",
      "id": "intfn2"
    }
  }, [_vm._v("2")])]), _vm._v(" I will not repeat my arguments here, but what is crucial to note is that regardless of how one decides on the relationship between the political and the philosophical, the gift of Heideggerian thought has been enormous, and so, too, the debt of those seized by the reverberations—at times haunting—of his voice, and this includes the impressive aggregate of Jewish students who flocked to the feet of the master or the “philosopher-king,” as he was known. And so it is with my own philosophical reflections on Jewish mysticism. For several decades, I have availed myself of certain themes in Heidegger’s œuvre to elucidate the phenomenological aspects of kabbalistic esotericism and hermeneutics. In this book, I will expand my earlier insights and think more deeply about the juxtaposition of Heidegger and kabbalah."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_3",
      "id": "intfn3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Heidegger and Judaism: Review of Previous Scholarship")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To contextualize my approach, it would be beneficial to mention some previous analyses that impinge upon this subject. In her provocative study, "), _c('i', [_vm._v("La Dette impensée: Heidegger et l’héritage hébraïque")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_4",
      "id": "intfn4"
    }
  }, [_vm._v("4")])]), _vm._v(" Marlène Zarader explored the manner in which the Hebraic heritage influenced Heidegger’s thought, principally in his appropriation of biblical faith through the medium of Christianity, which, together with Greek thought, comprise the foundations of occidental culture. The very experience of being and language that "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Heidegger sought to retrieve from the pre-Socratic thinkers as an alternative to what was forgotten in the history of Western metaphysics can be traced to what has been more overtly expressed—“in letters black on white”—in Jewish sources."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_5",
      "id": "intfn5"
    }
  }, [_vm._v("5")])]), _vm._v(" And yet, as Zarader also contends, following Ricœur, Heidegger occludes the Hebraic component of his thought “to the point of leaving something like a "), _c('i', [_vm._v("blank")]), _vm._v(" space in his text.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_6",
      "id": "intfn6"
    }
  }, [_vm._v("6")])]), _vm._v(" Zarader thus concludes that Heidegger both “restored to Western thought the determinations central to the Hebraic universe” and “effaced it from thought and, more broadly, from the West itself.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_7",
      "id": "intfn7"
    }
  }, [_vm._v("7")])]), _vm._v(" Zarader’s own effort was to fill the blank space by making explicit the Hebraic dimension of Christianity that was obfuscated or perhaps consciously repressed by Heidegger with his alternate narrative of a "), _c('i', [_vm._v("Heilsgeschichte")]), _vm._v(" that revolves linguistically and historically about the poles of ancient Greece and modern Germany."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_8",
      "id": "intfn8"
    }
  }, [_vm._v("8")])]), _vm._v(" Just as Heidegger spoke of the oblivion of being ("), _c('i', [_vm._v("Seinsvergessenheit")]), _vm._v(") as the obliviousness to the difference between being and beings,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_9",
      "id": "intfn9"
    }
  }, [_vm._v("9")])]), _vm._v(" so Zarader identifies Judaism as what is left unthought at the heart of his thinking. In line with Heidegger’s hermeneutic, the more pronounced the concealment, the more profound the disclosure, the more resonant the silence, the more poignant the bearing witness. Particularly relevant to this study is the author’s comparison of Heidegger’s conception of nothingness and the domain of being’s withdrawal to kabbalistic speculation on "), _c('i', [_vm._v("ṣimṣum")]), _vm._v(", the contraction of infinity to create the vacuum within the plenum, the space wherein, paradoxically, what is ostensibly other than that which has no other can come to be."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_10",
      "id": "intfn10"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When asked in an interview with Dominique Janicaud to respond to Zarader’s thesis, Derrida concurred but argued even more forcefully that it was an act of violence on Heidegger’s part to disregard Jewish thought so thoroughly and deliberately, a display of disdain that can be explained only as part of an ideological-political agenda,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_11",
      "id": "intfn11"
    }
  }, [_vm._v("11")])]), _vm._v(" a position that curiously accords with Buber’s critique of Heidegger’s misrepresentation of the mission of the prophets of ancient Israel, or more expansively the Judeo-Christian tradition, which he contrasts with the prophetic essence of the poet as typified by Hölderlin."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_12",
      "id": "intfn12"
    }
  }, [_vm._v("12")])]), _vm._v(" Others, such as François Vézin, have drawn an explicit connection between Heidegger’s systematic, and apparently conscious, inattentiveness to Jewish philosophers and his apathy toward the millions of Jews brutally and senselessly murdered."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_13",
      "id": "intfn13"
    }
  }, [_vm._v("13")])]), _vm._v(" It is interesting that, in a similar vein, reading against Heidegger’s own explicit assertions, Jean-Luc Nancy surmised that his signature idea of "), _c('i', [_vm._v("Ereignis")]), _vm._v(" may have “nothing to do with a destinality engaged solely by the Greeks but everything to do with a different history, one that includes Roman, Judeo-Christian, and ‘modern’ events in a sense that Heidegger was perhaps never truly capable of apprehending.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_14",
      "id": "intfn14"
    }
  }, [_vm._v("14")])]), _vm._v(" My own inquiry will lend support to Nancy’s conjecture, albeit as it relates more specifically to the affinities between the Heideggerian event of beyng and the kabbalistic emanation of the infinite, a comparison that brings to light the metaontological critique of the ontotheology typically associated with the Jewish esoteric teaching. The validity of juxtaposing Heidegger’s "), _c('i', [_vm._v("Seinsdenken")]), _vm._v(" and the kabbalistic contemplation of infinity will be strengthened by attending to several other topics worthy of comparative analysis, to wit, the hermeneutical nature of the human experience of history and the contours of tradition, the conception of authentic time as a linear circle that instantiates the replication of difference, the simultaneous disclosure and concealment of the mystery, and the intricate triangulation of language, peoplehood, and land.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another work that should be mentioned is Johanna Junk’s "), _c('i', [_vm._v("Metapher und Sprachmagie, Heidegger und die Kabbala: Eine philosophische Untersuchung")]), _vm._v(". Even though this book is marred by the fact that the author does not seem to possess the philological skills requisite to read kabbalistic material in its primary languages, and thus her analyses are based on the evaluations culled from other scholars, Junk’s study yields some important insights and interpretive strategies that substantively enrich the discussion and illumine the fundamental question of the compatibility of Heidegger’s path and the esoteric tradition of the kabbalah."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_15",
      "id": "intfn15"
    }
  }, [_vm._v("15")])]), _vm._v(" Noteworthy as well are Richard Wolin’s "), _c('i', [_vm._v("Heidegger’s Children: Hannah Arendt, Karl Löwith, Hans Jonas, and Herbert Marcuse")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_16",
      "id": "intfn16"
    }
  }, [_vm._v("16")])]), _vm._v(" and Samuel Fleischacker’s edited collection "), _c('i', [_vm._v("Heidegger’s Jewish Followers: Essays on Hannah Arendt, Leo Strauss")]), _vm._v(", "), _c('i', [_vm._v("Hans Jonas, and Emmanuel Levinas")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_17",
      "id": "intfn17"
    }
  }, [_vm._v("17")])]), _vm._v(" These works are serious engagements with the complicated relationship that several leading twentieth-century "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("Jewish thinkers had to Heidegger, but the latter’s relationship to kabbalah or Jewish mysticism is not discussed at all in either book. Mention should also be made of Allen Scult’s "), _c('i', [_vm._v("Being Jewish/Reading Heidegger: An Ontological Encounter")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_18",
      "id": "intfn18"
    }
  }, [_vm._v("18")])]), _vm._v(" The author presents an innovative study that underscores the phenomenological resemblance of Judaism as a way of life, grounded in the interpretative relation to a sacred text, and Heidegger’s view of philosophical practice as a reading of the founding texts of Western philosophy. In like fashion, Michael Fagenblat has written that “Heidegger maintained, as does traditional Jewish thought, that thinking is saturated with interpretation and therefore conceived philosophy as an endless series of commentaries that forget, restore, and unfold an original truth, as does the Jewish tradition of commentary.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_19",
      "id": "intfn19"
    }
  }, [_vm._v("19")])]), _vm._v(" This comparison of Jewish commentarial practice with Heideggerian hermeneutics does not make any explicit reference to the kabbalistic material, but the inclusion of the latter would substantiate the thesis considerably. The same can be said for more recent attempts to draw positive analogies between Heidegger’s thinking and rabbinic thought by Elad Lapidot and Sergey Dolgopolski."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_20",
      "id": "intfn20"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is appropriate to recall as well a passing remark of Emil Fackenheim in "), _c('i', [_vm._v("Encounters between Judaism and Modern Philosophy: A Preface to Future Jewish Thought")]), _vm._v(". Fackenheim, an escapee from Nazi Germany, suggested that the power of the later Heidegger “to captivate the Jewish thinker” far exceeded the Heidegger of "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(". The rationale for this assertion is that Heidegger’s insistence on a shift from an original hearing to a derivative seeing demonstrated that he was “engaged in no less startling an enterprise than the Judaization of the entire history of Western philosophy…. At least from Plato to Nietzsche there has been a fateful yet inevitable falling away from an original "), _c('i', [_vm._v("Denken")]), _vm._v("-of-Being—fateful because it manifests a "), _c('i', [_vm._v("Seinsvergessenheit")]), _vm._v(" and inevitable because it manifests a "), _c('i', [_vm._v("Seinsverlassenheit")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_21",
      "id": "intfn21"
    }
  }, [_vm._v("21")])]), _vm._v(" Summarizing Heidegger’s later thought, Fackenheim remarks that the notion of truth as the unconcealedness of being “is accessible to an original ‘thinking,’ which is a ‘hearing’ rather than a ‘seeing.’” Drawing on the conventional portrayal of Judaism as privileging the auditory over the visual, Fackenheim concludes that “the later Heidegger Judaizes philosophy, and hence also the view that the Jewish thinker is justified in being attracted to his later thought.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_22",
      "id": "intfn22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One can challenge the accuracy of this stereotypical characterization of Judaism, but even more important, Fackenheim’s observation is based on the faulty conception that the ocular and auditory dimensions of the Heideggerian appropriative event can be separated definitively. The spuriousness of this claim is attested, for instance, in Heidegger’s statement about the nature of "), _c('i', [_vm._v("Ereignis")]), _vm._v(" as the saying that is the showing ("), _c('i', [_vm._v("die Sage ist Zeigen")]), _vm._v("), or its corollary, the showing of the saying ("), _c('i', [_vm._v("das Zeigen der Sage")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_23",
      "id": "intfn23"
    }
  }, [_vm._v("23")])]), _vm._v(" Inasmuch as the hearing is at the same time a coming to light, the listening itself must be construed as an act of seeing."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_24",
      "id": "intfn24"
    }
  }, [_vm._v("24")])]), _vm._v(" Elsewhere Heidegger points out that the transfer from the aural to the visible—as we see in the case of the term for brightness, "), _c('i', [_vm._v("Helle")]), _vm._v(", which derives from "), _c('i', [_vm._v("hallen")]), _vm._v(", to reverberate or to echo, a character of sound and not originally of sight—is indicative of an early power and wisdom of language."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_25",
      "id": "intfn25"
    }
  }, [_vm._v("25")])]), _vm._v(" Bracketing this criticism, it is remarkable that Fackenheim, a German Jew arrested by the Nazis during Kristallnacht (November 9–10, 1938), and briefly interned in the Sachsenhausen concentration camp, would have no compunction characterizing Heidegger’s alleged denunciation of ocularcentrism after the so-called turn ("), _c('i', [_vm._v("Kehre")]), _vm._v(") in the 1930s as the "), _c('i', [_vm._v("Judaization of the entire history of Western philosophy")]), _vm._v(". The astounding nature of this claim is augmented when we recall that in "), _c('i', [_vm._v("To Mend the World: Foundations of Post-Holocaust Thought")]), _vm._v(", Fackenheim, in a manner that is consonant with Buber,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_26",
      "id": "intfn26"
    }
  }, [_vm._v("26")])]), _vm._v(" is brutally critical of Heidegger’s endorsement of the Nazi regime impelled not by personal considerations but by the force of the philosophical path laid out in "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v("."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_27",
      "id": "intfn27"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Heidegger and Kabbalah: Being, Language, Time")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In this section, I will review three Heideggerian themes that have been central to my previous efforts to offer a cogent philosophical exposition of the Jewish mystical material: the depiction of truth as the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("unconcealedness of the concealment of concealment; the construal of language as the house of being within which all beings are disclosed in the nothingness of their being; and the understanding of the origin of time-space arising from an inceptual act that is, concomitantly, a constriction and an expansion, a withholding of the boundless ground that results in the self-extending delineation of boundary.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turning to the first topic, I have been struck by the way Heidegger’s conception of truth as the clearing ("), _c('i', [_vm._v("Lichtung")]), _vm._v(") for the self-concealing ("), _c('i', [_vm._v("Sichverbergen")]), _vm._v(") of beyng, the bringing to light, the lighting-up, of what remains enshrouded, well captures the paradox of secrecy and the meontological understanding of the infinite nonbeing at play in a plethora of kabbalistic sources."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_28",
      "id": "intfn28"
    }
  }, [_vm._v("28")])]), _vm._v(" The clearing within which beings are unconcealed is the concealment of those very beings; kabbalists would surely assent to the Heideggerian assessment that the nature of nature (φύσις) is such that every being we encounter “keeps to this curious opposition of presence ["), _c('i', [_vm._v("Anwesens")]), _vm._v("] in that it always withholds itself at the same time in a concealedness ["), _c('i', [_vm._v("Verborgenheit")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_29",
      "id": "intfn29"
    }
  }, [_vm._v("29")])]), _vm._v(" The concealment that occurs within the clearing is thus a form of dissembling ("), _c('i', [_vm._v("Verstellen")]), _vm._v(") whereby the being that appears “presents itself as other than it is” ("), _c('i', [_vm._v("es gibt sich anders, als es ist")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_30",
      "id": "intfn30"
    }
  }, [_vm._v("30")])]), _vm._v(" This insight into the concealment that conceals and dissembles itself leads Heidegger to the disquieting conclusion that the unconcealedness ("), _c('i', [_vm._v("Unverborgenheit")]), _vm._v(") is dominated by a denial that takes the form of a "), _c('i', [_vm._v("double concealment")]), _vm._v(" ("), _c('i', [_vm._v("zwiefache Verbergen")]), _vm._v("), the concealment of the concealment, such that truth, in its very essence, is un-truth ("), _c('i', [_vm._v("die Wahrheit ist in ihrem Wesen Un-wahrheit")]), _vm._v("), a proposition that is not intended to state that truth is necessarily falsehood ("), _c('i', [_vm._v("Falschheit")]), _vm._v("), but only that, in defiance of the principle of noncontradiction, it is always itself and its opposite; that is, truth is the disclosure regarding which it is essential that it remain concealed."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_31",
      "id": "intfn31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Much as Heidegger understood that untruth belongs inextricably to the comportment of truth, insofar as the latter is the unconcealment ("), _c('i', [_vm._v("alētheia")]), _vm._v(") of that which is hidden or forgotten ("), _c('i', [_vm._v("lēthe")]), _vm._v("), the mystery that is “the concealing of what is concealed” ("), _c('i', [_vm._v("die Verbergung des Verborgenen")]), _vm._v("), the nonessence ("), _c('i', [_vm._v("Unwesen")]), _vm._v(") that is essential to the essence of truth,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_32",
      "id": "intfn32"
    }
  }, [_vm._v("32")])]), _vm._v(" the self-withdrawing ("), _c('i', [_vm._v("Sichentziehende")]), _vm._v(")"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_33",
      "id": "intfn33"
    }
  }, [_vm._v("33")])]), _vm._v(" that initiates the nonshowing of beyng in the showing of every nonbeing,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_34",
      "id": "intfn34"
    }
  }, [_vm._v("34")])]), _vm._v(" so for the kabbalist, divulging the secret is a double negative that yields a positive, the concealment that conceals itself to be revealed. Heidegger accurately, even if unsuspectingly, expressed the guiding principle of kabbalistic esotericism, “A mystery is a mystery only when it does not even come out "), _c('i', [_vm._v("that")]), _vm._v(" mystery is at work.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_35",
      "id": "intfn35"
    }
  }, [_vm._v("35")])]), _vm._v(" Extrapolating the cosmological implications of this hermeneutic of the dissimulation of the dissimulation, Gershom Scholem wrote that the “secret signatures ("), _c('i', [_vm._v("rishumim")]), _vm._v(") that God had placed upon things are as much concealments of His revelation as revelation of His concealment.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_36",
      "id": "intfn36"
    }
  }, [_vm._v("36")])]), _vm._v(" Prima facie, Scholem’s approach is close to my own,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_37",
      "id": "intfn37"
    }
  }, [_vm._v("37")])]), _vm._v(" but there is a decisive difference: when Scholem writes that the concealment of the divine revelation is a revelation of the divine concealment, he has in mind something akin to Hegel’s dialectic,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_38",
      "id": "intfn38"
    }
  }, [_vm._v("38")])]), _vm._v(" which posits the sublation of antinomies such that there is a synthesis in which one thing becomes its opposite; my hypothesis, by contrast, is more consistent with Heidegger’s idea of the belonging together of opposites that remain opposite in their juxtaposition as opposed to the "), _c('i', [_vm._v("coincidentia oppositorum")]), _vm._v(" from which one may infer the identity of the identity of nonidentity and the nonidentity of identity. The kabbalistic intonation of the paradox strikes me as far more germane to understanding the Heideggerian notion of the unveiling ("), _c('i', [_vm._v("Entbergung")]), _vm._v(") of beyng than simply viewing the latter as a philosophical appropriation of the theological emphasis on the epiphany of the invisible God common to a presumed Judeo-Christian vocabulary."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_39",
      "id": "intfn39"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Offering a generalization based on the painstaking immersion in particular texts through many years, I am prepared to say that kabbalists extended the hermeneutic of secrecy to their understanding of the nonbeing of being. Thus, like Nicholas of Cusa and Friedrich Wilhelm Joseph Schelling, both of whom may have incorporated elements of kabbalistic theosophy, which, in turn, influenced Heidegger in an ancillary way,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_40",
      "id": "intfn40"
    }
  }, [_vm._v("40")])]), _vm._v(" kabbalists have staunchly maintained that all that exists is a manifestation of the light of the infinite, but every manifestation of that light perforce must be a concealment, since what "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("is innately hidden can be revealed only insofar as it endures as being hidden. Perhaps most conspicuously, the conceptual footing of the myth of "), _c('i', [_vm._v("ṣimṣum")]), _vm._v(", the primordial act of divine kenosis, an idea whose roots go back to the thirteenth century but which is expressed more explicitly in the sixteenth century, is the paradox that concealment is the cause of disclosure and disclosure the cause of concealment."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_41",
      "id": "intfn41"
    }
  }, [_vm._v("41")])]), _vm._v(" Translated phenomenologically, every appearance of the infinite is a nonappearance—the nonapparent cannot appear except as inapparent—whence it follows that the infinite is present in the world to the degree that it is absent from the world; indeed, the infinite light is present precisely as that which is absent, not as a presence presently absent nor as an absence absently present, but as the absent presence that continuously withdraws in the spectacle of its present absence.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kabbalists and Heidegger share the hermeneutical conviction, which is based on the aforementioned cosmological paradox, that there is no naked truth but only truth rendered visible via the cloak of invisibility. This is the import of Heidegger’s insistence, mentioned above, on the identification of saying and showing; that is, with respect to the appearing of beyng implied in the "), _c('i', [_vm._v("es gibt")]), _vm._v(", all that we are capable of speaking is seen through the mantle of the name by which the being is denuded."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_42",
      "id": "intfn42"
    }
  }, [_vm._v("42")])]), _vm._v(" This, I submit, is also the phenomenological basis of Heidegger’s contention that beyng is expressed through but is irreducible to the discrete beings of the world, or to be even more precise, the former is disclosed in the latter to the extent that it is occluded by the latter. Thus, like a mantra, Heidegger proclaims in his essay “Der Spruch des Anaximander” (1946), “By revealing itself in the being, being withdraws ["), _c('i', [_vm._v("Das Sein entzieht sich, indem es sich in das Seiende entbirgt")]), _vm._v("]…. By bringing the being’s unconcealment, it founds, for the first time, the concealment of being.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_43",
      "id": "intfn43"
    }
  }, [_vm._v("43")])]), _vm._v(" The same dynamic can be attributed to the kabbalistic understanding of the infinite, and thus we can say of both "), _c('i', [_vm._v("Seyn")]), _vm._v(" and "), _c('i', [_vm._v("Ein Sof")]), _vm._v(" that they illumine—each from its distinctive vantagepoint—all that can be seen but are themselves never seen,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_44",
      "id": "intfn44"
    }
  }, [_vm._v("44")])]), _vm._v(" the luminescence that facilitates the appearance of all phenomena but itself does not appear phenomenologically."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_45",
      "id": "intfn45"
    }
  }, [_vm._v("45")])]), _vm._v(" As Heidegger put it in “Der Rückgang in dem Grund der Metaphysik,” the introduction he added to the fifth printing of the essay “Was ist Metaphysik?” in 1949, metaphysical thinking always represents beings only as beings and hence being as being ("), _c('i', [_vm._v("das Sein als Sein")]), _vm._v("), which in its essence is the truth as the unconcealing that is the source of the light in which beings appear, remains veiled and unthought."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_46",
      "id": "intfn46"
    }
  }, [_vm._v("46")])]), _vm._v(" The identification of being as the light that brings all beings into appearance but that does not itself appear calls to mind Heidegger’s two translations of the Heraclitean fragment (preserved by Hippolytus) τὰ δὲ πάντα οἰακίζει κεραυνόϛ, “The thunderbolt pilots all things,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_47",
      "id": "intfn47"
    }
  }, [_vm._v("47")])]), _vm._v(" as "), _c('i', [_vm._v("Das Alles jedoch (des Anwesenden) steuert (ins Anwesen) der Blitz")]), _vm._v(", “But lighting steers (in presencing) the totality (of what is present),”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_48",
      "id": "intfn48"
    }
  }, [_vm._v("48")])]), _vm._v(" or as "), _c('i', [_vm._v("Das Seiende im Ganzen aber steuert der Blitz")]), _vm._v(", “But the lightning steers beings as a whole.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_49",
      "id": "intfn49"
    }
  }, [_vm._v("49")])]), _vm._v(" Heidegger retrieves from Heraclitus the idea of being as the flash of lightning that summons the presencing of all things present while itself remaining concealed from being present, an idea connected as well to Heraclitus’s maxim that nature loves to hide, φύσις κρύπτεσθαι φιλεῖ,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_50",
      "id": "intfn50"
    }
  }, [_vm._v("50")])]), _vm._v(" which conveys the interplay of unhiddenness and hiddenness, that “the essence of being is such that, as a self-revealing, being reveals itself in a way such that a self-concealing—that means, a withdrawal—belongs to this revealing…. As a proffering that clears and lights, being is simultaneously withdrawal.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_51",
      "id": "intfn51"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The new thinking about beyng, as opposed to beings, requires one to push beyond the metaphysical binary of presence and absence. Jean Beaufret succinctly expressed the point: “For if presence and absence are qualities which constantly alternate in beings, this can happen only under the immutable horizon of being. Being itself is never a being, but rather the measure according to which all beings can enter into presence or can pull back from presence and disappear in absence. Far more original than the presence-absence of beings is the omnipresence of being, which, losing nothing in its participation in such a vicissitude, encompasses beings without losing itself in that vicissitude.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_52",
      "id": "intfn52"
    }
  }, [_vm._v("52")])]), _vm._v(" The same can be said about the infinite for the kabbalists, the light of being that manifests all beings but is itself unmanifest. The unconcealment of beings is what secures the concealment of being. Even the eschatological promise "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("that one may elicit from kabbalistic sources, to gaze upon the light without the encumbrance of any garment, amounts to realizing that it is not possible to behold the light but through the garment that is light. The goal on the mystical path may be described as the removal of all barriers to vision—to polish the heart like a translucent mirror, as Sufis are wont to say—but the greatest of barriers is to think that all barriers may be removed."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_53",
      "id": "intfn53"
    }
  }, [_vm._v("53")])]), _vm._v(" In the end, nothing is revealed to be the truth of which nothing is revealed but the possibility of something to be revealed."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_54",
      "id": "intfn54"
    }
  }, [_vm._v("54")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With respect to this matter, the state of contemplation cultivated by the kabbalists may be profitably compared to Heidegger’s description of "), _c('i', [_vm._v("Besinnung")]), _vm._v(" as musing ("), _c('i', [_vm._v("Er-denken")]), _vm._v(") or heartfelt thinking ("), _c('i', [_vm._v("herzhaften Denken")]), _vm._v("),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_55",
      "id": "intfn55"
    }
  }, [_vm._v("55")])]), _vm._v(" that is, the contemplative reflection ("), _c('i', [_vm._v("besinnliche Nachdenken")]), _vm._v(") or meditative thinking ("), _c('i', [_vm._v("besinnliche Denken")]), _vm._v(") that occasions the release ("), _c('i', [_vm._v("Gelassenheit")]), _vm._v(") into what is worthy of interrogation with respect to beyng rather than a computational thinking ("), _c('i', [_vm._v("rechnende Denken")]), _vm._v(") that thinks beyng from the perspective of beings and thereby reinforces the metaphysical fallacy of obliterating the ontological difference."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_56",
      "id": "intfn56"
    }
  }, [_vm._v("56")])]), _vm._v(" Heidegger felicitously called this mode of contemplation “thoughtful configuration” ("), _c('i', [_vm._v("denkerische Gestaltung")]), _vm._v("),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_57",
      "id": "intfn57"
    }
  }, [_vm._v("57")])]), _vm._v(" an expression that can be applied propitiously to the poetic thinking traversed by kabbalists, which similarly presumes that “the essence of thinking is something other than thinking” ("), _c('i', [_vm._v("das Wesen des Denkens sei etwas anderes als Denken")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_58",
      "id": "intfn58"
    }
  }, [_vm._v("58")])]), _vm._v(" Embarking on this path of thinking that is other than thinking leads one to the discernment that the Heideggerian "), _c('i', [_vm._v("Seyn")]), _vm._v(" and the kabbalistic "), _c('i', [_vm._v("Ein Sof")]), _vm._v(" each denote a presence that is always a nonpresence, a presence that can be present only by not being present, the mystery manifest in the nonmanifestation of the mystery, the nothing about which one cannot speak in contrast to there being nothing about which to speak. In Derridean terms, the ultimate secret is the open secret, the secret that there is no secret,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_59",
      "id": "intfn59"
    }
  }, [_vm._v("59")])]), _vm._v(" and hence the watchword of the secret of secrecy ("), _c('i', [_vm._v("secret du secret")]), _vm._v(") is that “no more secrecy means more secrecy” ("), _c('i', [_vm._v("plus de secret, plus de secret")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_60",
      "id": "intfn60"
    }
  }, [_vm._v("60")])]), _vm._v(" By continuing in the footprints of Heidegger,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_61",
      "id": "intfn61"
    }
  }, [_vm._v("61")])]), _vm._v(" Derrida, perhaps unwittingly, came upon a central tenet of kabbalistic esotericism: the truth of the nonbeing of being cannot be unveiled but through the veil of truth, which is to say, the veil of untruth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second theme I have explored in previous work centers on the resonances of Heidegger’s complex view on the relation between language and beyng with an analogous pattern of thought that may be elicited from the kabbalah."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_62",
      "id": "intfn62"
    }
  }, [_vm._v("62")])]), _vm._v(" For Heidegger, especially after the "), _c('i', [_vm._v("Kehre")]), _vm._v(", language and beyng stand in the proximity of their remoteness and in the concordance of their discord."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_63",
      "id": "intfn63"
    }
  }, [_vm._v("63")])]), _vm._v(" As he famously expressed it, “in thinking being comes to language. Language is the house of being. In its home human beings dwell.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_64",
      "id": "intfn64"
    }
  }, [_vm._v("64")])]), _vm._v(" Rather than positing a direct correspondence between words and things "), _c('i', [_vm._v("à la")]), _vm._v(" classical representationalist epistemology undergirding the Aristotelian definition of the human as the "), _c('i', [_vm._v("animal rationale")]), _vm._v(", Heidegger insists that “language is the house of being in which the human being ek-sists by dwelling, in that he belongs to the truth of being, guarding it.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_65",
      "id": "intfn65"
    }
  }, [_vm._v("65")])]), _vm._v(" In the manner that the house provides the framework within which beings are both exposed and sheltered, language is understood as an opening through which beyng appears to the human in the occlusion of its appearance."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_66",
      "id": "intfn66"
    }
  }, [_vm._v("66")])]), _vm._v(" In every word spoken, therefore, we must heed the unspoken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On this score, we find confirmation of the previous point: the showing-saying of language discloses the mystery of beyng it continues to safeguard, concealing the concealment at the heart of the unconcealment, projecting and withholding, not successively but synchronously."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_67",
      "id": "intfn67"
    }
  }, [_vm._v("67")])]), _vm._v(" Kabbalists would acquiesce to Heidegger’s allegation, “That which shows itself and at the same time withdraws is the essential trait of what we call the mystery ["), _c('i', [_vm._v("Was auf solche Weise sich zeigt und zugleich sich entzieht, ist der Grundzug dessen, was wir das Geheimnis nennen")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_68",
      "id": "intfn68"
    }
  }, [_vm._v("68")])]), _vm._v(" In similar fashion, Heidegger describes the "), _c('i', [_vm._v("unheimlich")]), _vm._v("—the uncanny, which is the counterpoint to "), _c('i', [_vm._v("Geheimnis")]), _vm._v(", the mystery—as “what looms forth in the essence of human beings and is that which stirs in all stirring and arousal: that which presences and at the same time absences ["), _c('i', [_vm._v("das Anwesende und zugleich Abwesende")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_69",
      "id": "intfn69"
    }
  }, [_vm._v("69")])]), _vm._v(" Just as the presence of being at home is experienced most acutely in the absence of not being at home, so the secret "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("necessitates the letting be—that is, the letting appear—of the “hidden essence of being” ("), _c('i', [_vm._v("das verborgene Wesen des Seins")]), _vm._v("),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_70",
      "id": "intfn70"
    }
  }, [_vm._v("70")])]), _vm._v(" which is concurrently present and absent, present as that which is absent and absent as that which is present. The mystery, therefore, is not a thing, not even a no-thing, but the “open in-between” ("), _c('i', [_vm._v("offene Zwischen")]), _vm._v(") that “is the being-there ["), _c('i', [_vm._v("Da-sein")]), _vm._v("]… of the ecstatic region of the disclosure and concealment of being.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_71",
      "id": "intfn71"
    }
  }, [_vm._v("71")])]), _vm._v(" The open enclosure—the refusal that is the conferral—is the absolute appearance wherein nothing appears, the privation of the privation of privation, the lack of image that surpasses in its ontic deficiency even the image of lack. Metaontologically, presence is not the absence of absence nor is absence the absence of presence; presencing rather is the absencing of the absencing of presencing. Following this line of thinking, we might say that the mystery of language is the self-withdrawing bestowal of the self-bestowing withdrawal of the nothing—the kabbalistic "), _c('i', [_vm._v("Ein Sof")]), _vm._v(" and the Heideggerian "), _c('i', [_vm._v("Seyn")]), _vm._v("—which denotes not a nonbeing, the negation of something positive, but the nullity or emptiness that is the origin of all that comes to be in the intricate interweave of beings that make up the fabric of the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heidegger insists that Dasein is uniquely endowed with the language that unveils the veil of beyng. However, the way that language and beyng belong together in this unveiling of the veiling is veiled, not because the matter is presently concealed and eventually will be revealed, but, in a more enduring sense, because not-showing is intrinsic to the showing that is the saying of the unsaying. With this we arrive at an aspect of Heidegger’s thinking that resonates deeply with the paradox of esotericism at play in kabbalistic theosophy: every act of revealing is a concealing, for the truth that is inherently a secret cannot be revealed unless it is concealed. Simply put, uncovering is always a cover-up. In Heidegger’s own words, “Retaining belongs to concealment ["), _c('i', [_vm._v("Das Behalten gehört in die Verborgenheit")]), _vm._v("]. The mystery [of being] is concealment, which is [at the same time] unconcealing itself as such ["), _c('i', [_vm._v("Das Geheimnis ist die sich entbergende Verborgenheit als solche")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_72",
      "id": "intfn72"
    }
  }, [_vm._v("72")])]), _vm._v(" The kabbalists similarly view the performativity of language as revealing and concealing, not sequentially but concurrently; that is, language has the capacity to reveal the nature of being to the extent that the nature of being it reveals is concealed. For the kabbalists, like Heidegger, the unconcealment is not a disrobing of truth but the unveiling of the veil. “All revealing,” writes Heidegger in a decidedly kabbalistic tone, “belongs within a harboring and a concealing. But that which frees—the mystery—is concealed and always concealing itself…. Freedom is that which conceals in a way that opens to light, in whose clearing shimmers the veil that hides the essential occurrence of all truth and lets the veil appear as what veils.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_73",
      "id": "intfn73"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('i', [_vm._v("To let the veil appear as what veils")]), _vm._v("—this corroborates the point made above concerning the eschatological goal of the mystical way: lifting the veil, ostensibly to see the face laid bare, amounts to discerning that there is no way to see the face but through the veil of the face. Hence, the final veil to lift is the veil that one can see without a veil."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_74",
      "id": "intfn74"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heidegger’s poeticized thinking, as it is enunciated in relation to Greek and to German—a belonging together that connects but also keeps separate thought and poetry—finds a close parallel in the kabbalistic allocation of ontological significance to Hebrew."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_75",
      "id": "intfn75"
    }
  }, [_vm._v("75")])]), _vm._v(" From the vantage point of the kabbalists, unfailingly and uniformly upheld through the generations, Hebrew is the matrix language and hence it is accorded the status of being most conducive to unmasking the masking of the unmasking, to disclose the secret of the concealing of what is concealed in ascribing a name to the nameless. In addition, the kabbalistic focus on the connection between the holiness of Hebrew, the godliness of the Jewish people, and the sanctity of the land of Israel presents another intriguing analogy to Heidegger’s commitment to the nexus between homeland, peoplehood, and language in the case of the Germans. Far from avoiding the difficult political questions that surround this indissoluble link between place, nationality, and speech, in the final chapter, I will show that kabbalistic sources are susceptible to the reproach that has been leveled against Heidegger for what he himself called the folkish thinking ("), _c('i', [_vm._v("völkische Denken")]), _vm._v("),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_76",
      "id": "intfn76"
    }
  }, [_vm._v("76")])]), _vm._v(" which mandates the ethnolinguistic enrootedness and invocation of historical destiny for a particular people to the exclusion of others. The similarity is all the more remarkable in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("light of the fact that Heidegger’s privileging of Greek and German as the axes about which the history of beyng turns—the first beginning inaugurated by the Greeks and the other beginning entrusted to the Germans—not only marginalizes but demonizes the Jews as the metaphysical enemy excluded from that history."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_77",
      "id": "intfn77"
    }
  }, [_vm._v("77")])]), _vm._v(" But more than exclusion, the connection forged by Heidegger between the Jewish question ("), _c('i', [_vm._v("Judenfrage")]), _vm._v(") and the question of being ("), _c('i', [_vm._v("Seinsfrage")]), _vm._v(") confers on the Jew—or, more specifically, on "), _c('i', [_vm._v("Weltjudentum")]), _vm._v("—a central part in the philosophical transgression par excellence, the forgetfulness of being: “The question of the role of "), _c('i', [_vm._v("world-Judaism")]), _vm._v(" is not a racial question, but a metaphysical one, a question that concerns the kind of human existence which in an "), _c('i', [_vm._v("utterly unrestrained")]), _vm._v(" way can undertake as a world-historical ‘task’ the uprooting of all beings from being.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_78",
      "id": "intfn78"
    }
  }, [_vm._v("78")])]), _vm._v(" Apparently, Heidegger did not think the Jew was capable of realizing the “innermost structure” of the "), _c('i', [_vm._v("metaphysics of Dasein")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_79",
      "id": "intfn79"
    }
  }, [_vm._v("79")])]), _vm._v(" which enables the expansion into the "), _c('i', [_vm._v("metapolitics “of” the historical people")]), _vm._v(", that is, the task of belonging to the "), _c('i', [_vm._v("Volk")]), _vm._v(" determined not racially or biologically but by an essentially collective and historical destiny that is metapolitical."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_80",
      "id": "intfn80"
    }
  }, [_vm._v("80")])]), _vm._v(" As Donatella di Cesare has aptly put it, “Heidegger’s apocalyptic vision sees the Jew as the figure of an end that obsessively repeats itself, preventing the German people from reaching the ‘other beginning,’ that is, a new dawn of the West…. The "), _c('i', [_vm._v("metaphysics of the Jew")]), _vm._v(" gives rise to "), _c('i', [_vm._v("the metaphysical Jew")]), _vm._v(", an abstract figure to which the qualities that supposedly pertain to the ‘idea’ of the Jew, the fantastic model of the figural Jew, are obscurely transferred…. The "), _c('i', [_vm._v("metaphysics of the Jew")]), _vm._v(" thus produces a "), _c('i', [_vm._v("metaphysical Jew")]), _vm._v(", the idea of the Jew defined "), _c('i', [_vm._v("metaphysically")]), _vm._v(" on the basis of the secular oppositions that relegate the Jew to inauthentic appearance, that reduce him to a soulless abstraction, to a spectral invisibility, and eventually to nothingness.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_81",
      "id": "intfn81"
    }
  }, [_vm._v("81")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The third theme in Heidegger that I have invoked as a prism through which to examine kabbalistic texts is the idea of time."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_82",
      "id": "intfn82"
    }
  }, [_vm._v("82")])]), _vm._v(" In modes of discourse beholden explicitly to Schelling, and by implication to the theosophical gnosis espoused by kabbalists, Heidegger depicts the "), _c('i', [_vm._v("Abgrund")]), _vm._v(" as the “primary clearing,” or the nameless abyss, the groundlessness that grounds its ground in the holding sway of its grounding, that is, the ungrounding of the nonground, the spot or interval prior to the partition of time and space into the differentiated representations that mark the signposts of humankind’s historical destination. Heidegger’s understanding of the origin of time-space within the revealing-concealing of the "), _c('i', [_vm._v("Abgrund")]), _vm._v(", which constitutes the essence of truth, is indebted to Schelling’s rendering of time as the space of the "), _c('i', [_vm._v("Ungrund")]), _vm._v(", the infinite within which oppositions are preserved in the indifference of their identity. The terminology of Schelling is appropriated from the mystical theosophy of Jacob Böhme,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_83",
      "id": "intfn83"
    }
  }, [_vm._v("83")])]), _vm._v(" which is ideationally, if not textually, related, in turn, to the "), _c('i', [_vm._v("Abgrund")]), _vm._v(" of Eckhart"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_84",
      "id": "intfn84"
    }
  }, [_vm._v("84")])]), _vm._v("—an intellectual trajectory that Heidegger noted with regard to the paradoxical notion of God becoming the ground of the emergence from himself to himself of that which is not himself"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_85",
      "id": "intfn85"
    }
  }, [_vm._v("85")])]), _vm._v("—but also may reflect kabbalistic speculation on "), _c('i', [_vm._v("Ein Sof")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_86",
      "id": "intfn86"
    }
  }, [_vm._v("86")])]), _vm._v(" as is made explicit in the thought of Friedrich Christoph Oetinger."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_87",
      "id": "intfn87"
    }
  }, [_vm._v("87")])]), _vm._v(" Previous scholarship has documented the possible influence of kabbalistic motifs on Schelling and the probable channels of influence, to wit, Latin translations of zoharic and Lurianic texts published in Christian Knorr von Rosenroth’s "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v(";"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_88",
      "id": "intfn88"
    }
  }, [_vm._v("88")])]), _vm._v(" original treatises of Christian kabbalah by Pico della Mirandola, Johannes Reuchlin, Guillaume Postel, Egidio da Viterbo, Francesco Giorgi, and Paulus Ricius, to name a few of the better-known examples;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_89",
      "id": "intfn89"
    }
  }, [_vm._v("89")])]), _vm._v(" the writings of European philosophers, particularly in their interpretation of Spinoza spearheaded by Friedrich Heinrich Jacobi and Johann Georg Wachter, as well as the Cambridge Platonist school of Henry More and his disciple Ann Conway,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_90",
      "id": "intfn90"
    }
  }, [_vm._v("90")])]), _vm._v(" the thought of Gottfried Wilhelm Leibniz, Gotthold Ephraim Lessing, and Johann Georg Hamann; and the works of hermetists, alchemists, and theosophists influenced by Jewish esotericism and the occult, such as Cornelius Agrippa von Nettesheim, Paracelsus, Athanasius Kircher, Böhme, Franciscus Mercurius van Helmont, Oetinger, and Franz von Baader."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_91",
      "id": "intfn91"
    }
  }, [_vm._v("91")])]), _vm._v(" As Habermas succinctly expressed the matter, “It remains astonishing how productively central motifs of the philosophy of German Idealism shaped so essentially by Protestantism can be developed in terms "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("of the experience of the Jewish tradition. Because the legacy of the Kabballah already flowed into and was absorbed by Idealism, its light seems to refract all the more richly in the spectrum of a spirit in which something of the spirit of Jewish mysticism lives on, in however hidden a way.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_92",
      "id": "intfn92"
    }
  }, [_vm._v("92")])]), _vm._v(" It is feasible to extend this argument to Heidegger and to assume an incidental influence of Jewish theosophical speculation on his path of inceptual thinking/enowning, an inspiration that remained unspoken and unthought. At the very least, the similarities are striking and call for interpretation.")])]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Belonging Together and the Correlation of Sameness through Difference")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This monograph, to the best of my knowledge, presents the first serious attempt to lay out the comparison of the Heideggerian and kabbalistic corpora on the basis of textual-philological criteria. As I already noted, it may very well be that Heidegger became aware indirectly of kabbalistic motifs and symbols through the work of Schelling."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_93",
      "id": "intfn93"
    }
  }, [_vm._v("93")])]), _vm._v(" With regard to the more general influence of mystical theosophy on Heidegger, which may independently exhibit a symbolic kinship with the kabbalah, the likely vehicles of transmission would have been the Latin and German writings of Eckhart"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_94",
      "id": "intfn94"
    }
  }, [_vm._v("94")])]), _vm._v(" and the theosophical compositions of Böhme."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_95",
      "id": "intfn95"
    }
  }, [_vm._v("95")])]), _vm._v(" The impact of these thinkers on Heidegger has been duly noted, but no one has paid attention to how the kabbalistic resonances in their works may have inadvertently imprinted Heidegger’s thought. An investigation of this sort would certainly contribute to unearthing new facets and dimensions of European intellectual history from the Middle Ages to modernity and into contemporary postmodernism. At various pivotal junctures in the ensuing chapters, I will argue that certain kabbalistic ideas made their way into Heidegger’s thought through secondary conduits. The argument in this book primarily, however, assumes a different form. It is not influence that is the focal point of my concern—I am sympathetic to Heidegger’s denigration of this kind of analysis"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_96",
      "id": "intfn96"
    }
  }, [_vm._v("96")])]), _vm._v("—but rather the constellation of themes underlying the respective viewpoints of Heidegger and the kabbalists, a constellation that demonstrates the disarming correlation—as opposed to dialectical coincidence—of sameness through difference, that is, the identity of the nonidentical in the preservation of the nonidentity of the identical.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without denying the cultural and existential disparities too obvious to warrant specification, it is justifiable nonetheless to bridge the two, to ponder the kabbalah in light of Heideggerian poetic thinking, and the later in light of the former, on three accounts. First, as I noted above, historical connections between Heidegger and kabbalah—through intermediaries like Böhme and Schelling—cannot be ruled out unequivocally. Second, Heidegger’s relation to gnostic, mystical, and esoteric currents in Western Christian thought,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_97",
      "id": "intfn97"
    }
  }, [_vm._v("97")])]), _vm._v(" including principally Meister Eckhart"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_98",
      "id": "intfn98"
    }
  }, [_vm._v("98")])]), _vm._v(" and Angelus Silesius,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_99",
      "id": "intfn99"
    }
  }, [_vm._v("99")])]), _vm._v(" suggest the possibility that he may have been enamored with ideas from these sources that have strong parallels in the Jewish material. Third, and most important, leaving aside the historiographical question of influence, the comparative analysis is justified methodologically by conceptual affinities. The path of Heidegger’s later thought turns in a paradoxical manner—predicated, as it is, on the poetological heeding of the unspoken in what is spoken—that is particularly appropriate for the study of the apophatic dimension of the kabbalah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The predictable anachronistic charge of anachronism against this approach is readily dismissible as the philological insistence that a text be studied in a diachronically modulated historical context, though valid up to a point, need not be accorded hegemony in the hermeneutical task of constructing meaning. Availing ourselves of the Heideggerian distinction, the analysis in this book may be considered historical as opposed to historiological. To avoid potential misunderstanding, let me be clear that I am not advocating an interpretative method that discards philological competence on the specious grounds that all readings are equally tenable, an erroneous and self-contradictory view that lamentably has gained great currency in the marketplace of ideas. It is fitting to recall the acerbic observation of Nietzsche, “He who wants to mediate between two resolute thinkers shows that he is mediocre: he has no eye for what is unique; seeing things as similar and making things the same is the sign of weak "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("eyes.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_100",
      "id": "intfn100"
    }
  }, [_vm._v("100")])]), _vm._v(" Lest I be accused of mediocrity and feeble vision, I will state clearly and unambiguously that I have no intention of equating Heidegger and kabbalists on the basis of superficial comparisons that ignore the specificity of the respective historical, social, and cultural environments that informed each body of thinking. On the contrary, I embrace the discipline of philology as the means that is necessary for both the historicist situating of a text in its literary milieu and the deconstructionist deciphering of the textual sense, a venture that doubtlessly would demarcate the substantial differences even as it points to considerable correspondences. Beyond that criterion, however, the meaning one imparts to or elicits from a text should not be corroborated solely on the basis of genealogy or chronology. As Heidegger himself in one place expressed the matter, “It is possible, for example, to ascertain historically down to the last detail what Leibniz said about the Being of beings, and yet not to understand in the least what Leibniz thought when he defined the Being of beings from the perspective of the monad, and defined the monad as the unity of "), _c('i', [_vm._v("perceptio")]), _vm._v(" and "), _c('i', [_vm._v("appetitus")]), _vm._v(", as the oneness of perception and appetite.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_101",
      "id": "intfn101"
    }
  }, [_vm._v("101")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What Heidegger wished to convey here, and in countless other passages in his voluminous corpus, is that the philosophical understanding may be enhanced by—but it is certainly not confined to—the historical setting, at least if that setting is determined exclusively and predominantly by historiological assumptions. Granted that one’s hermeneutical orientation cannot be disentangled from presumptions about experience more generally and especially the elaborate role that memory plays in the psychosocial formation of identity and the eidetic confabulation of time. Criteria that respect these realities foster a broader and more diversified conception of historical enframing that epistemologically problematizes the commonplace belief that we can be certain that the future does not flow into the past through the present or that the past is not as much occasioned by the future as the future is by the past. In contrast to this more conventional standpoint, the temporal presupposition buttressing my hermeneutic embraces the prospect of a reversible timeline—what I have called the timeswerve of linear circularity—such that the present is as much the cause of the past as the past is the cause of the present; the past persists in the present as the trace that is reconfigured anew each moment through the agency of anamnesis. In sync with Benjamin and Heidegger, I view scholarly reconstruction as a type of "), _c('i', [_vm._v("futural remembering")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_102",
      "id": "intfn102"
    }
  }, [_vm._v("102")])]), _vm._v(" or a "), _c('i', [_vm._v("remembering expectation")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_103",
      "id": "intfn103"
    }
  }, [_vm._v("103")])]), _vm._v(" an act of recollecting that has the capacity to redeem the past, not by describing how the past really was but by imputing to it meaning that it never had except as the potential to become what it is not. The radical possibility of time as future—a perspective shared by kabbalists and Heidegger—implies that the past itself is only past insofar as it is the reiteration of what is always yet to come. The gesture of mindfulness most apposite to this temporal possibility is the leap ("), _c('i', [_vm._v("Sprung")]), _vm._v("), which “takes us abruptly to where everything is different, so different that it strikes us as strange,” as opposed to a “steady progress, where we move unawares from one thing to the next and everything remains alike.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_104",
      "id": "intfn104"
    }
  }, [_vm._v("104")])]), _vm._v(" The deeper attunement leads to the recognition that appropriation of one’s own requires the disappropriation of confronting the stranger. The encounter with the alien is what propels the journey home, the struggle with the unordinary instigates the return to the ordinary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Accepting this hermeneutic plausibility, it is reasonable to propose that Heidegger can provide a metadiscourse to excavate structures of thought latent in kabbalistic literature. His own words on the nature of “genuine comparing” in "), _c('i', [_vm._v("Einleitung in die Philosophie: Denken und Dichten")]), _vm._v("—a lecture course announced for the 1944–45 winter semester at the University of Freiburg but canceled after the second session as a result of the intrusion of the Nationalist Socialist Party in November 1944—are especially germane: “After all, comparing ["), _c('i', [_vm._v("Vergleichen")]), _vm._v("] is not supposed to result only in the determination of what is the same and different ["), _c('i', [_vm._v("die Feststellung von Gleichem und Verschiedenem")]), _vm._v("]; rather, with real comparison, we aspire to see what is different through the same and through the difference of the same ["), _c('i', [_vm._v("durch das Gleiche das Verschiedene und durch das Verschiedene des Gleichen")]), _vm._v("] to always see into the very essence of that which stands in comparison.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_105",
      "id": "intfn105"
    }
  }, [_vm._v("105")])]), _vm._v(" In this book, I will seek to achieve the vision of that which stands in comparison so that difference is disclosed through the discernment of the same "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("and the same through the discernment of difference. There is no appeal to a transcendental ideal for the nature of being or to a concept of experience that can be extricated from specific historical contexts, no postulating a metadiscourse or a monolingualism universally applicable to the multiple networks of sociolinguistic meaning. To paraphrase Derrida, even the speaking of one voice requires that there be several voices."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_106",
      "id": "intfn106"
    }
  }, [_vm._v("106")])]), _vm._v(" As Steven Burik has argued, the circumspect reader may elicit from Heidegger’s own work a model of comparative thinking that is not expressive of syncretism or monotonization that would level out all difference, but rather the forging of a bricolage of thought based on convergences marked by deep-seated divergence,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_107",
      "id": "intfn107"
    }
  }, [_vm._v("107")])]), _vm._v(" or what has been called more recently by Eric Nelson intercultural hermeneutics."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_108",
      "id": "intfn108"
    }
  }, [_vm._v("108")])]), _vm._v(" In Heidegger’s own formulation in the 1929–30 lecture course "), _c('i', [_vm._v("Die Grundbegriffe der Metaphysik: Welt—Endlichkeit—Einsamkeit")]), _vm._v(", the comparative examination is the most approachable and adaptable method “because in the process of making and grasping distinctions we can first really glimpse whatever is coincident ["), _c('i', [_vm._v("Übereinstimmende")]), _vm._v("] and the same ["), _c('i', [_vm._v("Selbige")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_109",
      "id": "intfn109"
    }
  }, [_vm._v("109")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here it is pertinent to recall that Heidegger was fond of distinguishing between “the identical” ("), _c('i', [_vm._v("das Gleiche")]), _vm._v(") and “the same” ("), _c('i', [_vm._v("das Selbe")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_110",
      "id": "intfn110"
    }
  }, [_vm._v("110")])]), _vm._v(" Thus, for example, in “Die Onto-Theo-Logische Verfassung der Metaphysik,” a lecture delivered on February 24, 1957, in Todtnauberg as part of a seminar on Hegel’s "), _c('i', [_vm._v("Wissenschaft der Logik")]), _vm._v(", he put it this way: “But the same is not the merely identical ["), _c('i', [_vm._v("Allein das Selbe ist nicht das Gleiche")]), _vm._v("]. In the merely identical, the difference disappears ["), _c('i', [_vm._v("verschwindet die Verschiedenheit")]), _vm._v("]. In the same the difference appears ["), _c('i', [_vm._v("erscheint die Verschiedenheit")]), _vm._v("], and appears all the more pressingly, the more resolutely thinking is concerned with the same matter in the same way ["), _c('i', [_vm._v("von derselben Sache auf dieselbe Weise")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_111",
      "id": "intfn111"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the trialogue between the guide, the scientist, and the scholar on the nature of thinking, written in 1944–45 but published posthumously in 1995 with the title "), _c('i', [_vm._v("Feldweg-Gespräche")]), _vm._v(", Heidegger expressed the difference between selfsameness ("), _c('i', [_vm._v("Selbigkeit")]), _vm._v(") and identicalness ("), _c('i', [_vm._v("Gleichheit")]), _vm._v(") by noting that the quality of belonging togetherness ("), _c('i', [_vm._v("Zusammengehörigkeit")]), _vm._v(") applies to the former and not to the latter. We can say of things that are identical that they “associate well with one another” ("), _c('i', [_vm._v("gleich und gleich gestellt sich gern")]), _vm._v("), but it is the identicalness that precludes the justification of thinking of them as belonging together ("), _c('i', [_vm._v("zusammenzugehören")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_112",
      "id": "intfn112"
    }
  }, [_vm._v("112")])]), _vm._v(" Things belong together, in other words, only because of the unbridgeable chasm that keeps them separate; sameness is discernible through difference, but not in a dialectical way that sublates the disjuncture of their conjunction."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_113",
      "id": "intfn113"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The centrality of this notion in Heidegger’s thought can be gauged from a passing comment in the address he gave in Messkirch on October 30, 1955, commemorating Conradin Kreutzer’s 175th birthday: “Meditative thinking demands of us that we engage ourselves with what at first sight does not go together at all ["), _c('i', [_vm._v("nicht zusammengeht")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_114",
      "id": "intfn114"
    }
  }, [_vm._v("114")])]), _vm._v(" Unlike computational thinking, which forces us to cling one-sidedly to ideas and to stitch them together homogeneously, the thinking that is meditational compels us to compound that which is heterogeneous. From a comment in "), _c('i', [_vm._v("Der Satz vom Grund")]), _vm._v(", the 1955–56 lecture course on the principle of reason delivered at the University of Freiburg, it can be further deduced that Heidegger considered the matter of sameness as the belonging together of difference an archaic truth of Western thought that perseveres as the unthought yet to be thought, which is to say, the essential thought that is prevented from ever becoming an object that is no longer underway to being thought:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("When we think the same—more precisely, sameness ["), _c('i', [_vm._v("Selbigkeit")]), _vm._v("]—as a belonging together in essence ["), _c('i', [_vm._v("Zusammengehörigkeit im Wesen")]), _vm._v("], then we keep in mind one of the earliest thoughts of Western thinking. Accordingly, “the same” does not mean the empty oneness of the one and the other, nor does it mean the oneness of something with itself. “The same” in the sense of oneness is the indifference ["), _c('i', [_vm._v("Gleichgültige")]), _vm._v("] of an empty, endlessly repeatable identity ["), _c('i', [_vm._v("Identität")]), _vm._v("]: A as A, B as B. Thought in the sense of what in essence belongs together, the same indeed bursts the indifference ["), _c('i', [_vm._v("Gleichgültigkeit")]), _vm._v("] of what belongs together, even more it holds them apart in the most radical dissimilarity ["), _c('i', [_vm._v("Ungleichheit")]), _vm._v("]; it holds them apart and yet does not allow them to fall away from each other and hence disintegrate. This holding-together "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("["), _c('i', [_vm._v("Zussamenhalten")]), _vm._v("] in keeping-apart ["), _c('i', [_vm._v("Auseinanderhalten")]), _vm._v("] is a trait of what we call the same and its sameness. This holding ["), _c('i', [_vm._v("Halten")]), _vm._v("] pertains to a “relation” ["), _c('i', [_vm._v("Verhältnis")]), _vm._v("] that still stands before thinking as what is to be thought."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_115",
      "id": "intfn115"
    }
  }, [_vm._v("115")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Utilizing the Schellingian locution, Heidegger thus delineates the same as the relational quality that bursts the indifference of what is conjoined, holding apart what is held together in radical dissimilarity as opposed to the oneness of the indifference of an endlessly repeatable identity. That radical dissimilarity is the underpinning of Heidegger’s repeated emphasis on strife, the contentious encounter of combatants bonded in their disunion. The discriminating ear will hear echoes of this Heideggerian theme in Schelling’s comment that the “outcome of opposing infinite activities” is a “"), _c('i', [_vm._v("static")]), _vm._v(" conflict,” which is equivalent to rest. The synthesis has “to be thought of, not as an annihilation of the two activities by each other, but rather as an equilibrium to which they reduce one another, and whose continuance is conditioned by the persistent rivalry between the two.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_116",
      "id": "intfn116"
    }
  }, [_vm._v("116")])]), _vm._v(" For Schelling, as for Heidegger, the shared task of philosophy and art is to resolve the infinite dichotomy of opposed activities, but the aesthetic production unveils the mechanism of resolution more completely, and especially the primordial intuition of the poetic gift."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_117",
      "id": "intfn117"
    }
  }, [_vm._v("117")])]), _vm._v(" The oscillation between opposites is resolved by the third activity of juxtaposition, the bringing of the two opposites into a “relative equilibrium,” but the latter is predicated on the constant recurrence of the contradiction between the opposites."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_118",
      "id": "intfn118"
    }
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following passage from “Der Satz der Identiät,” a lecture delivered at the University of Freiburg on June 27, 1957, sheds further light on this critical Heideggerian hermeneutic of sameness as the "), _c('i', [_vm._v("bringing-together by keeping apart")]), _vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("If we think of belonging "), _c('i', [_vm._v("together")]), _vm._v(" ["), _c('i', [_vm._v("Zusammen")]), _vm._v("gehören] in the customary way, the meaning of belonging is determined by the word together, that is, by its unity. In that case, “to belong” means as much as: to be assigned and placed into the order of a “together,” established in the unity of a manifold, combined into the unity of a system, mediated by the unifying center of an authoritative synthesis…. However, belonging together can also be thought of as "), _c('i', [_vm._v("belonging")]), _vm._v(" together [Zusammen"), _c('i', [_vm._v("gehören")]), _vm._v("]. This means: the “together” is now determined by the belonging."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_119",
      "id": "intfn119"
    }
  }, [_vm._v("119")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The belonging is no longer understood solely “in terms of the unity of the together,” but rather connotes “experiencing this together in terms of belonging.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_120",
      "id": "intfn120"
    }
  }, [_vm._v("120")])]), _vm._v(" Heidegger concludes, therefore, that “belonging "), _c('i', [_vm._v("together")]), _vm._v("” represents “belonging in terms of the unity of the together,” whereas “"), _c('i', [_vm._v("belonging")]), _vm._v(" together” entails “experiencing this together in terms of belonging.” Heidegger makes this distinction to explicate the coupling of thinking and being in the celebrated fragment of Parmenides, τὸ γὰρ αὐτὸ νοεῖν ἐστίν τε καὶ εἶναι, which he translates as "), _c('i', [_vm._v("Das Selbe nämlich ist Vernehmen (Denken) sowohl als auch Sein")]), _vm._v(", “For the same perceiving (thinking) as well as being.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_121",
      "id": "intfn121"
    }
  }, [_vm._v("121")])]), _vm._v(" The choice of the term "), _c('i', [_vm._v("das Selbe")]), _vm._v(" to render the Greek "), _c('i', [_vm._v("to auto")]), _vm._v(" is quite deliberate on the part of Heidegger. According to his interpretation, “before thinking arrived at the principle of identity,” Parmenides expressed the “enigma” ("), _c('i', [_vm._v("Rätsel")]), _vm._v(") of identity in his pronouncement, which is to be decoded as follows: “thinking and Being belong together in the Same and by virtue of this Same” ("), _c('i', [_vm._v("Denken und Sein gehören in das Selbe und aus diesem Selben zusammen")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_122",
      "id": "intfn122"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To understand the mystery of the identity of thinking and being—the originary mystery that embodies the “essence of thinking” sanctioned by the ancient Greek thinkers and eventually abandoned by the “technical interpretation of thinking” advanced by philosophy beginning with the Sophists and Plato"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_123",
      "id": "intfn123"
    }
  }, [_vm._v("123")])]), _vm._v("—one must probe the nature of the belonging together. Thinking and being belong together in such a way that the togetherness is delimited by the belonging rather than the belonging by the togetherness, and thus the difference of the sameness of that which belongs together is affirmed—they are the same by virtue of being different. In the “Brief über den ‘Humanismus,’” Heidegger put it simply, “thinking is the thinking of being. The genitive says something twofold. Thinking is of being inasmuch "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("as thinking, propriated ["), _c('i', [_vm._v("ereignet")]), _vm._v("] by being, belongs to being. At the same time thinking is of being insofar as thinking, belonging to being, listens to being. As the belonging to being that listens, thinking is what it is according to its essential origin.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_124",
      "id": "intfn124"
    }
  }, [_vm._v("124")])]), _vm._v(" Thinking belongs to being, but it does so as that which listens to being, which is to say, thinking and being belong together as what remain distinct, since the notion of listening—even listening to oneself—presupposes some degree of distance, a breach that can be bridged only by conjoining what remains apart.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following this insight, the comparison of kabbalah and Heidegger undertaken in this monograph will yield reflections on the same within which the differences shall become more blatant in light of common ground. Given Heidegger’s personal involvement with National Socialism, his disparaging use of some standard anti-Semitic tropes, his steadfast silence about the victims of Nazi brutality, and his concerted effort to avoid engaging any Jewish thinker or text, thereby banishing Jews from the history of philosophy,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_125",
      "id": "intfn125"
    }
  }, [_vm._v("125")])]), _vm._v(" it is all the more remarkable that the path of his thinking can be illumined by and can illumine the theosophical ruminations of the Jewish esoteric tradition."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_126",
      "id": "intfn126"
    }
  }, [_vm._v("126")])]), _vm._v(" Even more surprising is the fact that in both Heidegger and the kabbalists one can find a coupling of semantic essentialism and ethnocentric chauvinism, that is, the privileging of a particular language as disclosive of the truth of being and the consequent affirmation of a unique cultural destiny of a particular ethnos to be the custodian of that language in the land of its origin,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_127",
      "id": "intfn127"
    }
  }, [_vm._v("127")])]), _vm._v(" a position that harbors the potential for the disvaluing of others in racial terms."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_128",
      "id": "intfn128"
    }
  }, [_vm._v("128")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a published review of the first three volumes of Heidegger’s "), _c('i', [_vm._v("Schwarzen Heften")]), _vm._v(", spanning the years 1931–41, David Krell noted the obvious: the “repeated juxtaposition of Jews and National Socialism in Heidegger’s texts” is “repugnant and perverse.” Focusing on one passage in particular in which Heidegger writes that his “attack” on Descartes “has been exploited by both Jews and National Socialists with equal vigor,” Krell speculates that these words could have been written at the very moment when Kristallnacht occurred."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#intfn_129",
      "id": "intfn129"
    }
  }, [_vm._v("129")])]), _vm._v(" I certainly understand Krell’s point and he is to be given credit for pointing out the magnitude of Heidegger’s arrogance and insensitivity to pair the victims and the executor in this aberrant and tactless way. However, it is my hope that the juxtaposition of the ostensibly incongruent fields of discourse, the belonging together of what is foreign, Heidegger and kabbalah, will not only enhance our understanding of both, but, in an even more profound sense, will serve as an ethical corrective of their respective ethnocentrisms, thereby illustrating the redemptive capacity of thought to yield new configurations of the unthought colluding on disparate paths of contemplative thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "intfn_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn1"
    }
  }, [_vm._v("1")]), _vm._v(". For a summary of Heidegger’s affair with National Socialism, see de Beistegui, "), _c('i', [_vm._v("New Heidegger")]), _vm._v(", pp. 155–79, and Kisiel’s balanced treatment “Heidegger’s Apology: Biography as Philosophy and Ideology” in his "), _c('i', [_vm._v("Heidegger’s Way of Thought")]), _vm._v(", pp. 1–35.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "intfn_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn2"
    }
  }, [_vm._v("2")]), _vm._v(". Wolfson, "), _c('i', [_vm._v("Duplicity")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "intfn_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn3"
    }
  }, [_vm._v("3")]), _vm._v(". There are many dimensions of the kabbalistic worldview—to wit, the mystical rationales for rituals, meditational and magical practices, contemplative study, inspired exegesis, angelic visitations, revelatory visions, and other paranormal experiences—that have no counterpart in Heidegger. My focus is limited to certain phenomenological and hermeneutical issues. Although I consider these matters to be central to understanding the philosophical anchor of kabbalistic lore and praxis, I make no claim that these are to be accorded more value than the other dimensions that fall outside the purview of my analysis. Let me note, finally, that the method that undergirds this book is related to my larger assumption that the kabbalah is itself an integral part of the Western philosophical tradition. For an early formulation, see my justification for using Irigaray to analyze the gender construction in medieval kabbalistic texts in Wolfson, “Occultation,” p. 117n12. The criticism of my comment offered by Idel, "), _c('i', [_vm._v("Kabbalah and Eros")]), _vm._v(", p. 254n28, is based on a narrow geo-cultural understanding of the taxonomy Western philosophy. In response to Idel’s question, I would argue that it is perfectly legitimate, if not desirable, to explicate kabbalists from Persia and Yemen—the two countries mentioned by Idel—using Western philosophical concepts. First, this is "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("justified historically, since even the so-called “Eastern Kabbalists” were influenced, directly or indirectly, by medieval kabbalistic treatises—primarily composed in Provence and Spain—that were influenced by Aristotelian and Neoplatonic texts and ideas that originated in the Occident, even if they do not present the reader with a rigorous epistemology or a thoroughgoing ontology. But second, and more critically, I am committed to the supposition that one may engage kabbalistic sources philosophically and thereby elicit from them insights that will contribute to the ongoing interrogation of speculative questions that have perplexed thinkers through the centuries. This method is to be differentiated from the more historiographical orientation that puts its focus on the relationship of kabbalists to the philosophical literature of their day. As important as this line of research is, my concern is not with a chronological history of ideas, but with the more constructive attempt to delineate the interaction with philosophy that can be excavated from kabbalistic material. See Wolfson, “Retroactive Not Yet,” p. 17.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "intfn_4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn4"
    }
  }, [_vm._v("4")]), _vm._v(". Zarader, "), _c('i', [_vm._v("Unthought Debt")]), _vm._v(". The book has commanded several critical reviews, but see especially Bergo, “Marlène Zarader’s "), _c('i', [_vm._v("The Unthought Debt")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "intfn_5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn5"
    }
  }, [_vm._v("5")]), _vm._v(". Zarader, "), _c('i', [_vm._v("Unthought Debt")]), _vm._v(", p. 199.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "intfn_6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn6"
    }
  }, [_vm._v("6")]), _vm._v(". Ibid., p. 7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "intfn_7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn7"
    }
  }, [_vm._v("7")]), _vm._v(". Ibid., p. 185. On the overlap between themes in the Hebrew Bible and Heideggerian thought, see the more recent conjecture of Atkins, "), _c('i', [_vm._v("Ethical and Theological Appropriation")]), _vm._v(", pp. 162–66. In a letter to Shlomo Zemach, the translator of Heidegger’s "), _c('i', [_vm._v("Origins of the Work of Art")]), _vm._v(" into Hebrew in 1968, Heidegger explicitly acknowledged that he studied Hebrew “at school” and later as part of his “theological studies.” The letter is cited in Herskowitz, “Heidegger in Hebrew,” p. 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "intfn_8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn8"
    }
  }, [_vm._v("8")]), _vm._v(". Caputo, “People of God,” pp. 89–92. On p. 89, Caputo argues that Heidegger’s narrative of being is “structurally analogous in all of its main points to the biblical model, that is to the narratives of the Jews and their God in the Tanach, but in Heidegger’s narrative the Jews are "), _c('i', [_vm._v("totally silenced")]), _vm._v(", one might even say "), _c('i', [_vm._v("repressed")]), _vm._v("” (emphasis in original). Following Zarader’s lead, Caputo concludes that, in spite of Heidegger’s intentions, the Jews are the unthought debt or what was left unsaid in his thought, and this is related especially to the emphasis in his own rival history of salvation on the need to respond to the inaugural call of being assigned to one people as their unique historical destiny.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "intfn_9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn9"
    }
  }, [_vm._v("9")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Off the Beaten Track")]), _vm._v(", p. 275; "), _c('i', [_vm._v("Holzwege")]), _vm._v(", p. 364.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn10"
    }
  }, [_vm._v("10")]), _vm._v(". Zarader, "), _c('i', [_vm._v("Unthought Debt")]), _vm._v(", pp. 130–38. Building on Zarader’s conjecture, Goodman, “Give the Word,” pp. 155–60, argues that Celan’s attraction to Heidegger’s speculation on "), _c('i', [_vm._v("das Nichts")]), _vm._v(" may have been inspired by his interest in the kabbalistic notion of "), _c('i', [_vm._v("Ein Sof")]), _vm._v(", a curiosity that was stoked primarily by his reading some of Scholem’s scholarship. On the possible affinity between the kabbalistic idea of "), _c('i', [_vm._v("ṣimṣum")]), _vm._v(" and Heidegger’s description of nothingness as the vortex of zeroness, see Steiner, "), _c('i', [_vm._v("Grammars of Creation")]), _vm._v(", pp. 27–28. In the final stages of writing this book, Jeremy Brown brought to my attention the monograph by Meinvielle, "), _c('i', [_vm._v("De la Cábala")]), _vm._v(", which includes several chapters on the influence—or in the author’s precise language, the penetration ("), _c('i', [_vm._v("penetración")]), _vm._v(") and invasion ("), _c('i', [_vm._v("invasión")]), _vm._v(")—of kabbalah on the “Christian world” ("), _c('i', [_vm._v("mundo Cristiano")]), _vm._v("), including a brief section on “La línea cabalista de Heidegger,” pp. 320–22. The main thrust of Meinvielle’s argument is that Heidegger affirms the notion of being that is separate from beings but he rejects identifying it with God, the uncreated being ("), _c('i', [_vm._v("ens increatum")]), _vm._v(") or the supreme being ("), _c('i', [_vm._v("summum ens")]), _vm._v(") of Christian theology. Supplanting the scholastic metaphysics, Heidegger proposes a “gnostic” path that reintroduces the sacred as the impersonal and indeterminate being. Thus, following Löwith, "), _c('i', [_vm._v("Heidegger")]), _vm._v(", p. 156, Meinvielle concludes that Heidegger continued in the footsteps of Hegel, who renewed in a modern philosophical idiom the language of Valentinus. For other attempts to retrieve the gnostic elements of Heidegger’s thought, see below, n. 97.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn11"
    }
  }, [_vm._v("11")]), _vm._v(". Janicaud, "), _c('i', [_vm._v("Heidegger in France")]), _vm._v(", pp. 358–59. Although Heidegger had Jewish students and colleagues, he unfalteringly showed no interest in engaging Jewish thought on its own terms. One possible exception might have been Martin Buber. Heidegger did maintain a personal connection with Buber, but even in this case it is not entirely clear how much of the latter’s work, and especially on Jewish themes and figures, he read. Buber, of course, was more explicit about his engagement with Heidegger’s thought, his most vital intervention being "), _c('i', [_vm._v("Das Problem des Menschen")]), _vm._v(", based on lectures delivered in Jerusalem in 1938 and first published in Hebrew in 1942 and then in German in 1948, and "), _c('i', [_vm._v("Gottesfinsternis")]), _vm._v(": "), _c('i', [_vm._v("Betrachtungen zur Beziehung zwischen Religion und Philosophie")]), _vm._v(", published in 1953. On the relationship between the two thinkers, see Fackenheim, "), _c('i', [_vm._v("To Mend the World")]), _vm._v(", pp. 190–92; and in more detail, Mendes-Flohr, “Martin Buber and Martin Heidegger.” Mendes-Flohr writes that “Heidegger was apparently an avid reader of Buber’s "), _c('i', [_vm._v("Tales of the Hasidim")]), _vm._v(" ("), _c('i', [_vm._v("Erzählungen "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("des Chassidim")])]), _vm._v(") and other of his writings as well” (p. 5). In the accompanying n. 17, Mendes-Flohr refers to Pöggeler, "), _c('i', [_vm._v("Paths of Heidegger’s Life")]), _vm._v(", p. 67, to substantiate the assumption about “Heidegger’s early reading of Buber’s Hasidic tales.” Unfortunately, Pöggeler refers only to Heidegger’s making use of Buber’s "), _c('i', [_vm._v("Reden und Gleichnisse des Tschuang Tse")]), _vm._v(". Mendes-Flohr mentions this work as well and recounts the event in Heidelberg in October 1930 when Heidegger read from Buber’s edition of the parables of Chuang Tzu. In support of this claim, he cites Petzet, "), _c('i', [_vm._v("Encounters and Dialogues")]), _vm._v(", pp. 18–19. On the reception of and interaction with Taoism in Heidegger and Buber, see the analysis of Nelson, "), _c('i', [_vm._v("Chinese and Buddhist Philosophy")]), _vm._v(", pp. 109–29. On Buber’s meeting with Heidegger, see the correspondence between Fackenheim and Scholem in Scholem, "), _c('i', [_vm._v("Life in Letters")]), _vm._v(", pp. 475–76. The original German is published in Scholem, "), _c('i', [_vm._v("Briefe III")]), _vm._v(", pp. 194–95; Fackenheim’s letter is reproduced on p. 420, # 179, n. 1. For more evidence of the encounter between Buber and Heidegger, including photographs, see now Weissblei, “German Martin and the Jewish Mordechai.” The complex relationship between Heidegger and Buber centered on the question of ontology and human existence is explored by Munro, “On Being Oneself”; Gordon, "), _c('i', [_vm._v("Heidegger-Buber Controversy")]), _vm._v(". On Buber’s critique of Heidegger, see Gordon, op. cit., pp. 151–58 and Goldstein, “Buber’s Misunderstanding,” pp. 156–67; Novak, “Buber’s Critique”; Friedman, “Buber, Heschel, and Heidegger”; Urban, “Paradox of Realization,” pp. 175–77. On Buber and Heidegger, see also Herskowitz, “Heidegger as a Secularized Kierkegaard,” and Hadad, “Fruits of Forgetfulness.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn12"
    }
  }, [_vm._v("12")]), _vm._v(". Buber, "), _c('i', [_vm._v("Eclipse")]), _vm._v(", p. 73. The passage to which Buber refers is Heidegger, "), _c('i', [_vm._v("Elucidations")]), _vm._v(", pp. 136–37; "), _c('i', [_vm._v("Erläuterungen")]), _vm._v(", pp. 113–14. See ch. 3 at n. 180. On Heidegger’s attempt to contrast poetry and prophetism, see Zarader, "), _c('i', [_vm._v("Unthought Debt")]), _vm._v(", pp. 51–56. Finally, it is worth mentioning the passage from Heidegger, "), _c('i', [_vm._v("Anmerkungen I")]), _vm._v("–"), _c('i', [_vm._v("V")]), _vm._v(", p. 159, cited and analyzed in Wolfson, "), _c('i', [_vm._v("Duplicity")]), _vm._v(", pp. 167–68. In that aphorism, Heidegger remarks that prophecy is an instrument of the will to power and that the great prophets were Jews, “a fact whose secret side has not yet been thought.” Anticipating that others would consider his comment prejudicial, he adds a parenthetical gloss, “A footnote for donkeys: this observation has nothing to do with ‘anti-Semitism.’ Anti-Semitism is as foolish and as objectionable as the bloody and above all the unbloody attack on ‘the pagans’ by Christianity. That Christianity too condemns anti-Semitism as ‘un-Christian’ belongs to the highly developed finesse of its technology of power.” As I noted in "), _c('i', [_vm._v("Duplicity")]), _vm._v(", p. 265n61, I utilized the translation by Krell, “Troubled Brows,” p. 319. For a different rendering and analysis, see di Cesare, "), _c('i', [_vm._v("Heidegger and the Jews")]), _vm._v(", pp. 214–15. Di Cesare attempts to contextualize the passage historically by noting that it was written after Heidegger had been banned from teaching at the university in 1946. She also argues that Heidegger’s self-defense that his comment about Jews and prophecy had nothing to do with anti-Semitism should be read against the backdrop of the growing stigmatization of anti-Semitism in the period of de-Nazification ("), _c('i', [_vm._v("Entnazifizierung")]), _vm._v("). This historical contextualization makes sense, and in particular sheds light on why Heidegger would emphasize that Christianity already condemned anti-Semitism as unchristian, but it does not address the crucial nexus Heidegger draws between the prophecy of the Jews and the will to power.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn13"
    }
  }, [_vm._v("13")]), _vm._v(". See the evidence adduced in Babich, “Heidegger’s Jews,” pp. 134–35; and Babich, “Heidegger’s "), _c('i', [_vm._v("Judenfrage")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn14"
    }
  }, [_vm._v("14")]), _vm._v(". Derrida, Gadamer, and Lacoue-Labarthe, "), _c('i', [_vm._v("Heidegger")]), _vm._v(", p. x. Also relevant to Heidegger’s repression or marginalization of other cultural formations is the essay by Bernasconi, “On Heidegger’s Other Sins.” See, by contrast, Davis, “Heidegger on the Way”; and see the studies cited in ch. 3 n. 94.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn15"
    }
  }, [_vm._v("15")]), _vm._v(". Junk, "), _c('i', [_vm._v("Metapher und Sprachmagie")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn16"
    }
  }, [_vm._v("16")]), _vm._v(". Wolin, "), _c('i', [_vm._v("Heidegger’s Children")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn17"
    }
  }, [_vm._v("17")]), _vm._v(". Fleischacker, ed., "), _c('i', [_vm._v("Heidegger’s Jewish Followers")]), _vm._v(". The influence of “Heideggerian themes or, at least, a post-Nietzschean sensibility” on many of the German-Jewish thinkers from the Weimar period is noted by Aschheim in "), _c('i', [_vm._v("Beyond the Borders")]), _vm._v(", p. 93.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn18"
    }
  }, [_vm._v("18")]), _vm._v(". Scult, "), _c('i', [_vm._v("Being Jewish/Reading Heidegger")]), _vm._v(". See also Scult, “Forgiving ‘La Dette Impensée.’” Noteworthy as well is the hermeneutical program for rereading Heidegger, based on the Jewish concept of "), _c('i', [_vm._v("teshuvah")]), _vm._v(", laid out in the essay by Gibbs, “Reading Heidegger.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn19"
    }
  }, [_vm._v("19")]), _vm._v(". Fagenblat, “‘Heidegger’ and the Jews,” p. 157. See also Fagenblat, “Lévinas, Judaism, Heidegger.” According to Fagenblat, not only is Heidegger an indispensable key to comprehending the viability of Levinas’s philosophical ethics, but Heideggerian hermeneutics—especially the notion of “formal indication” ("), _c('i', [_vm._v("formale Anzeige")]), _vm._v("), by which Heidegger established a relationship between the Christian experience of enactment ("), _c('i', [_vm._v("Vollzug")]), _vm._v(") and fundamental ontology—can serve as the foundation for a philosophy of Judaism that is not simply predicated on Jewish identity (“Levinas, Judaism, Heidegger,” pp. 56–57).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_20"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn20"
    }
  }, [_vm._v("20")]), _vm._v(". Lapidot, “Das Fremde im Denken”; Dolgopolski, “How Else?”")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn21"
    }
  }, [_vm._v("21")]), _vm._v(". Fackenheim, "), _c('i', [_vm._v("Encounters")]), _vm._v(", p. 218. The passage is cited by Fagenblat, “‘Heidegger’ and the Jews,” pp. 157–58.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn22"
    }
  }, [_vm._v("22")]), _vm._v(". Fackenheim, "), _c('i', [_vm._v("Encounters")]), _vm._v(", p. 219.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn23"
    }
  }, [_vm._v("23")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("On the Way to Language")]), _vm._v(", p. 127; "), _c('i', [_vm._v("Unterwegs zur Sprache")]), _vm._v(", p. 246. Compare Heidegger, "), _c('i', [_vm._v("On the Way to Language")]), _vm._v(", p. 47 ("), _c('i', [_vm._v("Unterwegs zur Sprache")]), _vm._v(", p. 137), where the expression “saying” ("), _c('i', [_vm._v("sagen")]), _vm._v(") is said to have the meaning of “let appear and let shine ["), _c('i', [_vm._v("erscheinen-und scheinenlassen")]), _vm._v("], but in the manner of hinting.” See Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", p. 131. For a different assessment of the status of the visual image in Heidegger’s poetic-linguistic ontology, see Gosetti-Ferencei, "), _c('i', [_vm._v("Ecstatic Quotidian")]), _vm._v(", pp. 185–94.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn24"
    }
  }, [_vm._v("24")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Poetry, Language, Thought")]), _vm._v(", p. 170; "), _c('i', [_vm._v("Vorträge und Aufsätze")]), _vm._v(", p. 172.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn25"
    }
  }, [_vm._v("25")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Essence of Truth")]), _vm._v(", p. 40; "), _c('i', [_vm._v("Vom Wesen der Wahrheit")]), _vm._v(", p. 54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn26"
    }
  }, [_vm._v("26")]), _vm._v(". Novak, “Buber’s Critique,” pp. 134–36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn27"
    }
  }, [_vm._v("27")]), _vm._v(". Fackenheim, "), _c('i', [_vm._v("To Mend the World")]), _vm._v(", pp. 168–71. Fackenheim, on pp. 180–81, does note the eventual shift in Heidegger and his critique of Nazism but finds it wanting and inauthentic. Compare Fackenheim’s remark in a letter to Scholem (November 26, 1978), in Scholem, "), _c('i', [_vm._v("Life in Letters")]), _vm._v(", p. 475, inquiring about Buber’s meeting with Heidegger: “Perhaps I should add that what is at stake for me here is not Heidegger but the philosophical concerns that he so profoundly stirred and that, in my opinion, he failed philosophically (not to mention personally) to carry out: namely, the historical-ness of Being and the question of truth in the Age of Technology.” For the original German, see Scholem, "), _c('i', [_vm._v("Briefe III")]), _vm._v(", p. 420, # 179, n. 1")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn28"
    }
  }, [_vm._v("28")]), _vm._v(". Wolfson, "), _c('i', [_vm._v("Language")]), _vm._v(", pp. 13–21. Fagenblat, “‘Heidegger’ and the Jews,” p. 157, correctly notes the “extensive use of Heidegger” in my “research into Kabbalistic language.” The author generously refers to some of my previous publications on p. 166n70 and even mentions the present book as a forthcoming project. See also Fagenblatt, “The Thing,” p. 18. With no blame intended to the author, this does not tell the whole story, including my noting the influence of kabbalah on Schelling (see reference below, n. 40) as well as drawing attention to the affinities between Heideggerian thought and modern Jewish philosophy, especially Rosenzweig and Levinas, and this includes the possible residuals of kabbalistic concepts, chronicled in great detail in Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 45–54, 68–69, 80–81, 94–102, 124–32. Fagenblat, “‘Heidegger’ and the Jews,” pp. 152–56, independently discusses the relationship of Heidegger to Rosenzweig, Levinas, Altmann, and Soloveitchik. See also Fagenblatt, “The Thing,” pp. 12–20. On Altmann’s use of Heidegger in constructing a contemporary Jewish theology, see Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", p. 290n37, where I refer to previous scholarship that I will refrain from repeating in this context. The attraction of Altmann to Heidegger may have also been related to a mutual interest in Gnosticism. Consider the revealing testimony given by Altmann, “Author’s Preface,” in "), _c('i', [_vm._v("Meaning of Jewish Existence")]), _vm._v(", p. xii: “Hans Jonas’s disclosure of the Gnostic world view (1934), which at that time was virtually disregarded in Germany, also found a strong resonance in me, not least in view of the demonic features of the life experience of those days. Herein lies the basis for my long preoccupation with Gnostic motifs in rabbinic literature.” On this passage, see Wasserstrom, “Hans Jonas,” pp. 59–60. On Altmann’s interest in Gnosticism and various studies on it, see Mendes-Flohr, “Theologian before the Abyss,” in Altmann, "), _c('i', [_vm._v("Meaning of Jewish Existence")]), _vm._v(", pp. xlv–xlvii. Regarding Heidegger and Soloveitchik, see Wolfson, “Eternal Duration,” pp. 208–12n37; Herskowitz, “Rabbi Joseph B. Soloveitchik’s Endorsement,” pp. 382–86; and Herskowitz, “The Moment and the Future,” pp. 97–99. Herskowitz’s suggestion that the similarity I detect between Heidegger and Soloveitchik can be explained by the influence of Kierkegaard on both of them is well taken, but I would argue nevertheless that the specific issue of the compresence of the three temporal modes in the moment reflects the kabbalistic idea as transmitted in Ḥabad sources. See, more recently, Shatz, “Contemporary Scholarship,” pp. 156, 157n57, 159–60n58, 166–67n85. On balance, I would say, my contributions to the topic of Heidegger and modern Jewish thinkers could be well characterized by Fagenblat’s own assertion that the task is not only to trace the “‘Hebraic’ elements in Heidegger’s thought but the becoming-Heideggerian of prominent strands of modern Jewish thought” (Fagenblat, “‘Heidegger’ and the Jews,” p. 158). Finally, mention should be made of Perlman, "), _c('i', [_vm._v("Eclipse of Humanity")]), _vm._v(". I agree with the main thesis of Perlman’s study, although I think that in some other areas of phenomenological inquiry, for instance, their respective investigations of temporality, a case can be made for a more striking resemblance between Heschel and Heidegger. I will not respond in length to Perlman’s criticism of my use of Heidegger (pp. 29–30n92), but I will say it is disappointing that in a book published in 2016, the author refers only to my monograph published in 1994 and makes no effort to relate to subsequent work in which I have delved more deeply into the affinities "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("between Heidegger, the kabbalists, and modern Jewish thinkers, including Heschel. On Heschel and Heidegger, see also Held, "), _c('i', [_vm._v("Abraham Joshua Heschel")]), _vm._v(", pp. 46–51, 249–50nn176–77; Herskowitz, “God, Being, Pathos.”")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn29"
    }
  }, [_vm._v("29")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Poetry, Language, Thought")]), _vm._v(", p. 53; "), _c('i', [_vm._v("Holzwege")]), _vm._v(", p. 40. On φύσις as the ever-emerging self-concealment, see Dahlstrom, “Being,” pp. 140–46. It is of interest to recall the comment of Boeder, "), _c('i', [_vm._v("Seditions")]), _vm._v(", p. 6: “No light penetrates the darkness of Heidegger’s thought so long as reference continues to be made to the double-pivoting of a φύσις that is simultaneously an emergence into appearance and a self-concealment. This reference fades insofar as thinking finds its way out of Nature not only as it is the Nature of what appears but, what is more, out of Nature as the history of self-concealing and thereby severs the history of occidental thought from just this Nature. This was our point of departure from Heideggerian thought.” It is beyond the scope of this note for me to evaluate whether this student of Heidegger was able to achieve this departure, but what is most relevant to my discussion is Boeder’s recognition of the central place the paradox of the concurrent revealing and concealing occupied in his teacher’s thought. On Heidegger’s notion of truth as unconcealment or disclosedness, see also Farber, “Heidegger”; Anderson, “Truth”; Stambaugh, "), _c('i', [_vm._v("Finitude of Being")]), _vm._v(", pp. 13–30; Tugendhat, "), _c('i', [_vm._v("Wahrheitsbegriff")]), _vm._v(", pp. 389–93, 396–99, 402–3; Tugendhat, “Heidegger’s Idea of Truth”; and the discussion in Zabala, "), _c('i', [_vm._v("Hermeneutic Nature")]), _vm._v(", pp. 25–44; Dahlstrom, "), _c('i', [_vm._v("Heidegger’s Concept")]), _vm._v(", pp. 182, 214, 223–31, 238–40, 291–92, 300–1, 314–15, 322–25, 389–92, 397–407, 431–32; Olafson, “Being”; Sallis, “Interrupting Truth”; de Beistegui, "), _c('i', [_vm._v("Truth and Genesis")]), _vm._v(", pp. 122–30, 142–46, 153–54; Wrathall, “Heidegger, Truth, and Reference”; Wrathall, “Heidegger on Plato”; Malpas, "), _c('i', [_vm._v("Heidegger’s Topology")]), _vm._v(", pp. 183–201; Gonzalez, "), _c('i', [_vm._v("Plato and Heidegger")]), _vm._v(", pp. 225–55; Blond, "), _c('i', [_vm._v("Heidegger and Nietzsche")]), _vm._v(", pp. 79–98. On the interplay of revealing and concealing in Heidegger, see also Vail, "), _c('i', [_vm._v("Heidegger and Ontological Difference")]), _vm._v(", pp. 25–46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn30"
    }
  }, [_vm._v("30")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Poetry, Language, Thought")]), _vm._v(", p. 54; "), _c('i', [_vm._v("Holzwege")]), _vm._v(", p. 40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn31"
    }
  }, [_vm._v("31")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Poetry, Language, Thought")]), _vm._v(", pp. 54–55; "), _c('i', [_vm._v("Holzwege")]), _vm._v(", p. 41. Heidegger’s commitment to the proposition that “the nature of truth is untruth,” "), _c('i', [_vm._v("das Wesen der Wahrheit ist die Un-Wahrheit")]), _vm._v(" ("), _c('i', [_vm._v("Poetry, Language, Thought")]), _vm._v(", p. 55; "), _c('i', [_vm._v("Holzwege")]), _vm._v(", p. 41) may be related as well to another deep structure of the kabbalistic worldview, viz., the belief that the deceptiveness of the demonic is an inherent aspect of the veracity of the divine. To the extent that evil is the other side and not the privation of good, that darkness is a manifestation and not the occlusion of light, it follows that there can be no truth that is not itself untruth, no rectitude that is not tinged with mendacity. For discussion of the relevance of this motif to Heidegger’s ethics and politics, see Wolfson, "), _c('i', [_vm._v("Duplicity")]), _vm._v(", pp. 154–68. In that analysis, I suggested, inter alia, that the kabbalistic idea may have been transmitted to Heidegger through Böhme and Schelling. On Heidegger’s use of Böhme’s notion of strife and Schelling’s idea of rage, see now Bernasconi, “Being is Evil.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn32"
    }
  }, [_vm._v("32")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Pathmarks")]), _vm._v(", p. 148; "), _c('i', [_vm._v("Wegmarken")]), _vm._v(", p. 194.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn33"
    }
  }, [_vm._v("33")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §129, p. 194 (all references are to the translation of Rojcewicz and Vallega-Neu unless otherwise noted); "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 246. The passage is discussed in Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 242–43. See also Maly, “Man and Disclosure,” pp. 51–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn34"
    }
  }, [_vm._v("34")]), _vm._v(". Bernasconi, "), _c('i', [_vm._v("Question of Language")]), _vm._v(", pp. 15–27, 87; Wolfson, "), _c('i', [_vm._v("Language")]), _vm._v(", pp. 19, 413n173; Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 2, 48–52, 130–31, 243. For a critique of the Heideggerian interpretation of "), _c('i', [_vm._v("a-lēthēs")]), _vm._v(" and "), _c('i', [_vm._v("a-lētheuein")]), _vm._v(" as unconcealment, see Jonas, "), _c('i', [_vm._v("Phenomenon of Life")]), _vm._v(", p. 181.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn35"
    }
  }, [_vm._v("35")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("On the Way to Language")]), _vm._v(", p. 50 (emphasis in original); "), _c('i', [_vm._v("Unterwegs zur Sprache")]), _vm._v(", p. 140.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn36"
    }
  }, [_vm._v("36")]), _vm._v(". Scholem, "), _c('i', [_vm._v("Messianic Idea")]), _vm._v(", p. 293. See also Idel, "), _c('i', [_vm._v("Old Worlds")]), _vm._v(", p. 111.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn37"
    }
  }, [_vm._v("37")]), _vm._v(". Idel, "), _c('i', [_vm._v("Old Worlds")]), _vm._v(", p. 273n11. I am grateful to Idel for acknowledging the affinity between my view on concealment and disclosure in kabbalistic lore and the perspective of Scholem, and for his noting further the Lacanian influence on my thinking. See also Idel, "), _c('i', [_vm._v("Kabbalah and Eros")]), _vm._v(", p. 129. I have certainly been explicit about the impact of Lacan—especially as it relates to his idea of the exposure of the phallus that remains veiled (see Wolfson, “Circumcision, Secrecy”; Wolfson, "), _c('i', [_vm._v("Language")]), _vm._v(", pp. 128–36)—but Heidegger is an equally, if not more, important source, although perhaps one should note the Heideggerian background of Lacan himself on this matter (see ch. 1 n. 131). To complicate the picture, one could argue that Scholem’s perspective is close to Eliade’s idea of the religious phenomenon as a hierophany wherein the sacred is both manifest and occluded, occluded to the extent that it is manifest and manifest to the extent that it is occluded, a position that has much in common with the Heideggerian hermeneutic and the paradoxical confluence of truth and untruth, concealment and disclosure. See Wolfson, "), _c('i', [_vm._v("Abraham Abulafia")]), _vm._v(", pp. 17n21, 28–29 (see ch. 7 n. 147). For a different approach to Scholem’s relationship "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("to Heidegger, see Magid, “Gershom Scholem’s Ambivalence,” pp. 246–47: “As we will see, the defining factor for Scholem is his theory of language, which, unlike Buber and Heidegger, is not an adequate tool of communication, but is the fabric of experience and being itself.” According to Magid, Scholem’s critique of Buber’s "), _c('i', [_vm._v("Erlebnismystik")]), _vm._v(" (for a more detailed evaluation of this topic, see Mendes-Flohr, “Introductory Essay,” pp. 12–14) as allocating ultimate authority to subjective experience was combined with a Cohenian rejection of the Parmenidean identity of being and thought bolstering a pantheistic cosmology, which becomes most pronounced in the rejection of any transcendence in Heidegger’s thinking. See the reproach of Heidegger in one of Scholem’s poems cited in ch. 6 n. 222. Scholem’s possible engagement with Heidegger is noted as well by Wasserstrom, "), _c('i', [_vm._v("Religion after Religion")]), _vm._v(", pp. 136, 229, 310n60. On Scholem’s antipathy to Heidegger and his refusal to accept Gadamer’s invitation to meet him based on the inability to forgive his past, see Scholem’s letter to Fackenheim (December 7, 1978), in Scholem, "), _c('i', [_vm._v("Life in Letters")]), _vm._v(", p. 476; Scholem, "), _c('i', [_vm._v("Briefe III")]), _vm._v(", p. 195. See ch. 8 n. 176. In my work, including in this volume, I offer a different perspective that narrows the gap between Scholem and Heidegger. For both thinkers, language attests to the fabric of being but in such a manner that language unveils the veil of being that remains veiled in the unveiling. The paradox is also expressed by Scholem linguistically in terms of the relationship between the name and the nameless. See, for instance, Scholem, “Name of God,” p. 174, and compare ibid., pp. 180, 193–94. I readily acknowledge that with respect to the privileging of paradox in the kabbalistic understanding and expression of truth, I do concur with Scholem. For a criticism of Scholem’s description of the kabbalistic view as paradoxical, together with the notion of the mythological, as oversimplifications, see Idel, “On Some Forms,” pp. xxxi–xxxii. I would counter that an appreciation of the nature of the mythical or the paradoxical in general, and in particular as the matter may be elicited from kabbalistic texts, hardly merits the label of oversimplification. Idel’s claim is based on an inadequate appeal to hermeneutical diversity and the faulty assertion that, by applying these structural categories to the analysis of texts, the scholar is guilty of necessarily adopting an “essentialistic approach” that lacks “open-mindedness.”")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn38"
    }
  }, [_vm._v("38")]), _vm._v(". The connection is made explicit in the description of the Lurianic mythology in Scholem, "), _c('i', [_vm._v("Kabbalah")]), _vm._v(", p. 143: “At the same time, side by side with this Gnostic outlook, we find a most astonishing tendency to a mode of contemplative thought that can be called ‘dialectic’ in the strictest sense of the term as used by Hegel. This tendency is especially prominent in attempts to present formal explanations of such doctrines as that of the "), _c('i', [_vm._v("ẓimẓum")]), _vm._v(", the breaking of the vessels, or the formation of the "), _c('i', [_vm._v("parẓufim")]), _vm._v(".” Although Hegel is not mentioned explicitly, the influence of his thinking is evident in the description of the emanation of the "), _c('i', [_vm._v("sefirot")]), _vm._v(" from the infinite nothingness in Scholem, "), _c('i', [_vm._v("Major Trends")]), _vm._v(", p. 218: “In other words, the passage from "), _c('i', [_vm._v("ain")]), _vm._v(" to "), _c('i', [_vm._v("ani")]), _vm._v(" is symbolical of the transformation by which the Nothing passes through the progressive manifestation of its essence in the Sefiroth, into the I—a dialectical process whose thesis and antithesis begin and end in God: surely a remarkable instance of dialectical thought. Here as elsewhere, mysticism, intent on formulating the paradoxes of religious experience, uses the instrument of dialectics to express its meaning. The Kabbalists are by no means the only witnesses to this affinity between mystical and dialectical thinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn39"
    }
  }, [_vm._v("39")]), _vm._v(". Jonas, “Heidegger and Theology,” pp. 211–15, reprinted with minor changes in Jonas, "), _c('i', [_vm._v("Phenomenon of Life")]), _vm._v(", pp. 240–44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn40"
    }
  }, [_vm._v("40")]), _vm._v(". On the influence of Cusanus on Heidegger, see McDonough, "), _c('i', [_vm._v("Martin Heidegger’s Being and Time")]), _vm._v(", p. xxvi n4. The possible impact of Christian kabbalah on Cusanus, related especially to the mystical meaning of the divine names, including the name YHSWH, has been discussed by Schmidt-Biggemann, "), _c('i', [_vm._v("Geschichte der christlichen Kabbala")]), _vm._v(", 1:49–55. On the name YHSWH, see the sources (including a passage from Pico) cited in Wolfson, "), _c('i', [_vm._v("Along the Path")]), _vm._v(", p. 213n104, to which one might add Baader, "), _c('i', [_vm._v("Biographie und Briefwechsel")]), _vm._v(", 461; Schmidt-Biggemann, "), _c('i', [_vm._v("Geschichte der christlichen Kabbala")]), _vm._v(", 1:16–18. For other references to Baader and the kabbalah, see below, n. 91. On the relationship of Schelling and the kabbalah, see Scholem, "), _c('i', [_vm._v("Major Trends")]), _vm._v(", pp. 409n19 and 412n77; Scholem, "), _c('i', [_vm._v("Kabbalah")]), _vm._v(", pp. 134 and 200; Schulze, “Schelling und die Kabbala”; Benz, "), _c('i', [_vm._v("Mystical Sources")]), _vm._v(", pp. 47–58; Idel, "), _c('i', [_vm._v("Kabbalah: New Perspectives")]), _vm._v(", p. 264; Olson, "), _c('i', [_vm._v("Hegel and the Spirit")]), _vm._v(", pp. 42–44; Schulte, “Zimzum in the Works of Schelling” (German version: “Zimzum bei Schelling”); Schulte, “Ẓimẓum in der "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v("”; Schulte, "), _c('i', [_vm._v("Zimzum")]), _vm._v(", pp. 296–323; Cahnman, “Friedrich Wilhelm Schelling”; Beach, "), _c('i', [_vm._v("Potencies of God(s)")]), _vm._v(", pp. 1–2, 6–13, 25–45, 69–82, 226–30; Bowie, "), _c('i', [_vm._v("Schelling")]), _vm._v(", p. 117; Gibbons, "), _c('i', [_vm._v("Spirituality")]), _vm._v(", pp. 12–13; Koslowski, "), _c('i', [_vm._v("Philosophien der Offenbarung")]), _vm._v(", pp. 565–771; Habermas, “Dialectical Idealism in Transition”; Bielik-Robson, “God of Luria.” And compare the discussion of Franz Joseph Molitor, which includes "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("occasional references to Schelling, in Schmidt-Biggemann, "), _c('i', [_vm._v("Geschichte der christlichen Kabbala")]), _vm._v(", 3:382–425, esp. 401, 408, 413–14, 417. See also Schmidt-Biggemann, “Schellings ‘Weltalter,’” pp. 4, 10, 38–40, 62, 77; Wolfson, "), _c('i', [_vm._v("Language")]), _vm._v(", pp. xv–xvi, 99–105, and references to other scholars mentioned on pp. 392–93n2; and see further references cited in ch. 4 n. 279. For the more specific affinity between Schelling and Ḥabad, see Wolfson, "), _c('i', [_vm._v("Open Secret")]), _vm._v(", pp. 101–2; Wolfson, “Achronic Time,” pp. 57–73. On Rosenzweig’s linking the Lurianic teaching about the “interiorization of God,” which precedes the “self-externalization,” and the “dark ground” of Schelling’s thought, see Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", p. 80, and references cited on p. 346nn332–33. Schelling’s embrace of kabbalah, I presume, may also be related to the more positive outlook he adopted regarding the place and the role of Judaism in the history of religion. See Danz, “‘Ihre Wahrheit hat die alttestamentliche Religion nur in der Zukunft.’” The influence of kabbalah on German idealism is addressed as well by Meinvielle, "), _c('i', [_vm._v("De la Cábala")]), _vm._v(", pp. 254–65. See also the wide-ranging analysis of Vassányi, "), _c('i', [_vm._v("Anima Mundi")]), _vm._v(", and the remark about Schelling on p. 387; Franks, “Rabbinic Idealism and Kabbalistic Realism,” pp. 232–41; Franks, “Peirce’s ‘Schelling-Fashioned Idealism,’” pp. 745–51; Franks, “Fichte’s Kabbalistic Realism.” Also relevant here are the studies on the occult nature of Hegel’s philosophical incursions by O’Regan, "), _c('i', [_vm._v("Heterodox Hegel")]), _vm._v(", and Magee, "), _c('i', [_vm._v("Hegel")]), _vm._v(". Magee discusses the influence of kabbalism on Hegel on pp. 150–86. See also Simuţ, "), _c('i', [_vm._v("F. C. Baur’s Synthesis")]), _vm._v(". On the affinity of Hegel and the kabbalah, see also Franks, “Nothing Comes from Nothing,” p. 12, where the proximity between the Lurianic doctrine of "), _c('i', [_vm._v("ṣimṣum")]), _vm._v(" and the depiction of divine creativity in Hegel as the negation of self-negativity is noted. For the impact of Böhmean theosophy on Hegel, see Codignola, “Monde sensible.” A related but separate issue is Schelling’s classification of philosophy as esoteric and inaccessible, a perspective he shared early on with Hegel. See Franks, "), _c('i', [_vm._v("All or Nothing")]), _vm._v(", pp. 82n135, 327–29, 374–76. Finally, many have opined on the intellectual relationship between Schelling and Heidegger. For the purposes of this study, see especially Iber, "), _c('i', [_vm._v("Das Andere der Vernunft")]), _vm._v(", pp. 326–61; Hedley, “Schelling and Heidegger.” See below, n. 93.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn41"
    }
  }, [_vm._v("41")]), _vm._v(". Wolfson, “Divine Suffering,” pp. 110–17. See also Wolfson, “Murmuring Secrets,” pp. 69–85.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn42"
    }
  }, [_vm._v("42")]), _vm._v(". Compare the Lacanian text about the nature of the rainbow and the elementary utterance "), _c('i', [_vm._v("c’est cela")]), _vm._v(" cited and discussed by Žižek, "), _c('i', [_vm._v("Less Than Nothing")]), _vm._v(", pp. 861–62.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn43"
    }
  }, [_vm._v("43")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Off the Beaten Track")]), _vm._v(", p. 254; "), _c('i', [_vm._v("Holzwege")]), _vm._v(", p. 337.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn44"
    }
  }, [_vm._v("44")]), _vm._v(". The language was used by Funkenstein, "), _c('i', [_vm._v("Perceptions of Jewish History")]), _vm._v(", p. 331, in his comparison of Heidegger’s notion of being with Spinoza’s idea of substance, which he famously identified as God or nature ("), _c('i', [_vm._v("Deus sive natura")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn45"
    }
  }, [_vm._v("45")]), _vm._v(". Compare the formulation of Blumenberg, “Light as a Metaphor,” p. 31 (cited in ch. 7 at n. 71).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn46"
    }
  }, [_vm._v("46")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Pathmarks")]), _vm._v(", pp. 277–78; "), _c('i', [_vm._v("Wegmarken")]), _vm._v(", pp. 365–66. On the motif of the light of being in Heidegger, see Wood, "), _c('i', [_vm._v("Path into Metaphysics")]), _vm._v(", pp. 297–99.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn47"
    }
  }, [_vm._v("47")]), _vm._v(". Kahn, "), _c('i', [_vm._v("Art and Thought of Heraclitus")]), _vm._v(", pp. 82–83, 271–72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn48"
    }
  }, [_vm._v("48")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Early Greek Thinking")]), _vm._v(", p. 72; "), _c('i', [_vm._v("Vorträge und Aufsätze")]), _vm._v(", p. 227.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn49"
    }
  }, [_vm._v("49")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Heraklit")]), _vm._v(", p. 162. I have utilized the translation in Maly and Emad, eds., "), _c('i', [_vm._v("Heidegger on Heraclitus")]), _vm._v(", p. 45. See now Heidegger, "), _c('i', [_vm._v("Heraclitus")]), _vm._v(", p. 123. For an analysis of Heidegger’s reading of this Heraclitean fragment, see Korab-Karpowicz, "), _c('i', [_vm._v("Presocratics")]), _vm._v(", pp. 131–33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn50"
    }
  }, [_vm._v("50")]), _vm._v(". Kahn, "), _c('i', [_vm._v("Art and Thought of Heraclitus")]), _vm._v(", pp. 32–33, 105.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn51"
    }
  }, [_vm._v("51")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Principle of Reason")]), _vm._v(", p. 70; "), _c('i', [_vm._v("Satz vom Grund")]), _vm._v(", p. 104. Heidegger cited and interpreted this Heraclitean dictum frequently in his lectures and writings. Compare Heidegger, "), _c('i', [_vm._v("Metaphysical Foundations")]), _vm._v(", p. 217 ("), _c('i', [_vm._v("Metaphysische Anfangsgründe")]), _vm._v(", p. 281); Heidegger, "), _c('i', [_vm._v("Fundamental Concepts")]), _vm._v(", p. 27 ("), _c('i', [_vm._v("Grundbegriffe")]), _vm._v(", p. 41); Heidegger, "), _c('i', [_vm._v("Essence of Truth")]), _vm._v(", pp. 9–11 ("), _c('i', [_vm._v("Vom Wesen der Wahrheit")]), _vm._v(", pp. 13–15); Heidegger, "), _c('i', [_vm._v("Early Greek Thinking")]), _vm._v(", pp. 113–14 ("), _c('i', [_vm._v("Vorträge und Aufsätze")]), _vm._v(", pp. 277–79); Heidegger, "), _c('i', [_vm._v("Introduction to Metaphysics")]), _vm._v(", pp. 120–21 ("), _c('i', [_vm._v("Einführung in die Metaphysik")]), _vm._v(", p. 122); Heidegger, "), _c('i', [_vm._v("Pathmarks")]), _vm._v(", pp. 229–30 ("), _c('i', [_vm._v("Wegmarken")]), _vm._v(", pp. 300–1); Heidegger, "), _c('i', [_vm._v("Heraclitus")]), _vm._v(", pp. 83–86, 90–91, 131–32 ("), _c('i', [_vm._v("Heraklit")]), _vm._v(", pp. 109–14, 121–22, 175–77). For discussion of Heidegger’s interpretation of the Heraclitean saying and the self-concealing of nature, see Scott, “Appearing to Remember Heraclitus,” pp. 252–57; Dahlstrom, “Being,” pp. 142–43, 150–51; Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 51–52, 316–17n129. The interpretive history of the aphorism of Heraclitus is traced by Hadot, "), _c('i', [_vm._v("Veil of Isis")]), _vm._v(", pp. 39–87. Heidegger’s specific explication thereof is discussed on pp. 303–7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn52"
    }
  }, [_vm._v("52")]), _vm._v(". Beaufret, “Heraclitus and Parmenides,” pp. 83–84.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn53"
    }
  }, [_vm._v("53")]), _vm._v(". Wolfson"), _c('i', [_vm._v(", Open Secret")]), _vm._v(", pp. 25–27, 52, 64, 96, 99–100, 113, 114–29, 212, 245, 341n166.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn54"
    }
  }, [_vm._v("54")]), _vm._v(". I have taken the liberty to repeat the argument in Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", p. 54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_55"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn55"
    }
  }, [_vm._v("55")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Gelassenheit")]), _vm._v(", p. 25. I have modified the translation of "), _c('i', [_vm._v("herzhaften Denken")]), _vm._v(" as “courageous thinking” in Heidegger, "), _c('i', [_vm._v("Discourse on Thinking")]), _vm._v(", p. 56. Commenting on the expression "), _c('i', [_vm._v("herzhaften Denken")]), _vm._v(", translated as “hearty thinking,” in relation to "), _c('i', [_vm._v("Gelassenheit")]), _vm._v(", Schürmann, "), _c('i', [_vm._v("Meister Eckhart")]), _vm._v(", p. 202, noted that the heart, for Heidegger, is not “the seat of the sentiments” but “the place where the totality of beings renders itself essentially present: it is the center or the core of thinking. This ‘heart of thought,’ then, maintains a nonfortuitous relation with letting-be and the openness to the favors of the mystery.” See also Wood, “Heart in Heidegger’s Thought.”")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn56"
    }
  }, [_vm._v("56")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Discourse on Thinking")]), _vm._v(", p. 46; "), _c('i', [_vm._v("Gelassenheit")]), _vm._v(", pp. 12–13. See Stambaugh, “Future of Continental Philosophy.” On the meditative nature of the Heideggerian "), _c('i', [_vm._v("Besinnung")]), _vm._v(", see also Seidel, “Musing with Kierkegaard,” pp. 410–12. On the ontological difference, see Heidegger, "), _c('i', [_vm._v("Basic Problems of Phenomenology")]), _vm._v(", p. 227 ("), _c('i', [_vm._v("Grundprobleme der Phänomenologie")]), _vm._v(", p. 322): “It is not without reason that the problem of the distinction between being in general and beings occurs here in the first place. For the purpose of the discussion of this difference is to make it possible first of all to get to see thematically and put into investigation, in a clear and methodically secure way, the like of being in distinction from beings. The possibility of ontology, of philosophy as a science, stands and falls with the possibility of a sufficiently clear accomplishment of this differentiation between being and beings and accordingly with the possibility of negotiating the passage from the ontical consideration of beings to the ontological thematization of being.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn57"
    }
  }, [_vm._v("57")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings VII–XI")]), _vm._v(", pp. 57–58; "), _c('i', [_vm._v("Überlegungen VII–XI")]), _vm._v(", pp. 75–76.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn58"
    }
  }, [_vm._v("58")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Country Path Conversations")]), _vm._v(", p. 68; "), _c('i', [_vm._v("Feldweg-Gespräche")]), _vm._v(", p. 106.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn59"
    }
  }, [_vm._v("59")]), _vm._v(". Derrida, "), _c('i', [_vm._v("Circumfession")]), _vm._v(", p. 156. See Caputo, “Toward a Postmodern Theology,” p. 221; Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 157 and 194.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn60"
    }
  }, [_vm._v("60")]), _vm._v(". Derrida, "), _c('i', [_vm._v("Gift of Death")]), _vm._v(", p. 100; "), _c('i', [_vm._v("Donner la mort")]), _vm._v(", p. 137. See Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 191–92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn61"
    }
  }, [_vm._v("61")]), _vm._v(". Caputo, “Toward a Postmodern Theology,” p. 223, sharply contrasts the Derridean insight that the truth is that there is no truth, and the secret is that there is no secret, with the Heideggerian "), _c('i', [_vm._v("Denken")]), _vm._v(", “which is steered by a mighty "), _c('i', [_vm._v("Geschick")]), _vm._v(", a destiny and "), _c('i', [_vm._v("moira")]), _vm._v(", our destiny on Derrida’s account is ‘destinerrance,’ destiny gone errant, cut off from destiny and the Truth of Being.” In my judgement, the gap between the two thinkers is not so wide insofar as Heidegger, too, disavows an idea of truth that can be surgically disentangled from untruth. I would go so far as to say that the Derridean dissimulation of secrecy is indebted to Heidegger’s insight that every truth is enveloped in a veil of untruth. See, however, Bruns, "), _c('i', [_vm._v("Inventions")]), _vm._v(", pp. 95–97; and Bruns, "), _c('i', [_vm._v("Hermeneutics")]), _vm._v(", pp. 222–23.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn62"
    }
  }, [_vm._v("62")]), _vm._v(". My surmise regarding the affinity of the kabbalistic conception of language and Heidegger can be contrasted with the argument about magical speech and the Frankfurt school proffered by Matern, "), _c('i', [_vm._v("Über Sprachgeschichte")]), _vm._v(". See also Martins, "), _c('i', [_vm._v("Adorno und die Kabbala")]), _vm._v(", pp. 148–56, 163–68. See ch. 3 n. 229. Relevant as well is the comparative analysis of the question of language in Heidegger and Jewish sources in Zarader, "), _c('i', [_vm._v("Unthought Debt")]), _vm._v(", pp. 37–57. See also the study of Fagenblat cited below, n. 75.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn63"
    }
  }, [_vm._v("63")]), _vm._v(". Bernasconi, "), _c('i', [_vm._v("Question of Language")]), _vm._v(", pp. 21–23.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn64"
    }
  }, [_vm._v("64")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Pathmarks")]), _vm._v(", p. 239; "), _c('i', [_vm._v("Wegmarken")]), _vm._v(", p. 312.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn65"
    }
  }, [_vm._v("65")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Pathmarks")]), _vm._v(", p. 254; "), _c('i', [_vm._v("Wegmarken")]), _vm._v(", p. 333.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn66"
    }
  }, [_vm._v("66")]), _vm._v(". For a more detailed discussion of this theme, see Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 94–102.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn67"
    }
  }, [_vm._v("67")]), _vm._v(". Courtine, “Phenomenology and/or Tautology,” pp. 249–50. For an attempt to relate Heidegger’s understanding of secrecy as a form of concealment, which belongs inextricably to truth as unconcealment, to the paradox of the secret affirmed by ancient thinkers, see Bruns, "), _c('i', [_vm._v("Inventions")]), _vm._v(", pp. 17–18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn68"
    }
  }, [_vm._v("68")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Discourse on Thinking")]), _vm._v(", p. 55; "), _c('i', [_vm._v("Gelassenheit")]), _vm._v(", p. 24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn69"
    }
  }, [_vm._v("69")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Hölderlin’s Hymn")]), _vm._v(" “"), _c('i', [_vm._v("The Ister")]), _vm._v(",” p. 72; "), _c('i', [_vm._v("Hölderlins Hymne")]), _vm._v(" “"), _c('i', [_vm._v("Der Ister")]), _vm._v(",” p. 89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn70"
    }
  }, [_vm._v("70")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Off the Beaten Track")]), _vm._v(", p. 85; "), _c('i', [_vm._v("Holzwege")]), _vm._v(", p. 112.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn71"
    }
  }, [_vm._v("71")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Off the Beaten Track")]), _vm._v(", p. 85; "), _c('i', [_vm._v("Holzwege")]), _vm._v(", p. 113.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn72"
    }
  }, [_vm._v("72")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Zollikon Seminars")]), _vm._v(", p. 171; "), _c('i', [_vm._v("Zollikoner Seminare: Protokolle")]), _vm._v(", p. 216. See now Heidegger, "), _c('i', [_vm._v("Zollikoner Seminare")]), _vm._v(", p. 76: “"), _c('i', [_vm._v("Behalten")]), _vm._v(" Bergen im Verbergen in die Unverborgenheit Bewahren vor dem Sog in der sich entziehenden "), _c('i', [_vm._v("Verborgenheit")]), _vm._v(". Geheimnis: die sich entziehende Verborgenheit als solche” (emphasis in original). The secret as the withdrawing concealment is occasioned by the safeguarding of the hiding in the unhiddenness.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn73"
    }
  }, [_vm._v("73")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Basic Writings")]), _vm._v(", p. 330; "), _c('i', [_vm._v("Vorträge und Aufsätze")]), _vm._v(", p. 26.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn74"
    }
  }, [_vm._v("74")]), _vm._v(". See above, n. 53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn75"
    }
  }, [_vm._v("75")]), _vm._v(". For a position similar to my own, see Fagenblat, “Of Dwelling Prophetically,” pp. 252–58.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn76"
    }
  }, [_vm._v("76")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings II–VI")]), _vm._v(", p. 170; "), _c('i', [_vm._v("Überlegungen II–VI")]), _vm._v(", p. 233.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn77"
    }
  }, [_vm._v("77")]), _vm._v(". Di Cesare, "), _c('i', [_vm._v("Heidegger e gli ebrei")]), _vm._v(", pp. 135–46, 207–13; di Cesare, "), _c('i', [_vm._v("Heidegger and the Jews")]), _vm._v(", pp. 105–15, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("164–68, 201–2; di Cesare, “Das Sein und der Jude,” pp. 63–66; English translation: “Heidegger’s Metaphysical Anti-Semitism,” pp. 186–87. See also McCumber, “Heidegger: Beyond Anti-Semitism.”")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn78"
    }
  }, [_vm._v("78")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings XII–XV")]), _vm._v(", p. 191 (emphasis in original); "), _c('i', [_vm._v("Überlegungen XII–XV")]), _vm._v(", p. 243.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn79"
    }
  }, [_vm._v("79")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings II–VI")]), _vm._v(", p. 91; "), _c('i', [_vm._v("Überlegungen II–VI")]), _vm._v(", p. 124.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn80"
    }
  }, [_vm._v("80")]), _vm._v(". Lapidot, “People of Knowers,” p. 277.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn81"
    }
  }, [_vm._v("81")]), _vm._v(". Di Cesare, “Being and the Jew,” pp. 77–78 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn82"
    }
  }, [_vm._v("82")]), _vm._v(". Wolfson, "), _c('i', [_vm._v("Alef")]), _vm._v(", pp. 30–46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn83"
    }
  }, [_vm._v("83")]), _vm._v(". Koenker, “Grund”; Weeks, “Radical Reformation,” p. 52. For more detailed studies of Böhme’s impact on Schelling, see Benz, "), _c('i', [_vm._v("Schellings theologische Geistesahnen")]), _vm._v("; Brown, "), _c('i', [_vm._v("Later Philosophy")]), _vm._v("; Schulte, “F. W. J. Schellings Ausleihe”; Vieillard-Baron, “Schelling et Jacob Böhme”; Mayer, "), _c('i', [_vm._v("Jena Romanticism")]), _vm._v(", pp. 179–221; and Whistler, “Silvering,” pp. 160–67. Heidegger makes use of the term "), _c('i', [_vm._v("Abgrund")]), _vm._v(" much more frequently than "), _c('i', [_vm._v("Ungrund")]), _vm._v(", but the latter is found on occasion as well. For instance, see Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", § 11, p. 27 ("), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 31): “The grounded ground is at once abyss ["), _c('i', [_vm._v("Abgrund")]), _vm._v("] for the fissure of beyng and distorted ground ["), _c('i', [_vm._v("Ungrund")]), _vm._v("] for the abandonment of beings by being.” See also Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", § 34, p. 61 ("), _c('i', [_vm._v("Beiträge")]), _vm._v(", pp. 76–77): “Beyng as the ground in which all beings first come to their truth (sheltering, instituting, objectivity); the ground in which beings are submerged (abyss) ["), _c('i', [_vm._v("Abgrund")]), _vm._v("]; the ground in which they also claim to be "), _c('i', [_vm._v("indifferent")]), _vm._v(" [Gleichgültigkeit] and "), _c('i', [_vm._v("self-evident")]), _vm._v(" [Selbstverständlichkeit] (distorted ground) ["), _c('i', [_vm._v("Ungrund")]), _vm._v("]” (emphasis in original). In my opinion, the translation of "), _c('i', [_vm._v("Ungrund")]), _vm._v(" as “distorted ground” offered by Rojcewicz and Vallega-Neu should be modified to “nonground.” "), _c('i', [_vm._v("Abgrund")]), _vm._v(" and "), _c('i', [_vm._v("Ungrund")]), _vm._v(" are paired together as well in Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", § 188, p. 244; "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 308. The former is correlated with concealment of being ("), _c('i', [_vm._v("Verbergung des Seins")]), _vm._v(") and nihilation ("), _c('i', [_vm._v("Nichtung")]), _vm._v("), the latter with dissemblance ("), _c('i', [_vm._v("Verstellung")]), _vm._v(") and decomposition ("), _c('i', [_vm._v("Verwesung")]), _vm._v("). See also Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", § 226, p. 277 ("), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 351): “Only now can we also see more clearly the origin of "), _c('i', [_vm._v("errancy")]), _vm._v(" and the power and possibility of the abandonment by being, the concealment ["), _c('i', [_vm._v("die Verbergung")]), _vm._v("] and the dissembling ["), _c('i', [_vm._v("die Ver-stellung")]), _vm._v("]: the dominance of the distorted ground ["), _c('i', [_vm._v("die Herrschaft des Ungrundes")]), _vm._v("]” (emphasis in original). Once again, I suggest that the translation of "), _c('i', [_vm._v("Ungrund")]), _vm._v(" as distorted ground be changed to nonground. See the passage cited in ch. 4 at n. 93.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn84"
    }
  }, [_vm._v("84")]), _vm._v(". Emmet, “Ground of Being”; Caputo, "), _c('i', [_vm._v("Mystical Element")]), _vm._v(", p. 98.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn85"
    }
  }, [_vm._v("85")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Schelling’s Treatise")]), _vm._v(", pp. 116–17 ("), _c('i', [_vm._v("Schelling: Vom Wesen")]), _vm._v(", pp. 203–4): “To understand this, we must think God’s nature clearly, God, insofar as he is not He himself, that is, God, insofar as he is the ground of himself ["), _c('i', [_vm._v("sofern er der Grund seiner selbst ist")]), _vm._v("], God as the truly originating God ["), _c('i', [_vm._v("der eigentlich anfängliche Gott")]), _vm._v("] who is still completely in his ground, the God as he has not yet emerged from himself to himself ["), _c('i', [_vm._v("wie er noch nicht aus sich selbst zu sich selbst herausgetreten ist")]), _vm._v("]…. The whole boldness of Schelling’s thinking comes into play here. But it is not the vacuous play of thoughts of a manic hermit, it is only the continuation of an attitude of thinking which begins with Meister Eckhart and is uniquely developed in Jacob Boehme. But when this historical context is cited, one is immediately ready again with jargon, one speaks of ‘mysticism’ and ‘theosophy.’ Certainly, one can call it that, but nothing is said by that with regard to the spiritual occurrence and the true creation of thought.” Heidegger goes on to deny the application of the title “mystic” to Schelling if that term is understood as denoting “a muddlehead ["), _c('i', [_vm._v("Wirrkopf")]), _vm._v("] who likes to reel in the obscure and finds his pleasure in veils.” Schelling probably had Böhme in mind when he spoke of “dogmatists and abstract idealists,” who dismiss as “mystics” the “minds that sought the living ground of nature.” See Schelling, "), _c('i', [_vm._v("Philosophical Investigations")]), _vm._v(", pp. 27, 147n31; "), _c('i', [_vm._v("Philosophische Untersuchungen")]), _vm._v(", p. 29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn86"
    }
  }, [_vm._v("86")]), _vm._v(". On Böhme’s "), _c('i', [_vm._v("Ungrund")]), _vm._v(" and the kabbalistic "), _c('i', [_vm._v("Ein Sof")]), _vm._v(", see Aubrey, “Influence of Jacob Boehme,” p. 36; Schulitz, "), _c('i', [_vm._v("Jakob Böhme")]), _vm._v(", pp. 47–82; Deghaye, “La Philosophie,” pp. 249–50; Deghaye, “La Théosophie de Jacob Boehme,” p. 157; Deghaye, "), _c('i', [_vm._v("De Paracelse à Thomas Mann")]), _vm._v(", pp. 83–84, 120–21; Hessayon, “Boehme’s Life,” p. 31; Scholem, "), _c('i', [_vm._v("Geheimnisse der Schöpfung")]), _vm._v(", p. 31; Schmidt-Biggemann, "), _c('i', [_vm._v("Philosophia Perennis")]), _vm._v(", p. 119; Schmidt-Biggemann, “Schellings ‘Weltalter,’” p. 25. See the additional references on the affinities between Böhme and Jewish esotericism cited below, n. 95. The Böhmean "), _c('i', [_vm._v("Ungrund")]), _vm._v(" was already linked to the kabbalistic "), _c('i', [_vm._v("Ein Sof")]), _vm._v(" by Baader. See Baader, "), _c('i', [_vm._v("Gesammelte Schriften zur philosophischen Grundwissenschaft")]), _vm._v(", p. 242; Baader, "), _c('i', [_vm._v("Gesammelte Schriften zur Naturphilosophie")]), _vm._v(", p. 384; Baader, "), _c('i', [_vm._v("Vorlesungen und Erläuterungen")]), _vm._v(", pp. 106, 119, 132, 172, 191, 194; Friesen, “Sophia,” p. 132. For comparative studies on Böhme and Heidegger, see Paslick, “Ontological Context,” pp. 409–13 (wherein the influence of the kabbalah on Böhme’s ontology, including the affinity between the absolute indifference of the "), _c('i', [_vm._v("Ungrund")]), _vm._v(" and "), _c('i', [_vm._v("Ein Sof")]), _vm._v(" as the plenitude of reality and the emptiness of nothingness, is considered in relation to Heidegger’s "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("positing a unity of poetry and thought); Friedrich, "), _c('i', [_vm._v("Ungrund der Freiheit")]), _vm._v("; Peckler, “Imagination”; Gentzke, “Imaginal Renaissance,” pp. 80n223, 92, 143, 184, 200–1, 298n800, 346. See also Caputo, "), _c('i', [_vm._v("Mystical Element")]), _vm._v(", p. 98, and Zarader, "), _c('i', [_vm._v("Unthought Debt")]), _vm._v(", p. 168; and compare the passing remark of Habermas, “Martin Heidegger,” pp. 161–62. See below, n. 92.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn87"
    }
  }, [_vm._v("87")]), _vm._v(". Benz, "), _c('i', [_vm._v("Christian Kabbalah")]), _vm._v(", pp. 67–68; Deghaye, “La Philosophie,” pp. 249–51; Deghaye, "), _c('i', [_vm._v("De Paracelse à Thomas Mann")]), _vm._v(", pp. 116–63, esp. 132–34, 146–47. See also Deghaye, “La Théosophie de Friedrich Christoph Oetinger,” pp. 149–50; Deghaye, “"), _c('i', [_vm._v("Gedulla")]), _vm._v(" et "), _c('i', [_vm._v("Gebura")]), _vm._v("”; Schmidt-Biggemann, “Schellings ‘Weltalter,’” p. 41. For a concise introduction to Oetinger’s thought, see Piepmeier, “Friedrich Christoph Oetinger.” On the influence of Oetinger on Schelling, see also the editor’s notes in Schelling, "), _c('i', [_vm._v("Nachlass 8")]), _vm._v(", pp. 31–32, 34, 46, 216–17.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn88"
    }
  }, [_vm._v("88")]), _vm._v(". See Coudert, “The "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v("”; Coudert, "), _c('i', [_vm._v("Impact of the Kabbalah")]), _vm._v(", pp. 100–36. See as well the essays that Andreas B. Kilcher edited for vol. 16 of "), _c('i', [_vm._v("Morgen-Glantz")]), _vm._v(", especially Morlok, “Text als Textur”; Burmistrov, “"), _c('i', [_vm._v("Pardes Rimmonim")]), _vm._v("”; Necker, “Geister, Engel und Dämonen”; and Theisohn, “Zur Rezeption.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn89"
    }
  }, [_vm._v("89")]), _vm._v(". Here I mention a select bibliography of studies on the Renaissance Christian kabbalah: Blau, "), _c('i', [_vm._v("Christian Interpretation")]), _vm._v("; Benz, "), _c('i', [_vm._v("Christian Kabbalah")]), _vm._v("; Secret, "), _c('i', [_vm._v("Le Zôhar chez les kabbalistes chrétiens")]), _vm._v("; Secret, "), _c('i', [_vm._v("Kabbalistes Chrétiens")]), _vm._v("; Wirszubski, “Francesco Giorgio’s Commentary”; Wirszubski, "), _c('i', [_vm._v("Pico Della Mirandola’s Encounter")]), _vm._v("; Idel, “Magical and Neoplatonic Interpretations”; Idel, “Kabbalistic Backgrounds”; McGinn, “Cabalists and Christians”; Scholem, “Beginnings”; Dan, “Kabbalah”; Reichert, “Christian Kabbalah”; Schmidt-Biggemann, “Einleitung”; Schmidt-Biggemann, “Schellings ‘Weltalter’”; Copenhaver, “Number, Shape, and Meaning”; Copenhaver, “Secret of Pico’s Oration”; Copenhaver, “Pico risorto”; Ogren, "), _c('i', [_vm._v("Renaissance")]), _vm._v(", pp. 212–63; Ogren, "), _c('i', [_vm._v("Beginnings")]), _vm._v(", pp. 44–59, 117–33; Ogren, “Law of Change”; Bartolucci, “Marsilio Ficino”; Lelli, “Pico, i Da Pisa”; Campanini, “Il commento alle "), _c('i', [_vm._v("Conclusiones cabalisticae")]), _vm._v("”; Copenhaver and Kokin, “Egidio da Viterbo’s "), _c('i', [_vm._v("Book on Hebrew Letters")]), _vm._v("”; Kokin, “Entering the Labyrinth”; Rabin, “Whither Kabbalah?”; Buzzetta, “La Cabbale vulgarisée”; Weiss, "), _c('i', [_vm._v("Kabbalistic Christian Messiah")]), _vm._v(". For a comprehensive list of studies on Christian kabbalah, see Wilkinson, "), _c('i', [_vm._v("Orientalism")]), _vm._v(", pp. 5–6n6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn90"
    }
  }, [_vm._v("90")]), _vm._v(". Schmidt-Biggemann, “Schellings ‘Weltalter,’” pp. 22–34, 37–38; Wirth, "), _c('i', [_vm._v("Conspiracy of Life")]), _vm._v(", pp. 33–64. On the “cabbalistic fanaticism” of Wachter’s "), _c('i', [_vm._v("Spinozismus im Judenthum")]), _vm._v(" (1699), see the refutation of Spinozism and pantheism in lecture 13 of Mendelssohn, "), _c('i', [_vm._v("Morning Hours")]), _vm._v(", pp. 75–81. More was the author of various works that deal with kabbalistic matters, including "), _c('i', [_vm._v("Conjectura Cabbalistica")]), _vm._v("; "), _c('i', [_vm._v("Immortality of the Soul")]), _vm._v(", pp. 136–37, 159; "), _c('i', [_vm._v("Aditus tentatus rationem reddeni nominum")]), _vm._v(", in "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v(", vol. 1, pt. 2, pp. 14–27; "), _c('i', [_vm._v("Quæstiones & considerationes paucæ brevesque in Tractatum primum Libri Druschim")]), _vm._v(", in "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v(", vol. 1, pt. 2, pp. 62–72; "), _c('i', [_vm._v("Ad Clarissimum ac Eruditissimum")]), _vm._v(", in "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v(", vol. 1, pt. 2, pp. 173–224; "), _c('i', [_vm._v("Visionis Ezechieliticæ")]), _vm._v(", in "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v(", vol. 1, pt. 2, pp. 225–73; "), _c('i', [_vm._v("Catechismus Cabbalisticus")]), _vm._v(", in "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v(", vol. 1, pt. 2, pp. 274–92; "), _c('i', [_vm._v("Fundamenta philosophiæ")]), _vm._v(", in "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v(", vol. 1, pt. 2, pp. 293–312. On the possible resonances of Lurianic kabbalah in Anne Conway, a disciple of Henry More and an influence on Leibniz, see introduction to Conway, "), _c('i', [_vm._v("Principles")]), _vm._v(", eds. Coudert and Corse, pp. xviii–xxii, xxix–xxxiii; Coudert, "), _c('i', [_vm._v("Impact of the Kabbalah")]), _vm._v(", pp. 177–210; Cocker, "), _c('i', [_vm._v("Henry More")]), _vm._v(", pp. 183–99; Hutton, “From Christian Kabbalism”; Hutton, "), _c('i', [_vm._v("Anne Conway")]), _vm._v(", pp. 7–8, 68, 153, 156–76; White, "), _c('i', [_vm._v("Legacy")]), _vm._v(", pp. 50, 53–56, 64. See also the introduction in Conway, "), _c('i', [_vm._v("Principles")]), _vm._v(", ed. Loptson, pp. 17–19, 30–33, 73. Loptson acknowledges the influence of kabbalah on Conway, but he is somewhat more skeptical based on the assumption that some of the references to the sources in "), _c('i', [_vm._v("Kabbala Denudata")]), _vm._v(" were added at a later date by More or van Helmont. See the suggestion about Conway’s "), _c('i', [_vm._v("Divine Dialogues")]), _vm._v(" in Bailey, "), _c('i', [_vm._v("Milton and Jakob Boehme")]), _vm._v(", p. 93: “She makes no direct mention of Boehme, but many of her theories are thoroughly Boehmenistic in tone; the whole work is Neoplatonic with a special leaning to the Kabalah.” On More and the kabbalah, see Crocker, "), _c('i', [_vm._v("Henry More")]), _vm._v(", pp. 63–77, 149, 154; Coudert, "), _c('i', [_vm._v("Impact of the Kabbalah")]), _vm._v(", pp. 220–40; White, "), _c('i', [_vm._v("Legacy")]), _vm._v(", p. 126n40; Schmidt-Biggemann, “Christliche Kabbala oder Philosophia Hebraeorum.” On the influence of Jewish esoteric doctrine on Leibniz, see Brown, “Leibniz and More’s Cabbalistic Circle”; Brown, “Proto-Monadology of the De Summa Rerum,” p. 284 and additional references cited there in n. 7; Coudert, "), _c('i', [_vm._v("Leibniz and the Kabbalah")]), _vm._v("; Coudert, “Leibniz and the Kabbalah”; Coudert, “Leibniz, Locke, Newton”; and Coudert, "), _c('i', [_vm._v("Impact of the Kabbalah")]), _vm._v(", pp. 308–29. The relationship between Leibniz and mysticism more generally is explored by Heinekamp, “Leibniz.” Also relevant is the informative analysis in Mahlev, “Kabbalah as Philosophia Perennis?” As Mahlev summarizes his argument, p. 235: “Jews were the most significant ‘other’ in German Protestantism, not only because they were physically present but "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("also because they served as a mirror image upon which Protestantism constructed its own identity. The fact that the consideration of ancient Judaism and its esoteric knowledge, the Kabbalah, stood at the heart of the "), _c('i', [_vm._v("philosophia perennis")]), _vm._v(" debate since the sixteenth century only intensified the tension. For side by side with Protestant controversies concerning the vaunted antiquity and authenticity of kabbalistic wisdom, there were internecine criticisms and concerns over the Christian preoccupation with these materials. Christian Kabbalah—already an established terminus in the seventeenth century—was often depicted as having a dangerous affinity for Judaism, an intrareligious accusation that in turn affected the image of Judaism itself.” See the appendix in Morgenstern, ed., "), _c('i', [_vm._v("Martin Luther und die Kabbala")]), _vm._v(", pp. 177–203.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn91"
    }
  }, [_vm._v("91")]), _vm._v(". See above, n. 40, and below, n. 93. See also Rudolph, “Die Kabbala im Werk des Paracelsus”; Webster, "), _c('i', [_vm._v("Paracelsus")]), _vm._v(", pp. 26–27, 64–65, 156–68, 250–51; Klijnsmit, “F.M. van Helmont: Kabbalist and Phonetician”; Vaughan, "), _c('i', [_vm._v("Johann Georg Hamann")]), _vm._v(", pp. 34–43, 64–68, 76–78, 96–100, 107–25, 127–31; Betanzos, "), _c('i', [_vm._v("Franz von Baader’s Philosophy")]), _vm._v(", pp. 14, 55, 64, 79, 176, 178n38. For discussion of Baader’s theosophy, see Faivre, "), _c('i', [_vm._v("Access to Western Esotericism")]), _vm._v(", pp. 113–33, 139–46, 201–74; the influence of the kabbalah on the notion of androgyny in Baader is briefly discussed on pp. 218–19, and see p. 272. Koslowski, “Franz Baader,” pp. 247–48, compares Baader’s allegedly more radical existential ontology of the total reality ("), _c('i', [_vm._v("einer existentialen Ontologie der Gesamtwirklichkeit")]), _vm._v(") to the Heideggerian existential analysis of the human being ("), _c('i', [_vm._v("existentiale Seinsanalyse des Menschen")]), _vm._v("). On Heidegger’s engagement with Baader, see reference in ch. 6 n. 27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn92"
    }
  }, [_vm._v("92")]), _vm._v(". Habermas, "), _c('i', [_vm._v("Philosophical-Political Profiles")]), _vm._v(", pp. 21–22. And see Franks, “Inner anti-Semitism.” The argument of Habermas, and the thesis I have expounded in this monograph, assumes an even more ironic dimension when we recall the comment in Heidegger, "), _c('i', [_vm._v("Phenomenological Interpretations of Aristotle")]), _vm._v(", p. 53 ("), _c('i', [_vm._v("Phänomenologische Interpretationen zu Aristoteles")]), _vm._v(", p. 70), on the possible “degeneration in the embellishment of mythical and theosophical metaphysics and mysticism and in the trance of a preoccupation with piety, which goes by the name of religiosity.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn93"
    }
  }, [_vm._v("93")]), _vm._v(". On the influence of kabbalistic sources on Schelling, see above, n. 40. See also Tilliette, “Schelling und die Gnosis,” pp. 270–71. Schelling’s relationship to Baader is explored in detail by Zovko, "), _c('i', [_vm._v("Natur und Gott")]), _vm._v(". For the influence of kabbalah on German romanticism, see also Gardt, "), _c('i', [_vm._v("Sprachreflexion in Barock und Frühaufklärung")]), _vm._v(", pp. 108–28; Kilcher, "), _c('i', [_vm._v("Die Sprachtheorie der Kabbala als Ästhetisches Paradigma")]), _vm._v(", pp. 239–327; Kilcher, “Die Kabbala als Trope”; Schulte, “Kabbala in der deutschen Romantik.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn94"
    }
  }, [_vm._v("94")]), _vm._v(". Previous works that have contributed to this discussion are Caputo, “Meister Eckhart and the Later Heidegger;” Caputo, "), _c('i', [_vm._v("Mystical Element")]), _vm._v(", pp. 140–217; Schürmann, "), _c('i', [_vm._v("Meister Eckhart")]), _vm._v(", pp. 192–213; Helting, "), _c('i', [_vm._v("Heidegger und Meister Eckehart")]), _vm._v("; Sikka, "), _c('i', [_vm._v("Forms of Transcendence")]), _vm._v(", pp. 109–86; Rickey, "), _c('i', [_vm._v("Revolutionary Saints")]), _vm._v(", pp. 69–70, 81–87, 97–98; Dalle Pezze, "), _c('i', [_vm._v("Martin Heidegger and Meister Eckhart")]), _vm._v("; Onishi, “Birth of World”; and the following studies in Lewin, Podmore, and Williams, eds., "), _c('i', [_vm._v("Mystical Theology")]), _vm._v(": Pattison, “Role of Mysticism,” pp. 139–43; Williams, “Eckhart’s Why and Heidegger’s What”; and Wojtulewicz, “Meister Eckhart’s Speculative Grammar.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn95"
    }
  }, [_vm._v("95")]), _vm._v(". The following comment about the relationship of the Romantics to Böhme in Hannak, “Boehme and German Romanticism,” p. 168, can be applied to Schelling: “In their search for a deeper dimension of being not beyond but rather within reality itself, the Romantics were fascinated by Hermetic, Neoplatonic, and Kabbalistic texts as well as by contemporary Mesmerism. These interests prepared the ground of their reading of Boehme.” See the comments on Böhme in Heidegger, “Poverty,” pp. 4–5. Speaking of the impact of the notion of the holy Sophia on the “Oriental Church,” and particularly in Russia, Heidegger writes, “The efficacy of the spirit as the all-pervading power of enlightenment and wisdom (Sophia) is ‘magical.’ The ownmost of the magical is as inscrutable and opaque as the ownmost of the pneumatic. Yet, we know that Jacob Böhme, the theosophist and philosopher … had recognized the magical in the light of the shoemaker’s globe and thought of it as the primal will. Böhme’s doctrine of the divine Sophia (theosophy) was known in Russia as early as the seventeenth century…. It is thus no exaggeration when I say that what one nowadays conceives shortsightedly and incompletely as merely ‘political’ or even roughly ‘political’ and calls Russian Communism comes from a spiritual world about which we know hardly anything.” The attempt to trace the spiritual roots of communism to Eastern Orthodoxy, and especially to the theosophy of Böhme, stands in sharp contrast to Heidegger’s disavowal of communism, together with capitalism, as technologically driven ideologies, a description he eventually assigned to Nazism as well. For discussion of Böhme and Heidegger, see studies cited above, n. 86. The affinity between the kabbalistic doctrine of "), _c('i', [_vm._v("Adam Qadmon")]), _vm._v(", the Neoplatonic Logos, and Böhme’s "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("speculation on the first man was already implied by Hegel. See the evidence adduced by Muratori, "), _c('i', [_vm._v("First German Philosopher")]), _vm._v(", p. 279. See also Deghaye, “La Philosophie,” pp. 273–75. On the speculation about "), _c('i', [_vm._v("Adam Qadmon")]), _vm._v(" as the second divinity ("), _c('i', [_vm._v("secunda divinitatis")]), _vm._v(") in relation to "), _c('i', [_vm._v("Ein Sof")]), _vm._v(" and Böhme’s speculation about the incarnation of Christ as the spoken and pronounced Word ("), _c('i', [_vm._v("das sprechende Wort und das ausgesprochene")]), _vm._v("), see Baader, "), _c('i', [_vm._v("Gesammelte Schriften zur Naturphilosophie")]), _vm._v(", pp. 406–8. Böhme’s writings contain some hints that he was aware of the esoteric dimension of Judaism. See the comment in the preface to Böhme, "), _c('i', [_vm._v("“Key")]), _vm._v(","), _c('i', [_vm._v("”")]), _vm._v(" p. 17: “Also the wise Heathens and Jews have hid the deep Ground of Nature under such Words, as having well understood that the Knowledge of Nature is not for every one, but it belongs to those only, whom God by Nature has chosen for it.” In the same work, reference is made to the rabbinic tradition on the Tetragrammaton; see herein ch. 5 n. 70. The kabbalah is invoked with reference to the magical power of the Tetragrammaton and the need to conceal it from the unworthy by Böhme in "), _c('i', [_vm._v("Theosophische Fragen oder 177 Fragen von göttlicher Offenbarung")]), _vm._v(". See Böhme, "), _c('i', [_vm._v("Quaestiones Theosophicae")]), _vm._v(", pp. 286–87 (Böhme, "), _c('i', [_vm._v("Sämtliche Schriften")]), _vm._v(" 9:12–13): “And here we have the wonder-working Word in its operation. For the great name of God TETRAGRAMMATON (JeHoVaH) is here the centre of the wonders of God, and it works in both the central fires. This name the evil spirits, in their transmutation according to the centre of the fire’s nature, do misuse. And the ground of all cabala and magic ["), _c('i', [_vm._v("der Grund der ganzen Cabbala und Magie")]), _vm._v("] is contained in this principle, these being the active powers whereby the imperceptible co-works in the perceptible ["), _c('i', [_vm._v("das Unempfindliche in dem Empfindlichen mitwirket")]), _vm._v("]. And here the law of Moses forbids misusing this principle on pain of eternal punishment, as may be seen in the ten commandments. For our fellow allies enough has been said, and for the godless a strong bar lies before it ["), _c('i', [_vm._v("den Unsern allhie genug gesagt, und den Gottlosen ein Schloß davor")]), _vm._v("]” (translation slightly modified). See Böhme, "), _c('i', [_vm._v("Quaestiones Theosophicae")]), _vm._v(", pp. 298–99 ("), _c('i', [_vm._v("Sämtliche Schriften")]), _vm._v(", 9:21): “For what the angels will and desire is by their imagination brought into shape and forms ["), _c('i', [_vm._v("das wird durch ihre Imaginirung in Bildung und Formen gebracht")]), _vm._v("], which forms are pure ideas ["), _c('i', [_vm._v("eitel Ideen")]), _vm._v("]. In manner as the Divine powers ["), _c('i', [_vm._v("die göttlichen Kräfte")]), _vm._v("] have shaped themselves into such ideas before the creation of the angels, so is their after-modelling ["), _c('i', [_vm._v("Nachmodelung")]), _vm._v("]. And herein lies the holy cabala of changes ["), _c('i', [_vm._v("die heilige Cabbala der Veränderungen")]), _vm._v("], and the great kingdom of joy ["), _c('i', [_vm._v("die grosse Freudenreich")]), _vm._v("], in which the Divine wisdom and knowledge is fashioned and shaped by the spirits of the central fire and light. And there is such a joy of cognition therein, that for great joy and knowledge they bow and humble themselves eternally before such majesty ["), _c('i', [_vm._v("Hoheit")]), _vm._v("], that the No ["), _c('i', [_vm._v("das Nein")]), _vm._v("] may not get the dominion in them, and they be deprived of such glory.” On these passages, see Stoudt, "), _c('i', [_vm._v("Jacob Boehme")]), _vm._v(", p. 89n17; Hessayon, “Boehme’s Life,” p. 31. The influence of the Christian kabbalistic understanding of the Tetragrammaton and its relationship to Jesus seems to be at play in Böhme, "), _c('i', [_vm._v("De Electione Gratiae")]), _vm._v(", pp. 107–8 (Böhme, "), _c('i', [_vm._v("Sämtliche Schriften")]), _vm._v(", 6:88): “From eternity the name Jesus lay in man, viz. in the likeness of God ["), _c('i', [_vm._v("der Gleichnis Gottes")]), _vm._v("], in an immovable love…. Adam before his fall had the divine light from Jehovah, that is, from the one God in which the high name Jesus stood hidden. Not that it was concealed in God, but in the creature, that is to say, in the attraction to the creature.” On Böhme and the kabbalah, see also Martensen, "), _c('i', [_vm._v("Jacob Boehme")]), _vm._v(", pp. 28, 74, 123; Schulze, “Jacob Boehme und die Kabbala”; Scholem, "), _c('i', [_vm._v("Major Trends")]), _vm._v(", pp. 237–38; Llewellyn, “Jacob Boehmes Kosmogonie”; Aubrey, “Influence of Jacob Boehme,” pp. 16, 30, 36–37, 44–45, 281n40, 291n29, 295–96n28; Benz, "), _c('i', [_vm._v("Mystical Sources")]), _vm._v(", pp. 47–58; Schulitz, "), _c('i', [_vm._v("Jakob Böhme und die Kabbalah")]), _vm._v("; Häussermann, “Theologia Emblematica”; Huber, “Die Kabbala”; Weeks, "), _c('i', [_vm._v("Boehme")]), _vm._v(", pp. 30, 43 (the author presumes without producing any evidence that Böhme could "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("have learned kabbalistic doctrines from Judah Loew ben Bezalel, the Maharal of Prague, during his visit to Görlitz, a hypothesis that I find highly improbable because of the Maharal’s reluctance to expose esoteric doctrines openly even to coreligionists), 106, 116, 147, 200, 204–5; Janz, “Jacob Boehme’s Theory,” pp. 77–79, 194–95; Edel, “Kabbala in der Theosophie Jacob Böhmes”; Edel, "), _c('i', [_vm._v("Die Individuelle Substanz bei Böhme und Leibniz")]), _vm._v("; Edel, “Métaphysique des idées et mystique des lettres”; O’Regan, "), _c('i', [_vm._v("Gnostic Apocalypse")]), _vm._v(", pp. 193–209; Schmidt-Biggemann, “Jakob Böhme und die Kabbala”; Stoudt, "), _c('i', [_vm._v("Jacob Boehme")]), _vm._v(", pp. 22, 88, 89n17, 96, 115; Rusterholz, “Elemente der Kabbala bei Jacob Böhme”; Kaennel, “Protestantisme et cabale,” pp. 193–95; O’Donnell, “Böhme and Hegel,” pp. 30–31; Böhme, "), _c('i', [_vm._v("Aurora")]), _vm._v(", pp. 43–44. See my own modest contribution to this question in Wolfson, "), _c('i', [_vm._v("Language")]), _vm._v(", pp. 8, 197, 471n435, 485–86n180, and references to other scholars cited on pp. 423n259 and 468n392; and more fully in Wolfson, “Holy Cabala.” Weeks, "), _c('i', [_vm._v("Boehme")]), _vm._v(", p. 30, identifies Balthasar Walter, an acquaintance and fellow traveler of Böhme, as a possible conduit through which he may have learned kabbalistic doctrines. Compare Bailey, "), _c('i', [_vm._v("Milton and Jakob Boehme")]), _vm._v(", p. 96. In more detail, see Penman, “A Second Christian Rosencreuz?” On the more specific relationship between Böhme and Christian kabbalah, see Weeks, "), _c('i', [_vm._v("Boehme")]), _vm._v(", p. 205; Schmidt-Biggemann, “Christian Kabbala”; Schmidt-Biggemann, "), _c('i', [_vm._v("Philosophia Perennis")]), _vm._v(", pp. 117–28, 187–92; Penman, “Boehme’s Intellectual Networks,” pp. 66–71. Let me note, finally, that despite Böhme’s attraction to and appropriation of kabbalistic theosophy, one can predictably discover in his published work negative comments about Judaism. For example, see Böhme, "), _c('i', [_vm._v("Aurora")]), _vm._v(", p. 663: “This is why God gave the law to the Jews, so that they should cultivate all gentleness and holiness and love that the entire world might find a mirror in them. But when they instead fell into pride and boasted of their birth rather than of love and turned the law of love into a blade of anger, God thrust the light from them and turned to the heathens instead.” In the same treatise, Böhme avails himself of the well-known anti-Semitic trope of the blind Jew (in some passages the blindness is attributed as well to the Turk and the heathen). See Böhme, "), _c('i', [_vm._v("Aurora")]), _vm._v(", pp. 131, 163, 263, 319, 321, 323, 325, 661. In one passage, Böhme insists that Christian, Jew, Turk, and heathen are all equally capable of overcoming the pernicious effect of the devil ("), _c('i', [_vm._v("Aurora")]), _vm._v(", p. 383), but the ostensible egalitarianism does not alleviate the derogatory comments that distinguish the Christian from the other three types of human beings. Compare Böhme, "), _c('i', [_vm._v("High and Deep")]), _vm._v(", pp. 224–25. After stating categorically that God wills to save all people who are lost, Böhme takes the following jab at the Jewish dietary law: “Dost thou know why God did forbid the "), _c('i', [_vm._v("Jews")]), _vm._v(" to eat of "), _c('i', [_vm._v("some sort of flesh")]), _vm._v("? Kindle their fat, and consider their property, and thou shalt discern it” (emphasis in original). See Böhme, "), _c('i', [_vm._v("High and Deep")]), _vm._v(", p. 239, where the Pharisees are labeled the “ministers of the dragon,” that is, servants of the devil in his lies, who pretended to be the “ministers of God.” The historical circumstances of Heidegger and Böhme are very different, and hence one must be wary of simplistic comparisons, but with respect to this point there is a valid analogy: it is possible for a thinker to be influenced, directly or indirectly, by a tradition, while at the same time maligning the people who sociologically uphold that tradition.")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn96"
    }
  }, [_vm._v("96")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings II–VI")]), _vm._v(", p. 24 ("), _c('i', [_vm._v("Überlegungen II–VI")]), _vm._v(", p. 32): “Why do eager reviewers and writers so uniformly and definitely "), _c('i', [_vm._v("shirk")]), _vm._v(" when it comes to the decisive treatise, ‘On the Essence of Ground’? "), _c('i', [_vm._v("Enough already here")]), _vm._v(" with the reckoning up of ‘influences’ and of the dependencies on Husserl, Dilthey, Kierkegaard, and whoever. Here the task was—if anything—to put into effect a confrontation ["), _c('i', [_vm._v("Auseinandersetzung")]), _vm._v("] with antiquity and with the retrieved problem of being. Instead of which, manifest prattle ["), _c('i', [_vm._v("Geschwätz")]), _vm._v("] keeps piling up from week to week” (emphasis in original). Heidegger does not deny the relevance of the matter of influence when examining masters of thought, but he insists that what is important to comprehend is the “peculiarity” ("), _c('i', [_vm._v("eigene Sache")]), _vm._v(") of the influence and not merely to gossip about the repetition of a “general opinion” ("), _c('i', [_vm._v("allgemeinen Meinung")]), _vm._v(") that is “rootless and homeless” ("), _c('i', [_vm._v("wurzel- und heimatlose")]), _vm._v("). The latter amounts to nothing but idle talk ("), _c('i', [_vm._v("Gerede")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_97"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn97"
    }
  }, [_vm._v("97")]), _vm._v(". On the gnostic resonances in Heidegger’s thought, perhaps even constituting an esoteric form of Christian gnosis in polemical conflict with mainstream Christian theology, see Taubes, “Gnostic Foundations,” p. 157 (cited partially in ch. 4 at n. 60). Also relevant is the thesis of Sacchi, "), _c('i', [_vm._v("Apocalypse of Being")]), _vm._v(". According to Sacchi, the esotericism in Heidegger is connected to his view that being is disclosed not through logical analysis or discursive thinking but through an "), _c('i', [_vm._v("experience of affective connaturality")]), _vm._v(" (p. 127) that is a form of poetic mysticism predicated on the abandonment of reason (p. 137). Sacchi’s thesis is summarized as follows: “Led by Hölderlin’s hands, Heidegger ended up by confusing philosophy with an erratic dithyramb in order to think about things and "), _c('i', [_vm._v("Sein")]), _vm._v(" in the midst of the darkness of a language in which the esoteric gnosticism always comes together with the unintelligibility of ravings” (p. 133). On the attempt to locate the source of Heidegger’s philosophizing in an esoteric experience, related especially to his avoidance for public discourse, see Trawny, "), _c('i', [_vm._v("Adyton")]), _vm._v(". Parallels between Heidegger’s ontology articulated in "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(" and ancient Gnostic sources were noted by Jonas, "), _c('i', [_vm._v("Gnosis und spätantiker Geist")]), _vm._v(", 1:90–91, 107–8, and 2:7, 359–79; Jonas, “Gnosticism and Modern Nihilism,” pp. 441–42, 445, 449–50; Jonas, "), _c('i', [_vm._v("Gnostic Religion")]), _vm._v(", pp. 62–65, 320–40 (the epilogue “Gnosticism, Existentialism, and Nihilism” is reprinted in Jonas, "), _c('i', [_vm._v("Phenomenon of Life")]), _vm._v(", pp. 211–34); and see the analysis of Levy, "), _c('i', [_vm._v("Hans Jonas")]), _vm._v(", pp. 25–30. The impact of Heidegger on Jonas’s study of Gnosticism is discussed in several essays in Tirosh-Samuelson and Wiese, eds., "), _c('i', [_vm._v("Legacy of Hans Jonas")]), _vm._v(": Hösle, “Hans Jonas’s Position,” pp. 30–31; Brumlik, “Resentment”; Rudolph, “Hans Jonas,” pp. 97, 103–5; Lazier, “Pauline Theology.” See also Jakob, "), _c('i', [_vm._v("Martin Heidegger und Hans Jonas")]), _vm._v("; Wolin, "), _c('i', [_vm._v("Heidegger’s Children")]), _vm._v(", pp. 101–33; Wiese, “‘Revolt Against Empiricism.’” On Heidegger and Gnosticism, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("see Baum, "), _c('i', [_vm._v("Gnostische Elemente")]), _vm._v("; Slattery, “Augustine, Heidegger, and Gnosticism.” The relationship between Heidegger and Gnosticism is explored from a standpoint of archetypal psychology in Avens, "), _c('i', [_vm._v("New Gnosis")]), _vm._v(". And see herein ch. 4 n. 61.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_98"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn98"
    }
  }, [_vm._v("98")]), _vm._v(". See above, n. 94. On Heidegger’s interest more generally in medieval mysticism, including Eckhart, as part of a youthful attempt to formulate a philosophical theology, see McGrath, "), _c('i', [_vm._v("Early Heidegger")]), _vm._v(", pp. 120–50.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "intfn_99"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn99"
    }
  }, [_vm._v("99")]), _vm._v(". Especially relevant is the fact that Silesius became acquainted with the works of Böhme, perhaps through his camaraderie with Abraham von Franckenberg, one of Böhme’s nobleman friends. See Rusterholz, “Elemente christlicher Kabbala,” pp. 194–97. Compare the passage from Baader, which seeks to sum up Böhme’s teaching on the mystical nature of God in the vein of Angelus Silesius, cited by Scholem, "), _c('i', [_vm._v("Major Trends")]), _vm._v(", p. 405n109.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_100"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn100"
    }
  }, [_vm._v("100")]), _vm._v(". Nietzsche, "), _c('i', [_vm._v("Gay Science")]), _vm._v(", §228, p. 145.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn101"
    }
  }, [_vm._v("101")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("What Is Called Thinking?")]), _vm._v(", p. 91; "), _c('i', [_vm._v("Was Heißt Denken")]), _vm._v("?, p. 95.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_102"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn102"
    }
  }, [_vm._v("102")]), _vm._v(". I have elaborated on this theme in Wolfson, “Not Yet Now,” pp. 156–80. On the conceptual convergence and divergence between Benjamin and Heidegger, see the evidence adduced in Wolfson, “Not Yet Now,” pp. 159–60n122, and the studies in Benjamin and Vardoulakis, eds., "), _c('i', [_vm._v("Sparks Will Fly")]), _vm._v(", esp. Schwebel, “Monad and Time,” and Benjamin, “Time and Task.” Also relevant is the essay by Wenning, “Adorno, Heidegger, and the Problem of Remembrance.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_103"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn103"
    }
  }, [_vm._v("103")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §242, p. 303; "), _c('i', [_vm._v("Beiträge")]), _vm._v(", pp. 383–84.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_104"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn104"
    }
  }, [_vm._v("104")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("What Is Called Thinking?")]), _vm._v(", p. 12; "), _c('i', [_vm._v("Was Heißt Denken?")]), _vm._v(", p. 15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_105"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn105"
    }
  }, [_vm._v("105")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Introduction to Philosophy")]), _vm._v(", p. 43; "), _c('i', [_vm._v("Einleitung in die Philosophie")]), _vm._v(", p. 138.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_106"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn106"
    }
  }, [_vm._v("106")]), _vm._v(". Derrida, "), _c('i', [_vm._v("On the Name")]), _vm._v(", p. 35. See the passages from Derrida cited herein in ch. 8 at nn. 220–22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_107"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn107"
    }
  }, [_vm._v("107")]), _vm._v(". Burik, "), _c('i', [_vm._v("End of Comparative Philosophy")]), _vm._v(". The approach I have taken is consonant with the observation of Lapidot, “People of Knowers,” p. 273, that the configuration of “Heidegger and Jewish Thought” must be pursued “both as a conjunction and as an opposition.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn108"
    }
  }, [_vm._v("108")]), _vm._v(". Nelson, "), _c('i', [_vm._v("Chinese and Buddhist Philosophy")]), _vm._v(", p. 252: “Heidegger’s articulation of philosophy, language, and existence in relation to the nothing and its own questionability … is pertinent to the intercultural hermeneutics that would think with and beyond his art of interpretation; we too must face our limits and finitude…. One systematizing meta-language from which different encounters with the nothing and emptiness could be categorized and systematized is lacking. There is only the space and the silence in which encounters occur and are missed. As Heidegger indicated in his dialogue with a Japanese visitor, genuine understanding cannot mean the erasure of what is singular and unique; words allow for each to be granted its own appropriate due and measure. We ought to be accordingly cautious and reticent in claiming that we understand the other and that which we do not and perhaps cannot understand.” The methodological underpinning of Nelson’s claim that the comparison of Heidegger’s "), _c('i', [_vm._v("Denkweg")]), _vm._v(" to patterns of thinking culled from Asian sources requires noting both congruence and incongruence supports the more deconstructive analysis proffered by Ma, “Mysterious Relations to the East.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_109"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn109"
    }
  }, [_vm._v("109")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Fundamental Concepts")]), _vm._v(", p. 178 (translation modified); "), _c('i', [_vm._v("Grundbegriffe")]), _vm._v(", p. 264. And compare the articulation in the preliminary considerations for the lecture course given in the winter semester 1931–32 at the University of Freiburg, published in Heidegger, "), _c('i', [_vm._v("Essence of Truth")]), _vm._v(", p. 1 ("), _c('i', [_vm._v("Vom Wesen der Wahrheit")]), _vm._v(", p. 1): “But we discover what is universal to "), _c('i', [_vm._v("all")]), _vm._v(" only by comparing "), _c('i', [_vm._v("particular")]), _vm._v(" things and observing the sameness of what they have in common” (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_110"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn110"
    }
  }, [_vm._v("110")]), _vm._v(". See the analysis in Seppi, “‘Wenn einer immerfort dasselbe sagt […],’” pp. 67–77.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_111"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn111"
    }
  }, [_vm._v("111")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Identity and Difference")]), _vm._v(", p. 45; German text: p. 111. Compare Heidegger, "), _c('i', [_vm._v("Poetry, Language, Thought")]), _vm._v(", pp. 218–19; "), _c('i', [_vm._v("Vorträge und Aufsätze")]), _vm._v(", pp. 196–97.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_112"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn112"
    }
  }, [_vm._v("112")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Country Path Conversations")]), _vm._v(", p. 25; "), _c('i', [_vm._v("Feldweg-Gespräche")]), _vm._v(", p. 39. For discussion of this theme, see “Translator’s Foreword,” in "), _c('i', [_vm._v("Country Path Conversations")]), _vm._v(", pp. xiv–xv.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_113"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn113"
    }
  }, [_vm._v("113")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Pathmarks")]), _vm._v(", p. 309; "), _c('i', [_vm._v("Wegmarken")]), _vm._v(", p. 409.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_114"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn114"
    }
  }, [_vm._v("114")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Discourse on Thinking")]), _vm._v(", p. 53; "), _c('i', [_vm._v("Gelassenheit")]), _vm._v(", p. 22.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn115"
    }
  }, [_vm._v("115")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Principle of Reason")]), _vm._v(", pp. 89–90; "), _c('i', [_vm._v("Satz vom Grund")]), _vm._v(", p. 133. The inherent futurity of the Heideggerian sensibility about the unsaid of what has been said and the unthought of what has been thought is expressed poetically by Bigelow, "), _c('i', [_vm._v("Conning")]), _vm._v(", p. xv: “Philosophy is written correctly when it comes out both stillborn and posthumous: it is finished before the author has yet to begin, and it is begun after the author has come to an end.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_116"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn116"
    }
  }, [_vm._v("116")]), _vm._v(". Schelling, "), _c('i', [_vm._v("System of Transcendental Idealism")]), _vm._v(", p. 51 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_117"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn117"
    }
  }, [_vm._v("117")]), _vm._v(". Ibid., p. 230.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn118"
    }
  }, [_vm._v("118")]), _vm._v(". Ibid., p. 72. My understanding of Schelling’s idea of indifference and the implied interconnectivity "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("of opposites predicated on their irreducible autonomy raises questions about the claim of Bielik-Robson, “Between Unity and Chaos,” that while Schelling remained beholden to a dialectical resolution of the “original contradiction” of opposites within God, Rosenzweig created a narrative based on a “non-antithetical sequence” such that the Yes and the No are never rigidly opposed. I concur with Bielik-Robson’s interpretation of Rosenzweig, but it strikes me that Schelling’s critique of Hegel, and his affirmation of indifference—a notion likely indebted to kabbalistic symbolism mediated through Böhme—suggests that he, too, thought that the antithesis or contradiction in the primordial beginning must be based on a doubling that entails a sequential rather than a dialectical movement between opposites. If this were not the case, the one could never become two. Schelling proffers that the Godhead is indivisibly and concurrently the eternal Yes and the eternal No, and hence the symbolic notation for the two forces, which act with free unity within the divine, is A + B. See the texts of Schelling cited and discussed in ch. 5 at nn. 103–5, 112–14. And consider the explanation of indifference in Schelling, "), _c('i', [_vm._v("Statement on the True Relationship of the Philosophy of Nature")]), _vm._v(", p. 95 ("), _c('i', [_vm._v("Darlegung des wahren Verhältnisses der Naturphilosophie")]), _vm._v(", in Schelling, "), _c('i', [_vm._v("Sämmtliche Werke")]), _vm._v(", 7:106–7): “One posits, for example, that if someone were to claim that Herr Fichte and Fr[iedrich] Nicolai are most intimately related to one another and at bottom fully in agreement ["), _c('i', [_vm._v("im Grunde völlig einig sehen")]), _vm._v("], he would seem to have uttered a great paradox. One employs for this relationship the word polarity, and everything is clear. For one sees how despite the most direct opposition, both are one in terms of their foundation ["), _c('i', [_vm._v("beide der innersten Grundlage nach dennoch eins sind")]), _vm._v("] and how they, represented as the two flammable types of gases, Herr Fichte as oxygen, Nicolai as hydrogen, in their mutual penetrations and depotentiation ["), _c('i', [_vm._v("in der gegenseitigen Durchdringung und Depotenzirung")]), _vm._v("] must produce pure indifference ["), _c('i', [_vm._v("die reine Indifferenz")]), _vm._v("], the true water of our age.” Already in this work, published in 1806, Schelling deployed a relatively simply example—the antagonism of Fichte and Nicolai, and their symbolic correlation with oxygen and hydrogen—to illustrate that indifference involves the paradox of polarity, that is, two opposing forces that are, at the same time, in full agreement—just as the clashing gases combine to produce water. In my judgment, Schelling’s "), _c('i', [_vm._v("Indifferenz")]), _vm._v(" served as the basis for Heidegger’s "), _c('i', [_vm._v("Zusammengehörigkeit")]), _vm._v(", the belonging together of contraries in the sameness of their difference, a notion that bears affinity to Rosenzweig’s insight regarding the conjunctive “and” that bridges the Yes and the No, the two root words that have an immediate relationship to the Nothing. Rosenzweig explicitly contrasts his perspective with the idealist synthesis, but his assertion that the original character of the No is equivalent to that of the Yes was already anticipated by Schelling. See Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", pp. 246–47; "), _c('i', [_vm._v("Stern der Erlösung")]), _vm._v(", pp. 255–56.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_119"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn119"
    }
  }, [_vm._v("119")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Identity and Difference")]), _vm._v(", p. 29; German text: p. 92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_120"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn120"
    }
  }, [_vm._v("120")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Identity and Difference")]), _vm._v(", p. 29; German text: p. 92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_121"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn121"
    }
  }, [_vm._v("121")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Identity and Difference")]), _vm._v(", p. 27; German text: p. 90. A more standard translation of the Parmenidean fragment is offered by Freeman, "), _c('i', [_vm._v("Ancilla")]), _vm._v(", p. 42: “For it is the same thing to think and to be.” Regarding this Parmenidean dictum, see the more extensive analysis in Heidegger, "), _c('i', [_vm._v("Introduction to Metaphysics")]), _vm._v(", pp. 145–55; "), _c('i', [_vm._v("Einführung in die Metaphysik")]), _vm._v(", pp. 145–55. See ch. 1 n. 17. Also relevant is the second dictum attributed to Parmenides, ταὐτὸν δ’ ἐστί νοεῖν τε καὶ οὕνεκέν ἐστί νόημα (Fragment 8.34), rendered by Freeman, "), _c('i', [_vm._v("Ancilla")]), _vm._v(", p. 44: “To think is the same as the thought that It Is,” which is to say, as the continuation of the aphorism makes clear, without what is, that is, being, there is no thought, and hence thinking and that of which there is thinking are one and the same. See Cordero, "), _c('i', [_vm._v("By Being")]), _vm._v(", pp. 81n339, 86–87. Compare the interpretation of the Parmenidean teaching as an insight into the essence of "), _c('i', [_vm._v("phusis")]), _vm._v(" in Heidegger, "), _c('i', [_vm._v("Introduction to Metaphysics")]), _vm._v(", p. 148 ("), _c('i', [_vm._v("Einführung in die Metaphysik")]), _vm._v(", p. 147): “apprehension and that for the sake of which apprehension happens are the same. Apprehension happens for the sake of Being. Being essentially unfolds as appearing, as stepping into unconcealment, only if unconcealment happens, only if a self-opening happens.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_122"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn122"
    }
  }, [_vm._v("122")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Identity and Difference")]), _vm._v(", p. 27; German text: p. 90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_123"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn123"
    }
  }, [_vm._v("123")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Pathmarks")]), _vm._v(", p. 240; "), _c('i', [_vm._v("Wegmarken")]), _vm._v(", p. 316.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_124"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn124"
    }
  }, [_vm._v("124")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Pathmarks")]), _vm._v(", p. 241; "), _c('i', [_vm._v("Wegmarken")]), _vm._v(", pp. 314–15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_125"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn125"
    }
  }, [_vm._v("125")]), _vm._v(". See the studies by Babich: “Heidegger’s Jews,” pp. 134–35, and “Heidegger’s "), _c('i', [_vm._v("Judenfrage")]), _vm._v(".” I concur with the assessment of Lapidot, “People of Knowers,” p. 269: “At some moments in the current controversy regarding Heidegger’s anti-Semitism, the notion of ‘Jewish thought’ seems even to be the controversial notion itself. As indicated in the introduction to this volume, one paradox or ambivalence in the current debate is that accusing the philosopher of ‘"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("anti-Semitism’ very often means accusing him not so much of philosophizing "), _c('i', [_vm._v("against")]), _vm._v(" Jews, but of philosophizing Jews at all. This ambivalence is perhaps constitutive for an entire discursive configuration of critique of anti-Semitism, so to speak a discourse of anti-anti-Semitism. The fundamental ambivalence of the anti-anti-Semitic discourse consists in countering anti-Semitism in philosophy by precluding the Jewish from philosophy or thought altogether, a preclusion which at some critical moments risks reproducing anti-Semitic discourse itself” (emphasis in original).")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_126"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn126"
    }
  }, [_vm._v("126")]), _vm._v(". This is hardly unique to Heidegger, as we find other thinkers who avowed explicit anti-Semitic views but who were nevertheless influenced by Jewish ideas, including kabbalistic motifs and symbols. See my comments about Böhme in the concluding part of n. 95 above, and consider the account of the anti-Semitic strain in Paracelsus, which attracted the admiration of German nationalists and ideologues in the Nazi period, in Weeks, "), _c('i', [_vm._v("Paracelsus")]), _vm._v(", p. 132. See also the remark of Franks, “Fichte’s Kabbalistic Realism,” p. 92: “Fichte is notorious for his role in the development of virulent anti-Semitism, including his opposition to Jewish civil rights. This may be thought—quite wrongly—to preclude the deployment of kabbalistic resources in his philosophy and especially in his account of reciprocal recognition.” The same logic can be imputed to Heidegger, although in his case there is less recognition of the channels of influence.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_127"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn127"
    }
  }, [_vm._v("127")]), _vm._v(". In previous publications, I have pointed out that, with respect to these issues, there is no appreciable difference between kabbalists across the generations. I have found no kabbalist who would not subscribe to the privileged status of Hebrew as the matrix language of creation and the superior status of the Jewish people and the land of Israel that derives from that assumption. See Wolfson, "), _c('i', [_vm._v("Language")]), _vm._v(", pp. 197–205.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_128"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn128"
    }
  }, [_vm._v("128")]), _vm._v(". In this orientation, Heidegger follows the main lines of nineteenth-century German philology based on the linkage between language and national identity. For a comprehensive study of this topic, see Benes, "), _c('i', [_vm._v("In Babel’s Shadow")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "intfn_129"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#intfn129"
    }
  }, [_vm._v("129")]), _vm._v(". Krell, “Heidegger’s "), _c('i', [_vm._v("Black Notebooks")]), _vm._v(",” p. 135. See as well Krell, "), _c('i', [_vm._v("Ecstasy")]), _vm._v(", and Krell, “Troubled Brows.”")])])])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "1. Hermeneutic Circularity: Tradition as Genuine Repetition of Futural Past"
    }
  }, [_c('p', {
    staticClass: "h2-cn"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253042569_Contents#ch1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253042569_Contents#ch1"
    }
  }, [_vm._v("Hermeneutic Circularity")])]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253042569_Contents#ch1"
    }
  }, [_c('i', [_vm._v("Tradition as Genuine Repetition of Futural Past")])])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("The "), _c('i', [_vm._v("eternal")]), _vm._v("—what the genuinely and always existing being is—has foolishness for its essential characteristic; the eternal—“the world”—is therefore continually outstripped and masked, for itself, by itself, and on account of its essential semblance; it continually overcomes “truth” in the sense of the fixed, but it cannot persist in its "), _c('i', [_vm._v("overflowing")]), _vm._v(" without securing at the same time the means of existence for the new appearance, which in turn will overcome it. And "), _c('i', [_vm._v("what")]), _vm._v(" does all this mean? That the world excludes itself from truth, where truth is now after all understood as the pure correspondence of representation to the real.")]), _vm._v(" "), _c('p', {
    staticClass: "epi1"
  }, [_vm._v("Heidegger, "), _c('i', [_vm._v("Interpretation of Nietzsche’s Second Untimely Meditation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The analysis of Heidegger and kabbalah will commence with an examination of the question of tradition as it relates to the intricate interplay of novelty and repetition that is grounded in the principle of hermeneutical circularity—the recurrence of that which always never was—and the related understanding of time as a linear circle. By way of introducing the intricate theme of dynamism and stasis in the respective paths of Heideggerian and kabbalistic thought, let me offer two preliminary procedural stipulations that will establish hermeneutical criteria essential to the method I shall pursue in this monograph. First, my commitment to the proposition that Heidegger is an effective prism through which to examine kabbalistic material and that the kabbalistic material is an effective prism through which to examine Heidegger does not mean that I am suggesting this is the only, or even the best, theoretical template to do this work. There is no overt or clandestine petition that the use of Heidegger by scholars of kabbalah be mandatory. Needless to say, the postmodern preference prejudices us against thinking that one explanatory tool is either necessary or sufficient. Axiomatically, I accept this disavowal of axiom. Nevertheless, long ago, I set my task as a scholar to read the texts of Jewish mysticism through philosophical interpretive lenses, and the one that has seemed most applicable and productive for me has been Heidegger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Second, over the years I have been criticized either for espousing an essentialism or for offering statements of a categorical nature in my analysis of kabbalistic sources. In an effort to discredit my claims, appeal has been made to multivocality—and, in some cases, to Derridean "), _c('i', [_vm._v("différance")]), _vm._v(", the emphasis on differing and deferring, a privileging of indeterminacy and almost unlimited potential for meaning"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn1",
      "id": "ch1fn_1"
    }
  }, [_vm._v("1")])]), _vm._v("—but the appeal to multivocality fails to comprehend that my approach is pliable enough to satisfy both the essentialist contention that there are structures and patterns of thought that we can identify as enduring and the constructivist argument that these structures and patterns are always shifting in accord with "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("ever-changing historical conditions. In various publications, I have emphasized that the propensity to partition matters in this way is subject to a logical fallacy that leads invariably to self-implosion: the veracity of the historicist presumption that meaning is always to be determined from context cannot be sufficiently generalized to justify the argument for contextualization. That is, without the ability to step out of context, we could not cultivate the cognitive apparatus necessary to detect the parameters of any context. A perspectivism predicated on an antinomic schism between the predictability of the universal and the unpredictability of the particular cannot be cogently affirmed without negating itself, since every statement avowing the relativity of perspective is subject to the criterion of perspective. Hence, to state unreservedly that we cannot discover truth can be true only if it is false, but it cannot be false unless it is true."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn2",
      "id": "ch1fn_2"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Homogeneity and Heterogeneous Fluctuation")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As one who is sympathetic to both deconstruction and postmodernism, not only do I not eschew the call for pluralistic interpretation as an advantageous explanatory tactic, but I would go so far as to say that the heuristic contrivance of univocality is audible only through the chorus of plurivocality—there is no monological speech that is not in truth dialogical. This conviction regarding what Derrida called the interlocution of the plurality of voices"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn3",
      "id": "ch1fn_3"
    }
  }, [_vm._v("3")])]), _vm._v(" does not discount the possibility of identifying unifying conceptual schemes and symbolic structures. A spurious dichotomy has prevailed in recent scholarship on the kabbalah in particular, and on the phenomenon of mysticism more generally, which is based on essentializing the effort to demarcate resemblance from within disparity as a form of essentialism. Despite the bluster in defending an ostensibly polyvalent hermeneutic—in fact, the insistence on polyvalence, I regret to say, can often be a ploy to cloak hegemony—the argument is specious. There is no compelling reason to separate heterogeneity and homogeneity; epistemically, the latter is detectable only against the backdrop of the former. As Jean-Luc Nancy reminds us of this commonsensical point too often obscured by the haze of political correctness, “difference is not the opposite of identity; for difference is what makes identity possible, and by inscribing this possibility at the heart of identity, it exposes it to this: that its meaning cannot be identical to it. We are our identity, and "), _c('i', [_vm._v("we")]), _vm._v(" designates—once again, in the simultaneous and undecidable reference to our ‘singularities’ and our ‘community’—an identity that is necessarily shared out, in us and between us. Difference takes place in this sharing, at once a distribution of meaning into all significations and a withdrawal of meaning from all signification—a withdrawal that each signification indicates, at the limit.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn4",
      "id": "ch1fn_4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even from a neuroscientific standpoint, the cerebral coding of information precludes positioning the homogeneous and the heterogeneous in binary opposition—we could not recognize deviation empirically without hypothesizing stability ideationally. Expressed somewhat more technically, syncretic processing is assigned to the right hemisphere of the brain and the diacritic processing to the left hemisphere; the activity of signifying—a cornerstone of our cogitative and linguistic aptitude as thinking beings—involves interaction between the two on the basis of what is referred to as a “bimodal reticulation of similarities and differences.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn5",
      "id": "ch1fn_5"
    }
  }, [_vm._v("5")])]), _vm._v(" Insofar as the brain discerns that things resemble one another only when it perceives that they are inconsonant, we can postulate more abstractly that discrimination facilitates the detection of correspondence. In the words of William J. Clancey, essential to the “architecture of memory and learning” are the ideas of systematicity and compositionality. These ideas “suggest the existence of rule-like pattern comprehension and generation,” which “result from categorization of sequences … with later reactivation of sequences admitting substitution of subsequences and couplings. The processes of temporal sequencing, substitution, ongoing generalization, and compositional reconstruction provide an explanation of "), _c('i', [_vm._v("productivity")]), _vm._v(", roughly, the ability to understand and produce relatively unbounded expressions from finite means. Most important, the architecture must be such that "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("conceptual structures form without an executive assembly process that interprets a descriptive language of features, parts, types, orderings, semantic associations, and so on. The process of constructing categories, sequences, and compositions of them is the ‘language’ of thought—although at this level, it can only be a poetic use of the word.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn6",
      "id": "ch1fn_6"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some have argued that memory is not to be conceived as “one homogeneous function,” but rather as “split into different subfunctions and subprocesses.” It must be considered, therefore, an “umbrella concept that covers heterogeneity of different functions and processes associated with different neural mechanisms and regions in the brain. Accordingly, what appears to be homogeneous on the conceptual level, turns out to be heterogeneous in neuronal, empirical terms.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn7",
      "id": "ch1fn_7"
    }
  }, [_vm._v("7")])]), _vm._v(" One could counter, however, that experiential variation cannot be appreciated without the presumption of conceptual uniformity. Similarly, the scholarly task to mark difference can be executed only if some degree of sameness is presumed; indeed, it is the different sameness that engenders the same difference. If it is true that the same is the same in virtue of the other, then it is correspondingly true that the other is other in virtue of the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The positing of recurrent patterns does not disallow diversity by ignoring specific details and historical changes that would account for plurality. In line with François Laruelle, I would argue that thinking from the perspective of a principle of unification—what he calls the One—implies generic fluctuation rather than systematic totalization; that is to say, the general is rooted in and must always be tested against the unassimilability of the particular."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn8",
      "id": "ch1fn_8"
    }
  }, [_vm._v("8")])]), _vm._v(" The deployment of repeated structures in the study of kabbalistic doctrine and practice does not imply that this variegated history should be subsumed monolithically under the stamp of immutable essences. As a religious phenomenon, kabbalism illustrates that the immutability of system occasions diverse interpretation, even to the point that, as we shall see, the feasibility of system may itself be called into question."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn9",
      "id": "ch1fn_9"
    }
  }, [_vm._v("9")])]), _vm._v(" In the indigenous wisdom of the tradition, something is new if it is old but it is old if it is new. The polysemy at play in these texts, therefore, indicates the vacillating tension between the novelty that repeats and the repetition that is novel. The inflexible bifurcation of innovation and conservation, which has dominated the academic approach to the study of kabbalah, can be avoided if we accept the dialetheic repudiation of the law of noncontradiction based on the assumption that the identification of opposites in the identity of their opposition yields a genuine and irresolvable contradiction; that is, the truth of a statement that presumes the paradoxical form α and ¬α, which translates into the disjunctive syllogism "), _c('i', [_vm._v("if it is the case that α, then it is not the case that α")]), _vm._v(", is a direct reproach of the more prevalent logic that for every statement either α or ¬α is true but both cannot be true at the same time and in the same relation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn10",
      "id": "ch1fn_10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With this shift in orientation in mind, we can attempt to understand the substratal presupposition of the hermeneutical axiology and the conception of time as a linear circularity based thereon. I have expounded this conundrum in many of my publications by noting that despite the wide diversity that characterizes kabbalistic productivity, it is possible to identify a common thread that ties together the masters of the esoteric wisdom through the centuries: the assumption under which they have labored—and continue to labor—is that the truth already spoken is always yet to be spoken, that the ancient saying may be envisioned as novel to the degree that the novel saying is envisioned as ancient. The chain of tradition is thus constituted by the endlessly distended moments, which should not be envisaged mathematically as spatially discrete points strung together and unified by an internal time consciousness, but rather as the mythopoeic instantiations of an infinitely protracted torrent that implements the eternal reappearance of the same, which is to say, the indefatigable duplication of difference.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The hermeneutical circle that enframes both kabbalistic speculation and Heidegger’s thinking is marked by the following temporal paradox: each moment is steadfastly the same because irresolutely different, and hence, originality is construed as the recovery of an archaic truth that is repeatedly discovered as what has not yet been uncovered."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn11",
      "id": "ch1fn_11"
    }
  }, [_vm._v("11")])]), _vm._v(" Commenting on Heidegger’s description and existential "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("grounding of the hermeneutic circle in the anticipatory movement of the ontological structure of the fore-understanding, Hans-Georg Gadamer wrote:")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The circle, then, is not formal in nature. It is neither subjective nor objective, but describes understanding as the interplay of the movement of tradition and the movement of the interpreter. The anticipation of meaning that governs our understanding of a text is not an act of subjectivity, but proceeds from the commonality that binds us to the tradition. But this commonality is constantly being formed in our relation to tradition. Tradition is not simply a permanent precondition; rather, we produce it ourselves inasmuch as we understand, participate in the evolution of tradition, and hence further determine it ourselves."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn12",
      "id": "ch1fn_12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Parenthetically, I would add that a judicious understanding of Derridean deconstruction leads us to the same conclusion, and with respect to this issue, as we see from the following depiction of his own writing performance, Derrida may be most kabbalistic or, if one prefers, most Heideggerian: “Every time I write something, I have the impression of making a beginning—but in fact that which is the same in texture is ceaselessly exposed to a singularity which is that of the other.… Everything appears anew: which means newness and repetition together.… In the actual writing, of course, I’m well aware of the fact that at bottom it all unfolds according to the same law that commands these always different things.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn13",
      "id": "ch1fn_13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The comment leaves little room for opacity or obscurity: everything must appear as new but newness is unintelligible without the presumption of repetition, the aspect of deconstruction that Derrida calls “paleonymy,” that is, “the using of an old word—a "), _c('i', [_vm._v("paleo")]), _vm._v(", a very old word—or the preserving of an old word precisely where the signification of this very word has awoken or woken up to "), _c('i', [_vm._v("something else")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn14",
      "id": "ch1fn_14"
    }
  }, [_vm._v("14")])]), _vm._v(" Writing proceeds in accord with the dynamic of "), _c('i', [_vm._v("the same law commanding things that are always different")]), _vm._v(". The chronicling of history as a meaningful construct—in contrast to the metaphysical concept of history that is linked to linearity and an entire system of implications about teleology, eschatology, accumulation of meaning, traditionality, and continuity—implies a logic of repetition whereby the trace marks the recurrence of the similar that is entirely dissimilar."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn15",
      "id": "ch1fn_15"
    }
  }, [_vm._v("15")])]), _vm._v(" This is precisely what is implied by the etymological denotation of kabbalah as the transmission of received tradition, the selfsame wisdom persistently engendering things divergently. What I espouse, therefore, is not an essentialism that silences discord, but rather a hermeneutic that turns on the paradox that the invariable is the condition that stimulates variance. In the interpretive praxis of scholar and practitioner alike, identity and difference are not mutually exclusive; they well forth from the spot where the original is perpetually disparate and the disparate provisionally original.")]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Origin and the Impossibility of Beginning the Beginning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It will be beneficial to digress briefly and consider David Leahy’s notion of "), _c('i', [_vm._v("thinking now occurring")]), _vm._v(", a formidable philosophical challenge that will help sharpen my view of the conception of tradition as genuine repetition that informed the Heideggerian and kabbalistic hermeneutic. I subscribe to Leahy’s conjecture that the new path of thinking must be one in which there is a coincidence of thought and existence without the one being reduced to or derived from the other"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn16",
      "id": "ch1fn_16"
    }
  }, [_vm._v("16")])]), _vm._v("—it is plausible, as Heidegger observed in "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(","), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn17",
      "id": "ch1fn_17"
    }
  }, [_vm._v("17")])]), _vm._v(" to mark the launch of philosophy by the Parmenidean aphorism that being and thinking are one and the same, a metaphysical precept that implies, as Hegel astutely observed in the first book of the first volume of the "), _c('i', [_vm._v("Wissenschaft der Logik")]), _vm._v(", published in 1812 and in a revised version in 1832, that “thinking ["), _c('i', [_vm._v("das Denken")]), _vm._v("] and the determination of thinking ["), _c('i', [_vm._v("die Bestimmungen des Denkens")]), _vm._v("] are not something alien to the subject matters, but are rather their essence, or that the "), _c('i', [_vm._v("things")]), _vm._v(" and the "), _c('i', [_vm._v("thinking")]), _vm._v(" of them agree in and for themselves (also our language expresses a kinship between them); that thinking in its immanent determinations, and the true nature of things, are one and the same content.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn18",
      "id": "ch1fn_18"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("The change championed by Leahy requires that the absolute novelty of matter, which is itself the identity of thought, is amalgamated notionally into the “the meta-identical transcendence of a meta-identity,” and hence “for the first time the "), _c('i', [_vm._v("meta")]), _vm._v(" meta-identically exists in essence. Existence for the first time is conceived essentially as itself absolute novelty. This existence is the matter of thought itself.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn19",
      "id": "ch1fn_19"
    }
  }, [_vm._v("19")])]), _vm._v(" I take issue, however, with the understanding of the temporal interval as it emerges from Leahy’s thinking that is now occurring. In my judgment, the discontinuity of a dramatically new commencement can be appropriated only to the extent that we grasp that the present is not only continuous with, but—in its deepest valence—the reverberation of the past that remains open as the future that is to come."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn20",
      "id": "ch1fn_20"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Describing the intent of his "), _c('i', [_vm._v("Novitas Mundi")]), _vm._v(", Leahy writes that the “book sets out for the first time the transcendental limits of the essentially new form of thought which is what the new world’s new thinking really is if it be really new.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn21",
      "id": "ch1fn_21"
    }
  }, [_vm._v("21")])]), _vm._v(" In somewhat more pedantic language, Leahy elaborates:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The appearance of the transcendental essence of existence itself is, in its being identically what has occurred to it during the course of its worldly being or being in time, that which makes that time "), _c('i', [_vm._v("to be")]), _vm._v(" what it is, identifying it through its transcendental essence with existence itself.… What we now see is truly seen for the first time. What we now see occurs through no necessity whatsoever. It is the manifest freedom of the fact of creation in history at this time. This critical occurrence of the transcendental essence of existence itself in thought is the essence of its history, manifested in the historical essence it is the "), _c('i', [_vm._v("templative authority")]), _vm._v(" of the history in essence of thought. In the essential history of thought, this world’s existence is "), _c('i', [_vm._v("contemplated")]), _vm._v(" for the first time (a fact made possible by history’s "), _c('i', [_vm._v("essential indifference")]), _vm._v(" to time); for the first time, what has occurred presents itself in absolute evidence."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn22",
      "id": "ch1fn_22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Moving beyond the equally abstract options of an apotheosis of the particular into the universal or the incarnation of the universal within the particular, Leahy’s thinking that is now occurring is the thinking of the transcendental essence of existence itself, a thinking that is keenly attuned to the contingency of the factual in the present liberated from the constraints of being determined by the past:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("In its faithful attention to the essence of what occurred to being in time, this thinking now existing brings each object into existence on its own terms without making those terms in themselves its object but only the appearance in them of the transcendental essence of existence itself. It is in the historical essence, through which each object in perpetuity is at once made wholly itself within that existence accounting for this world’s existence, that everything comes into existence on its own terms.… This is the absolute evidence of purely "), _c('i', [_vm._v("factual")]), _vm._v(" contingency. This absolute evidence is in the thinking now occurring radically discontinuous in essence with every point of view that encumbers existence with its own perspective, imposing upon it a "), _c('i', [_vm._v("logos")]), _vm._v(" of its own, that is, a purely "), _c('i', [_vm._v("logical")]), _vm._v(" contingency, essentially unhistorical, by which the past is bound to its thinking, the essence of which is termination in itself, or "), _c('i', [_vm._v("world-determination")]), _vm._v(".… But the termination of the transcendental essence of existence itself is the termination of essence in existence; its "), _c('i', [_vm._v("appearance")]), _vm._v(", or "), _c('i', [_vm._v("the essence of history")]), _vm._v(", terminates in existence itself, not in its "), _c('i', [_vm._v("de")]), _vm._v("termination."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn23",
      "id": "ch1fn_23"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I assent to Leahy’s call for the need to uphold a new logic that claims the beginning as the middle excluded by the logic of the excluded middle; that is, a beginning that is not the beginning of the end and therefore not a foreshadowing of the end of the beginning, but the beginning of the beginning that is always also the end of the end, albeit in a distinctly nontautological way. Moreover, this logic will exemplify the paradox of being “without meaning but not meaningless,” imparting the sense of “"), _c('i', [_vm._v("being for the first time")]), _vm._v(". The logical category would be "), _c('i', [_vm._v("being beginning")]), _vm._v(". Nothing other than being for the first time would be thought.… The essence beyond essence—the exception to essence that "), _c('i', [_vm._v("is")]), _vm._v(" essence—of a categorically new logic would be the essence of the new.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn24",
      "id": "ch1fn_24"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two critical questions need to be asked. First, has Leahy articulated the most felicitous understanding of newness, and second, is it possible to speak of a beginning that exists for the first time in history without presuming that there is a concatenation of successive nows, each coexisting in the absolute relativity of its own spatial-temporal dimensionality? Can there be an absolute now that breaks absolutely "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("with the continuum of time? The presumption of such a possibility is what leads Leahy to relate his thinking now occurring in the third millennium—the "), _c('i', [_vm._v("looking without a looking glass")]), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn25",
      "id": "ch1fn_25"
    }
  }, [_vm._v("25")])]), _vm._v("—to speculation about the apocalypse. Against the commonplace understanding, Leahy insists that the apocalypse is not about the end of the old world or the beginning of a new world, but rather about the end of the end and the beginning of the beginning. “We are dealing not with beginning now of the world, not with the creation of the world, but with the beginning of the beginning now of the world, not merely with the beginning, but with the beginning of the beginning. We are dealing not with the final now of the world, not with the end of the world, but with the end of the final now of the world, not merely with the end, but with the end of the end.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn26",
      "id": "ch1fn_26"
    }
  }, [_vm._v("26")])]), _vm._v(" The now of the apocalypse, on this score, is deemed “the first now of the world. Then the beginning of the new heaven and the new earth is the beginning of the universe now beginning.… For the first time the I now speaking is apocalyptic.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn27",
      "id": "ch1fn_27"
    }
  }, [_vm._v("27")])]), _vm._v(" Implicit in this turn is the collapse of the temporal divide, for the “not-yet is absolutely now.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn28",
      "id": "ch1fn_28"
    }
  }, [_vm._v("28")])]), _vm._v(" To heed the imperative of the apocalyptic, consequently, is to discern that "), _c('i', [_vm._v("tomorrow is now because now is tomorrow")]), _vm._v(". An absolutely new beginning, however, logically necessitates an absolute ending of the beginning that is now ending. Naturally, Leahy is attentive to this possibility, and thus he argues, “this beginning of fully apocalyptic thinking is anticipated in previous conceptions of mind in the history of thought. But precisely because previous thought "), _c('i', [_vm._v("anticipated")]), _vm._v(" this beginning of an essentially new form of mind its actuality before now is precluded.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn29",
      "id": "ch1fn_29"
    }
  }, [_vm._v("29")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With all due deference to Leahy, I would argue that the pure immediacy of now entails the reiteration of the new that renders the supposition of an absolute novum untenable. This plainspoken wisdom is deftly expressed by Emmanuel Falque, “The new, in philosophy as in theology, cannot be formulated except insofar as it arises from what was there before.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn30",
      "id": "ch1fn_30"
    }
  }, [_vm._v("30")])]), _vm._v(" Nuancing and further complicating the argument, I would contend that what was before could never be retrieved except as what has not yet taken place. Hence, rather than speaking of the thinking now occurring as existing for the first time historically, it is more accurate to speak of the present in which that thinking transpires as the reprise of what has always been what is to become. Utilizing a distinction made by Edward Said, we can say that the point of departure is inaccessible because it is not a transitive property determined by an anticipated end or an expected continuity; it is rather a radical and intransitive starting point that has no object other than its own relentless clarification."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn31",
      "id": "ch1fn_31"
    }
  }, [_vm._v("31")])]), _vm._v(" The beginning is thus “"), _c('i', [_vm._v("making")]), _vm._v(" or "), _c('i', [_vm._v("producing difference")]), _vm._v("; but—and here is the great fascination in the subject—difference which is the result of combining the already-familiar with the fertile novelty of human work in language.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn32",
      "id": "ch1fn_32"
    }
  }, [_vm._v("32")])]), _vm._v(" By his own admission, Said’s conception is indebted to the Husserlian phenomenological reduction whereby the search for the absolute beginning leads to its own undermining inasmuch as the beginning shows itself sensuously only as the beginning constructed intentionally in the constitution of the intuitive object that “attains original givenness in and with the "), _c('i', [_vm._v("form of a temporal duration")]), _vm._v(", rendering an encompassing and objective unity possible.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn33",
      "id": "ch1fn_33"
    }
  }, [_vm._v("33")])]), _vm._v(" Even in its immanent essence as an absolute givenness, the beginning is always noetically at a distance from being the beginning of the beginning of being."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn34",
      "id": "ch1fn_34"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The logic of this argument can be adduced further from Husserl’s remark in the lectures on the internal time consciousness of 1905, “But this "), _c('i', [_vm._v("question of origin")]), _vm._v(" is directed towards the "), _c('i', [_vm._v("primitive")]), _vm._v(" formations of time-consciousness, in which the primitive differences of the temporal become constituted intuitively and properly as the original sources of all the evidences relating to time.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn35",
      "id": "ch1fn_35"
    }
  }, [_vm._v("35")])]), _vm._v(" Phenomenological apperception is not concerned with the empirical genesis whence the intuitions of objective space and objective time arise, but only in the immanent sense and descriptive content of the experiences ("), _c('i', [_vm._v("Erlebnisse")]), _vm._v(") bracketed from the natural standpoint and the ensuing epistemological inquiry into the presumed existence or nonexistence transcendent to consciousness. As Husserl boldly states, “We do not fit experiences into any reality. We are concerned with reality only insofar as it is reality meant, objectivated, intuited, or conceptually thought. With respect to the problem of time, this means that we are interested in the "), _c('i', [_vm._v("experiences")]), _vm._v(" of time.… We seek to bring "), _c('i', [_vm._v("the a priori of time")]), _vm._v(" to "), _c('i', [_vm._v("clarity")]), _vm._v(" by exploring the "), _c('i', [_vm._v("consciousness of time")]), _vm._v(", by bringing its essential constitution to light, and by exhibiting the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("apprehension-contents and act-characters that pertain—perhaps specifically—to time and to which the "), _c('i', [_vm._v("a priori")]), _vm._v(" temporal laws essentially belong.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn36",
      "id": "ch1fn_36"
    }
  }, [_vm._v("36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The origin, then, is not an objective time that can be calculated instrumentally by the ego in the world of physical things and psychic subjects,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn37",
      "id": "ch1fn_37"
    }
  }, [_vm._v("37")])]), _vm._v(" but it is rather the interior time of the eidetic experiences accessible phenomenologically and not psychologically."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn38",
      "id": "ch1fn_38"
    }
  }, [_vm._v("38")])]), _vm._v(" When gauged from this vantagepoint, the origin of time can never be something that originates in time, and thus the essence of the "), _c('i', [_vm._v("arche")]), _vm._v(" inessentially is "), _c('i', [_vm._v("an-archic")]), _vm._v(". Husserl himself, it is worth recalling, defined philosophy more generally—although obviously phenomenology is privileged—as “a science of true beginnings, or origins, of "), _c('i', [_vm._v("rizōmata pantōn")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn39",
      "id": "ch1fn_39"
    }
  }, [_vm._v("39")])]), _vm._v(" But the true beginning is the beginning that cannot begin. The constant quest for origin, which is the watchword of phenomenology as the science of pure phenomena, to go back to the things themselves ("), _c('i', [_vm._v("zur Sache selbst")]), _vm._v("), is perforce a recoiling to the domain where the very question of origin is interrogated as the origin of the question. At the beginning stands the impasse of the beginning. In lieu of a unitary point whence all things originate, we find a fold, duplicity, contravention, the doubling of infringement that marks the way of the beginning in the beginning of the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A similar account, albeit betraying the influence of both Husserl and Merleau-Ponty, is offered by John Sallis: “Radical philosophy is a peculiar "), _c('i', [_vm._v("return to beginnings")]), _vm._v(", a turning towards what already determines it. It is a circling which sets out from the beginnings so as to return to them, which it can do only if in its circling it never really leaves them.… Radical philosophy, as return to beginnings, is thus simultaneously a turning towards its own beginnings, towards those beginnings with which the return to beginnings is initiated.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn40",
      "id": "ch1fn_40"
    }
  }, [_vm._v("40")])]), _vm._v(" I would add, by way of amplification and not dissension, that the return to the beginning is a return to where one has never been because the very notion of beginning, as Sallis himself wrote elsewhere, is always a “redoubling—which is to say no beginning at all.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn41",
      "id": "ch1fn_41"
    }
  }, [_vm._v("41")])]), _vm._v(" The beginning bears the paradox of existing only “after the fact,” that is, it “has always already been the beginning,” but if this is so, then there is no beginning that has not begun prior to beginning and therefore destabilizing the very possibility of beginning."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn42",
      "id": "ch1fn_42"
    }
  }, [_vm._v("42")])]), _vm._v(" In Derridean parlance, the onset can never be anything but second, an echo, a trace, the “originary iterability.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn43",
      "id": "ch1fn_43"
    }
  }, [_vm._v("43")])]), _vm._v(" Only that which is distinct can be duplicated, since what recurs is the same difference that is indifferently the same. As will become increasingly clear from the subsequent analysis in this chapter and the ones that follow, the conception I articulate on the basis of these sources, in contrast to Leahy, can be extricated from both Heidegger and the kabbalah.")]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Novelty and Repetition of the Altogether Otherwise")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Perhaps more efficaciously than any other twentieth-century philosopher, Heidegger has expressed the intonation of time—or, to be more fastidious, what he calls the “primordial temporality” ("), _c('i', [_vm._v("ursprünglichen Zeitlichkeit")]), _vm._v(") experienced in the ecstatic unity of past, present, and future, as opposed to the vulgar understanding ("), _c('i', [_vm._v("vulgären Verständnis")]), _vm._v(") of time as the continual succession of nows ("), _c('i', [_vm._v("Jetzt-folge")]), _vm._v(")—as the concurrence of the heterogeneity of the homogeneous and the homogeneity of the heterogeneous. This confluence is expressed as well in spatial terms as “"), _c('i', [_vm._v("the primordial ‘outside itself’ in and for itself")]), _vm._v(" [das ursprüngliche ‘Außer-sich’ an und für sich selbst].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn44",
      "id": "ch1fn_44"
    }
  }, [_vm._v("44")])]), _vm._v(" That time is extrinsic to itself in the manner of being intrinsic to itself suggests that the temporal flow consists of the recurrence of the same in which the same is the recurrence of difference."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn45",
      "id": "ch1fn_45"
    }
  }, [_vm._v("45")])]), _vm._v(" Following this notion of time, thinking itself is best characterized as a circular movement ("), _c('i', [_vm._v("Kreisbewegung")]), _vm._v(") by which one is restored to where one has previously not been. In contrast to the path of philosophy, the pedestrian understanding “can only perceive and grasp what lies straight in front of it: it thus wishes to advance in a straight line, moving from the nearest point on to the next one, and so on. This is called progress ["), _c('i', [_vm._v("Fortschritt")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn46",
      "id": "ch1fn_46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heidegger’s sarcasm is palpable as he expresses his disdain for the quotidian sense of time that even treats the orbicular motion in a linear fashion as “straightforward progression” ("), _c('i', [_vm._v("Geradeausgehen")]), _vm._v("), culminating in reverting to the starting point and coming to a standstill. The fuller hermeneutical error "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("implied by this conception of the serial progress of time, as it relates more specifically to a historiological as opposed to a historical perspective, is articulated by Heidegger in a meditation on the "), _c('i', [_vm._v("mystery of language")]), _vm._v(" from the "), _c('i', [_vm._v("Schwarze Hefte")]), _vm._v(": “we understand a ‘result’ [‘"), _c('i', [_vm._v("Erfolg")]), _vm._v("’] as the effect ["), _c('i', [_vm._v("Wirkung")]), _vm._v("] that "), _c('i', [_vm._v("follows")]), _vm._v(" [folgt] upon a cause ["), _c('i', [_vm._v("Ursache")]), _vm._v("]; but is not the result now what "), _c('i', [_vm._v("precedes")]), _vm._v(" that which is supposed to count as ‘true’? A result is not so much something effectuated ["), _c('i', [_vm._v("Bewirkte")]), _vm._v("] as it is the first properly backward effectuation ["), _c('i', [_vm._v("rückwärts Wirkende")]), _vm._v("], insofar as the result extinguishes all other possibilities, ones which then would have the result of being able to deny the claim to what is true.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn47",
      "id": "ch1fn_47"
    }
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mundane understanding of causality rests on the assumption that the result is cognized as an effect consequent to an antecedent cause, but the result is veritably a backward effectuation that is the “last consequence of the sovereignty of the human being as the historiological animal”; that is, the surrendering of all history to an anthropomorphizing concept of historiology wherein the past is determined completely “from the horizon of planning and using, and the human being is sequestered from all beyng.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn48",
      "id": "ch1fn_48"
    }
  }, [_vm._v("48")])]), _vm._v(" A historical comprehension ("), _c('i', [_vm._v("geschichtlich begriffen")]), _vm._v(") “shows that the humanity entangled in "), _c('i', [_vm._v("results")]), _vm._v(" and in their calculation and production twists history into a constant and increasing backward motion ["), _c('i', [_vm._v("Rückwärtsbewegung")]), _vm._v("] and indeed one behind the obviousness of the progress which everyone can see and which is all that is seen. Both—that regress ["), _c('i', [_vm._v("Rückschritt")]), _vm._v("] and this progress ["), _c('i', [_vm._v("Fortschritt")]), _vm._v("]—belong together.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn49",
      "id": "ch1fn_49"
    }
  }, [_vm._v("49")])]), _vm._v(" The emphasis on progress is, in truth, regressive, insofar as the preeminent form of the movement of history, and the essential sense of modern humanity based thereon, are pursued through the ascendancy of historiology. Moreover, the “backward effectivity” ("), _c('i', [_vm._v("Rückwärtswirken")]), _vm._v(") of the professed forward evolution erects “the genuine barrier to all meditation on the beginnings ["), _c('i', [_vm._v("Anfänge")]), _vm._v("], because indeed what happened is seen only in the horizon of "), _c('i', [_vm._v("results")]), _vm._v(" and precisely "), _c('i', [_vm._v("not")]), _vm._v(" out of the origin ["), _c('i', [_vm._v("Ur-sprung")]), _vm._v("] in the sense of the preservation of possibilities pregnant with decisions.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn50",
      "id": "ch1fn_50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inasmuch as this sense of regress-progress is the criterion that engulfs the conventional understanding, moving in a circle, which seemingly gets one nowhere but to the place whence one set out, is objectionable—hence the ubiquitous denunciation of circular reasoning, the everyday view that Heidegger summarily dismissed in "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(" as a failure to comprehend the fore-structure ("), _c('i', [_vm._v("Vor-struktur")]), _vm._v(") of understanding ("), _c('i', [_vm._v("Verstehen")]), _vm._v(") grounded in the tripartite nature of interpretation ("), _c('i', [_vm._v("Auslegung")]), _vm._v(") as fore-having ("), _c('i', [_vm._v("Vorhabe")]), _vm._v("), foresight ("), _c('i', [_vm._v("Vorsicht")]), _vm._v("), and fore-conception ("), _c('i', [_vm._v("Vorgriff")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn51",
      "id": "ch1fn_51"
    }
  }, [_vm._v("51")])]), _vm._v(" When the hermeneutical condition of Dasein is viewed from this perspective, then the matter of the vicious circle ("), _c('i', [_vm._v("circulus vitiosus")]), _vm._v(") commands a response different from the stock dismissal:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('i', [_vm._v("But to see a")]), _vm._v(" vitiosum "), _c('i', [_vm._v("in this circle and to look for ways to avoid it, even to “feel” that it is an inevitable imperfection, is to misunderstand understanding from the ground up")]), _vm._v(".… What is decisive is not to get out of the circle, but to get into it in the right way. This circle of understanding is not a circle in which any random kind of knowledge operates, but it is rather the expression of the existential "), _c('i', [_vm._v("fore-structure")]), _vm._v(" of Dasein itself.… The “circle” in understanding belongs to the structure of meaning, and this phenomenon is rooted in the existential constitution of Dasein, that is, in interpretive understanding."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn52",
      "id": "ch1fn_52"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The forestructure of understanding thus requires one to leap primordially and completely into the circular being of Dasein constituted as care ("), _c('i', [_vm._v("Sorge")]), _vm._v("),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn53",
      "id": "ch1fn_53"
    }
  }, [_vm._v("53")])]), _vm._v(" the ontological meaning of which relates to the existentiell question about Dasein’s potentiality-for-being-a-whole ("), _c('i', [_vm._v("Ganzseinkönnen")]), _vm._v(") and the existential question about the constitution of the being ("), _c('i', [_vm._v("Seinsverfassung")]), _vm._v(") of the end ("), _c('i', [_vm._v("Ende")]), _vm._v(") and the state of wholeness ("), _c('i', [_vm._v("Ganzheit")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn54",
      "id": "ch1fn_54"
    }
  }, [_vm._v("54")])]), _vm._v(" Responding to the alleged assumption that Dasein is marked by an unfinished quality ("), _c('i', [_vm._v("Unabgeschlossenheit")]), _vm._v(") that is always outstanding ("), _c('i', [_vm._v("aussteht")]), _vm._v("), which makes it impossible both to experience Dasein ontically as an existing whole and to define it ontologically in its wholeness, Heidegger suggests that the latter is made accessible through the anticipatory resoluteness of being-toward-death ("), _c('i', [_vm._v("Sein zum Tode")]), _vm._v(") that is the coming-to-an-end ("), _c('i', [_vm._v("Zu-End-kommen")]), _vm._v("); the consummate ending, which is death, is "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("the only meaningful way that each individual human being in its own sense of mineness ("), _c('i', [_vm._v("Jemenigkeit")]), _vm._v(") or specificity ("), _c('i', [_vm._v("Jeweiligkeit")]), _vm._v(") can be said to be whole."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn55",
      "id": "ch1fn_55"
    }
  }, [_vm._v("55")])]), _vm._v(" The fragmentariness of human existence is attenuated by the devouring nature of death, but a proper comprehension of the hermeneutical situation of Dasein precludes interpreting that end as merely the recapitulation of the beginning. Heidegger insists that this ending does not mean fulfillment or disappearance, two forms of being-at-an-end ("), _c('i', [_vm._v("Zu-Ende-sein")]), _vm._v(") that apply to an objective presence or something at hand ("), _c('i', [_vm._v("Zuhandenes")]), _vm._v("), but rather the end is delineated as being-toward-the-end ("), _c('i', [_vm._v("Sein zum Ende")]), _vm._v("), which is a feature of Dasein’s being ahead of itself ("), _c('i', [_vm._v("Sich-vorweg-sein")]), _vm._v(") as its own not-yet ("), _c('i', [_vm._v("Noch-nicht")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn56",
      "id": "ch1fn_56"
    }
  }, [_vm._v("56")])]), _vm._v(" To say that being-toward-the-end offers the existential possibility for an existentiell wholeness of Dasein implies that death does not denote a goal that can be achieved but not yet objectively present ("), _c('i', [_vm._v("Vorhandenes")]), _vm._v("); it is the imminence ("), _c('i', [_vm._v("Bevorstand")]), _vm._v(") through which Dasein is “"), _c('i', [_vm._v("completely")]), _vm._v(" thrown back upon its ownmost potentiality-of-being.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn57",
      "id": "ch1fn_57"
    }
  }, [_vm._v("57")])]), _vm._v(" The being-toward-the-end belongs essentially to the thrownness ("), _c('i', [_vm._v("Geworfenheit")]), _vm._v(") of Dasein that reveals itself in attunement ("), _c('i', [_vm._v("Stimmung")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn58",
      "id": "ch1fn_58"
    }
  }, [_vm._v("58")])]), _vm._v(" Heidegger’s ontological analytic of death, therefore, does not presume a successional narrative from the cradle to the grave, but rather an asymptotic circuity by which one’s past is always anticipating the future that is always reshaping the past.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the many turns on Heidegger’s path, he remained committed to the primacy of the circle as the appropriate geometric symbol to understand the hermeneutical texture of human experience, the comportment of temporality, and the trajectory of thinking. Thus, in one context, he writes that the “essential feature of the circular movement of philosophy does not lie in running around the periphery and returning to the point of departure ["), _c('i', [_vm._v("Ausgangsstelle")]), _vm._v("]. It lies in that view of the center that this circular course ["), _c('i', [_vm._v("Kreisgang")]), _vm._v("] alone can provide. The center, that is, the middle and ground, reveals itself as such only in and for the movement that circles it.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn59",
      "id": "ch1fn_59"
    }
  }, [_vm._v("59")])]), _vm._v(" Linear thinking is linked to the certainty of progress, whereas the circularity of philosophical thought is bound up with an ambiguity ("), _c('i', [_vm._v("Zweideutigkeit")]), _vm._v(") that is not eliminated or leveled even by means of the synthetic resolution of the conflict between thesis and antithesis according to the Hegelian dialectic."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn60",
      "id": "ch1fn_60"
    }
  }, [_vm._v("60")])]), _vm._v(" To move at the "), _c('i', [_vm._v("center of philosophizing")]), _vm._v(" is to move about not in the place of certitude but in the "), _c('i', [_vm._v("ambiguity of philosophizing")]), _vm._v(", a move that is always a retracing of one’s steps to the beginning of the question that calls into question the question of the beginning."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn61",
      "id": "ch1fn_61"
    }
  }, [_vm._v("61")])]), _vm._v(" As Heidegger expressed it through the voice of the scientist in the imaginary trialogue on the country path, “You philosophers always think backwards. This is surely the basis for the often noted impression that philosophy and its history leave on every straight-thinking mind: that philosophy, in contrast to the progress of scientific research ["), _c('i', [_vm._v("Forschung")]), _vm._v("], stays in the same place and never gets anywhere.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn62",
      "id": "ch1fn_62"
    }
  }, [_vm._v("62")])]), _vm._v(" The subterfuge here is obvious as the caricature of the circular law of philosophical argumentation, supposedly condemned by Heidegger, is precisely what he affirms as superior to the scientific idea of progress.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the import as well of Heidegger’s assertion that the “guiding question” ("), _c('i', [_vm._v("Leitfrage")]), _vm._v(") of inceptual thinking ("), _c('i', [_vm._v("anfängliche Denken")]), _vm._v(") concerns “the essentiality of the essence ["), _c('i', [_vm._v("die Wesentlichkeit des Wesens")]), _vm._v("],” which “consists of the greatest possible generality ["), _c('i', [_vm._v("größtmöglichen Allgemeinheit")]), _vm._v("] of the essence.” The question of the essence “contains in itself what is decisive ["), _c('i', [_vm._v("Entscheidungshafte")]), _vm._v("], which now from the ground up pervasively determines the question of being ["), _c('i', [_vm._v("Seinsfrage")]), _vm._v("].… The principle of inceptual thinking therefore sounds like something doubled ["), _c('i', [_vm._v("gedoppelt")]), _vm._v("]: all essence is essential occurrence ["), _c('i', [_vm._v("alles Wesen ist Wesung")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn63",
      "id": "ch1fn_63"
    }
  }, [_vm._v("63")])]), _vm._v(" The discourse to displace the closed circular movement—and the ancillary assumption that the future truth is already determined by the past—must partake of this doubling and what appears tautological from the perspective of the more prosaic linear logic. For Heidegger, the genuine tautology “names the Same only once, and indeed as itself” ("), _c('i', [_vm._v("nur einmal das Selbe nennt sie und zwar als es selbst")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn64",
      "id": "ch1fn_64"
    }
  }, [_vm._v("64")])]), _vm._v(" Tautological thinking is thus predicated on the temporal paradox of the same that can be disclosed only once, and in this respect it is the “primordial sense of phenomenology.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn65",
      "id": "ch1fn_65"
    }
  }, [_vm._v("65")])]), _vm._v(" The task, for Heidegger, as Derrida well understood, is not to circumvent this hermeneutic circulation, as viciously futile or as pointless as it might seem, but to engage in it by going "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("all around it."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn66",
      "id": "ch1fn_66"
    }
  }, [_vm._v("66")])]), _vm._v(" This is implied in the Heideggerian emphasis on resoluteness ("), _c('i', [_vm._v("Entschlossenheit")]), _vm._v(") and authenticity ("), _c('i', [_vm._v("Eigentlichkeit")]), _vm._v("):")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The experience of the circular closure does not close anything, it suffers neither lack nor negativity. Affirmative experience without voluntarism, without a compulsion to transgression: not to transgress the law of circle and "), _c('i', [_vm._v("pas de cercle")]), _vm._v(" but "), _c('i', [_vm._v("trust in them")]), _vm._v(". Of this trust would thought consist. The desire to accede, by this faithful repetition of the circle, to the not-yet-crossed, is not absent. The desire for a new step, albeit a backward one ("), _c('i', [_vm._v("Schritt zurück")]), _vm._v("), "), _c('i', [_vm._v("ties and unties")]), _vm._v(" this procedure ["), _c('i', [_vm._v("démarche")]), _vm._v("]. Tie without tie, get across ["), _c('i', [_vm._v("franchir")]), _vm._v("] the circle without getting free ["), _c('i', [_vm._v("s’affranchir")]), _vm._v("] of its law. "), _c('i', [_vm._v("Pas sans pas")]), _vm._v(" [step without step/step without not/not without step/not without not]."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn67",
      "id": "ch1fn_67"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With regard to the temporal quandary of the law of the circle—the future auguring the reversion to the past where one has never been, the fourfold connotation of the idiomatic expression "), _c('i', [_vm._v("pas sans pas")]), _vm._v("—there is continuity between the so-called earlier and later Heidegger."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn68",
      "id": "ch1fn_68"
    }
  }, [_vm._v("68")])]), _vm._v(" To cite one relevant passage from "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(": the three temporal modes are said to commingle around the notion that only the “"), _c('i', [_vm._v("being that, as futural")]), _vm._v(" [zukünftiges]"), _c('i', [_vm._v(", is equiprimordially having-been")]), _vm._v(" [gleichursprünglich gewesend]"), _c('i', [_vm._v(", can hand down to itself its inherited possibility")]), _vm._v(" [ererbte Möglichkeit]"), _c('i', [_vm._v(", take over its own thrownness and be in the Moment for ‘its time’")]), _vm._v(" [augenblicklich sein für ‘seine Zeit’]. "), _c('i', [_vm._v("Only authentic temporality")]), _vm._v(" [eigentliche Zeitlichkeit] "), _c('i', [_vm._v("that is at the same time finite makes something like fate")]), _vm._v(" [Schicksal]"), _c('i', [_vm._v(", that is, authentic historicity")]), _vm._v(" [eigentliche Geschichtlichkeit]"), _c('i', [_vm._v(", possible")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn69",
      "id": "ch1fn_69"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In some measure, Heidegger’s early thought bears affinity to Husserl’s description of the “eidetic laws of compossibility”—the “rules that govern simultaneous or successive existence and possible existence together”—anchored in the motivation of the transcendental sphere, as opposed to causation, structured as the “universal "), _c('i', [_vm._v("unity-form of the flux")]), _vm._v(",” that is, the “"), _c('i', [_vm._v("formal regularity pertaining to a universal genesis")]), _vm._v(", which is such that past, present, and future become unitarily constituted over and over again in a certain noetic-noematic formal structure of flowing modes of givenness.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn70",
      "id": "ch1fn_70"
    }
  }, [_vm._v("70")])]), _vm._v(" Consciousness constitutes itself for itself in the unity of its history, and in that constitution are contained the constitutions of all the objectivities, whether ideal or real, transcendent or immanent, that exist for that concrete and monadic ego. Heidegger translated Husserl’s insight into his own conceptual and terminological registry: the authentic temporality of Dasein—the finitude that makes possible the destiny of our historicity—is distinguished by the anticipatory resoluteness ("), _c('i', [_vm._v("vorlaufenden Entschlossenheit")]), _vm._v(") of appropriating the present moment as the realization of the future recuperating the past. This resoluteness, as it emerges from Heidegger’s reflections on Dasein’s essential being-guilty ("), _c('i', [_vm._v("Schuldigsein")]), _vm._v("), entails being thrown to the ground of nullity ("), _c('i', [_vm._v("Grund der Nichtigkeit")]), _vm._v("),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn71",
      "id": "ch1fn_71"
    }
  }, [_vm._v("71")])]), _vm._v(" but this thrownness is possible only if Dasein, as futural, can reclaim the "), _c('i', [_vm._v("way that it always already was")]), _vm._v(" (wie es je schon war), that is, its having-been ("), _c('i', [_vm._v("Gewesen")]), _vm._v("). “Only because Dasein in general "), _c('i', [_vm._v("is")]), _vm._v(" as I "), _c('i', [_vm._v("am")]), _vm._v("-having-been, can it come futurally toward itself in such a way that it comes-"), _c('i', [_vm._v("back")]), _vm._v(". Authentically futural, Dasein is authentically "), _c('i', [_vm._v("having-been")]), _vm._v(".… Dasein can "), _c('i', [_vm._v("be")]), _vm._v(" authentically having-been only because it is futural.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn72",
      "id": "ch1fn_72"
    }
  }, [_vm._v("72")])]), _vm._v(" Once more, we encounter Heidegger’s embrace of circularity applied hermeneutically to the structure of temporality: Dasein projects to the future to the extent that Dasein is thrown back to the past, but Dasein is thrown back to the past only to the extent that it projects to the future. From this it follows that the quality of resoluteness “becomes the "), _c('i', [_vm._v("repetition")]), _vm._v(" [Wiederholung] of a possibility of existence that has been handed down.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn73",
      "id": "ch1fn_73"
    }
  }, [_vm._v("73")])]), _vm._v(" That the repetition is deemed a “handing down” ("), _c('i', [_vm._v("Überlieferung")]), _vm._v(") implies that Dasein can mentally recuperate the stations of the journey it has traversed, but this does not mean that there is an exact reenactment of the past.")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The authentic repetition of a possibility of existence that has been … is grounded existentially in anticipatory resoluteness; for in resoluteness the choice is first chosen that makes one free for the struggle over what is to follow ["), _c('i', [_vm._v("kämpfende Nachfolge")]), _vm._v("] and fidelity ["), _c('i', [_vm._v("Treue")]), _vm._v("] to what can be repeated. The handing down of a possibility that has been in repeating it, does not, however, disclose the Dasein that has been there in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("order to actualize it again. The repetition of what is possible neither brings back “what is past,” nor does it bind the “present” back to what is “outdated.” Arising from a resolute self-projection, repetition is not convinced by “something past,” in just letting it come back as what was once real. Rather, repetition "), _c('i', [_vm._v("responds")]), _vm._v(" to the possibility of existence that has been-there. But responding ["), _c('i', [_vm._v("Erwiderung")]), _vm._v("] to this possibility in a resolution is at the same time, "), _c('i', [_vm._v("as a response belonging to the Moment")]), _vm._v(" [als augenblickliche], the "), _c('i', [_vm._v("renunciation")]), _vm._v(" [Widerruf] of that which is working itself out in the today as “past.” Repetition neither abandons itself to the past, nor does it aim at progress. In the Moment, authentic existence is indifferent ["), _c('i', [_vm._v("gleichgültig")]), _vm._v("] to both of these alternatives.… Repetition first makes manifest to Dasein its own history. The occurrence itself and the disclosedness belonging to it, or the appropriation of it, is existentially grounded in the fact that Dasein is ecstatically open as a temporal being."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn74",
      "id": "ch1fn_74"
    }
  }, [_vm._v("74")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The resolve to live momentously, to be responsive to the moment, depends on repetition, but an indispensable component of that repetition is renunciation of the past. Authentic existence entails the being-there that is forged neither by a retroactive glance backward nor by a proleptic glance forward but by repeating what is unrivaled with regard to the untruth of the truth that was once true as untrue. To leap to where one is no more is to retreat to where one is yet to be."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn75",
      "id": "ch1fn_75"
    }
  }, [_vm._v("75")])]), _vm._v(" Thinking on its way ("), _c('i', [_vm._v("unterwegs")]), _vm._v("), therefore, may be construed as a step back ("), _c('i', [_vm._v("den Schritt zurück")]), _vm._v(") out of metaphysics into the essence of metaphysics, as a migration out of the oblivion of difference into the destiny of the withdrawing concealment of perdurance."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn76",
      "id": "ch1fn_76"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the lecture course "), _c('i', [_vm._v("Vom Wesen der Wahrheit: Zu Platons Höhlengleichnis und Theätet")]), _vm._v(", offered in the winter semester 1931–32 at the University of Freiburg, Heidegger writes, “For in "), _c('i', [_vm._v("genuine")]), _vm._v(" historical reflection we take just that distance from the present which allows us room to leap out ["), _c('i', [_vm._v("hinauszuspringen")]), _vm._v("] beyond our own present, i.e. to treat it just as every present as present deserves to be treated, namely as something to be "), _c('i', [_vm._v("overcome")]), _vm._v(" [überwunden]. Genuine historical return is the decisive beginning of authentic "), _c('i', [_vm._v("futurity")]), _vm._v(" [Zukünftigkeit].… In the end it is "), _c('i', [_vm._v("historical")]), _vm._v(" return which brings us into what is actually happening "), _c('i', [_vm._v("today")]), _vm._v(". In the end it is also only a self-evident and therefore doubtful everyday opinion which takes history as something ‘past.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn77",
      "id": "ch1fn_77"
    }
  }, [_vm._v("77")])]), _vm._v(" History is emphatically not what happened factually in the past, as the discipline of historiology presumes, but what can be relived in the present as the way to heed the destiny that beckons us into the future. In that regard, the "), _c('i', [_vm._v("genuine historical return is the decisive beginning of the authentic futurity")]), _vm._v(". Striking a concordant note, Heidegger writes in a notebook entry from autumn 1932, “What truly remains in history is the unique ["), _c('i', [_vm._v("Einzige")]), _vm._v("]—"), _c('i', [_vm._v("un")]), _vm._v("repeatable [Un"), _c('i', [_vm._v("wiederholbare")]), _vm._v("]—at once necessary; what can be ‘"), _c('i', [_vm._v("repeated")]), _vm._v("’ in the extrinsic sense ["), _c('i', [_vm._v("äußeren Sinne")]), _vm._v("]—does not "), _c('i', [_vm._v("abide")]), _vm._v("—instead, it vacillates and has no unassailable necessity. It is altogether something else to repeat what is unique ["), _c('i', [_vm._v("das Einzige wiederholen")]), _vm._v("]—i.e., to carry out a proper necessity—and not just calculate ["), _c('i', [_vm._v("ausrechnen")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn78",
      "id": "ch1fn_78"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Counterintuitively, uniqueness is not antithetical to repetition. Heidegger insists that if we are to speak of an abiding necessity, then the mandate is "), _c('i', [_vm._v("to repeat what is unique")]), _vm._v(". But how does one repeat what is unique such that what is repeated remains unique? As he put it in a second passage from the notebooks written at a later date, for the common understanding of the masses the notion of sameness ("), _c('i', [_vm._v("das Selbe")]), _vm._v(") is set in opposition to what is novel, but “creative individuals” are committed to the “mystery” ("), _c('i', [_vm._v("Geheimnis")]), _vm._v(") of sameness “in its ever-originary essentiality” ("), _c('i', [_vm._v("immer ursprünglichen Wesentlichkeit")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn79",
      "id": "ch1fn_79"
    }
  }, [_vm._v("79")])]), _vm._v(" In a third passage, Heidegger opines that what is most common is the universal and its universalization arises “from the incapacity to experience the ever-incomparably unique in the same ["), _c('i', [_vm._v("das jeweils Unvergleichbare Einzige im Selben")]), _vm._v("] and to maintain it in its mystery.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn80",
      "id": "ch1fn_80"
    }
  }, [_vm._v("80")])]), _vm._v(" A similar idea is expressed in the observation in the "), _c('i', [_vm._v("Beiträge zur Philosophie (Vom Ereignis)")]), _vm._v(", composed between 1936 and 1938, that every essential occurrence of the essence of being “is determined out of what is essential in the sense of the original-unique ["), _c('i', [_vm._v("Ursprünglich-Einzigen")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn81",
      "id": "ch1fn_81"
    }
  }, [_vm._v("81")])]), _vm._v(" The upheaval in thinking that Heidegger sought to spearhead rests on the distinction between the conservative wish to preserve "), _c('i', [_vm._v("what was begun in the wake of the beginning")]), _vm._v(" and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("the more revolutionary relation to the beginning that demands acting and thinking "), _c('i', [_vm._v("from the perspective of the future")]), _vm._v(". The beginning is always a reemergence of the unprecedented—the origin ("), _c('i', [_vm._v("Ursprung")]), _vm._v(") that is incomparably distinctive ("), _c('i', [_vm._v("Einzig")]), _vm._v(") in each of its potentially countless iterations—and hence requires the “renunciation of the crutches and evasions of the habitual and the usual.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn82",
      "id": "ch1fn_82"
    }
  }, [_vm._v("82")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In much the same cadence, Heidegger writes in another section from the "), _c('i', [_vm._v("Beiträge")]), _vm._v(" that the wish to navigate the course of the question of being, in the hope of recuperating the lineage of antiquity, can be fulfilled if one comprehends that the matter of repetition means “to "), _c('i', [_vm._v("let")]), _vm._v(" the "), _c('i', [_vm._v("same")]), _vm._v(", the uniqueness of being, become a plight "), _c('i', [_vm._v("again")]), _vm._v(" and "), _c('i', [_vm._v("thereby out of a more original truth")]), _vm._v(". ‘Again’ means here precisely ‘altogether otherwise’ [‘"), _c('i', [_vm._v("Wieder")]), _vm._v("’ "), _c('i', [_vm._v("besagt hier gerade")]), _vm._v(": "), _c('i', [_vm._v("ganz anders")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn83",
      "id": "ch1fn_83"
    }
  }, [_vm._v("83")])]), _vm._v(" At first blush, one would not expect the concept of “the same” to be glossed as “the uniqueness of beyng” ("), _c('i', [_vm._v("die Einzigkeit des Seyns")]), _vm._v("), since sameness, by definition, is demonstrably opposed to uniqueness. In Heideggerian terms, however, there is no opposition, for, as I discussed in the introduction, to attend to the same, which he contrasts with the identical, means to heed that which is recurrently different. This hermeneutical assumption furnishes the rationale for the pattern of time that posits the “same” as unique and the “again” as altogether otherwise. In "), _c('i', [_vm._v("Einführung in die Metaphysik")]), _vm._v(", published in 1953 and based on a lecture course offered at the University of Freiburg in the summer semester of 1935, Heidegger writes, “To ask: how does it stand with Being?—this means nothing less than to "), _c('i', [_vm._v("repeat and retrieve")]), _vm._v(" [wieder-holen] the inception ["), _c('i', [_vm._v("Anfang")]), _vm._v("] of our historical-spiritual Dasein, in order to transform it into the other inception.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn84",
      "id": "ch1fn_84"
    }
  }, [_vm._v("84")])]), _vm._v(" The repetition of the novel is the basis for the phenomenological nexus that Heidegger establishes between time ("), _c('i', [_vm._v("Zeit")]), _vm._v("), eternity ("), _c('i', [_vm._v("Ewigkeit")]), _vm._v("), and the moment ("), _c('i', [_vm._v("Augenblick")]), _vm._v("): “The eternal is not the incessant ["), _c('i', [_vm._v("das Fort-währende")]), _vm._v("]; it is instead that which can withdraw ["), _c('i', [_vm._v("entziehen")]), _vm._v("] in a moment so as to recur ["), _c('i', [_vm._v("wiederzukehren")]), _vm._v("] later. What can recur: not as the "), _c('i', [_vm._v("identical")]), _vm._v(" ["), _c('i', [_vm._v("das")]), _vm._v(" Gleiche] but as the newly transforming ["), _c('i', [_vm._v("Verwandelnde")]), _vm._v("], the one and the unique ["), _c('i', [_vm._v("Eine-Einzige")]), _vm._v("], i.e., beyng, such that it is not immediately recognized, in this manifestation, as the same ["), _c('i', [_vm._v("das Selbe")]), _vm._v("]!”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn85",
      "id": "ch1fn_85"
    }
  }, [_vm._v("85")])]), _vm._v(" Conspicuously suggestive of both Kierkegaard’s idea of eternity as the movement of becoming, which is the fullness of time, and Nietzsche’s doctrine of the eternal recurrence of the same, Heidegger insists that eternity is not set in opposition to time; it is rather that which withdraws each moment to recur again the future."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn86",
      "id": "ch1fn_86"
    }
  }, [_vm._v("86")])]), _vm._v(" What recurs, however, is not the identical but the same, that is, the unique being that is always—originarily—different.")]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Tradition and the Present of Futurally Having-Been")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Inceptual thinking is characterized as the “original repetition” ("), _c('i', [_vm._v("ursprünglichere Wiederholung")]), _vm._v(") of the “first beginning,” the appropriating event ("), _c('i', [_vm._v("Ereignis")]), _vm._v(") of being, which is set in confrontation ("), _c('i', [_vm._v("Auseinandersetzung")]), _vm._v(") with the “other beginning.” The antagonistic positioning of the two beginnings transfigures the nature of time as the still-to-be-unfolded other beginning as a “re-attaining” ("), _c('i', [_vm._v("zurückzugelangen")]), _vm._v(") of the still-to-be-won-back first beginning, the future past that comes from the questioning of the truth of being that stands at the “origin of philosophy,” the dawning of Greek thought that initiated the history of Western metaphysics."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn87",
      "id": "ch1fn_87"
    }
  }, [_vm._v("87")])]), _vm._v(" Insofar as “every beginning is unsurpassable, it must constantly be repeated and must be placed through confrontation into the uniqueness of its incipience ["), _c('i', [_vm._v("die Einzigkeit seiner Anfänglichkeit")]), _vm._v("] and thus of its ineluctable reaching ahead.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn88",
      "id": "ch1fn_88"
    }
  }, [_vm._v("88")])]), _vm._v(" Just as the work of art ("), _c('i', [_vm._v("Kunst")]), _vm._v(")—epitomized in poetizing ("), _c('i', [_vm._v("Dichtung")]), _vm._v(")—is inceptual ("), _c('i', [_vm._v("anfänglich")]), _vm._v(") and futural ("), _c('i', [_vm._v("künftig")]), _vm._v(") in tandem, so the event in its eccentricity begins each time as that which was already yet to come."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn89",
      "id": "ch1fn_89"
    }
  }, [_vm._v("89")])]), _vm._v(" Following the suggestion of Reiner Schürmann, I concur that the “there” of being-in-the world in "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(" was transmuted from an ontological trait to the “possible momentary site,” which denotes “the non-generalizable other of all that has passed for universal and necessary. It names the event occurring only once and just this once.… The singular event, thought from out of the singular "), _c('i', [_vm._v("there")]), _vm._v("—that is the other of the ontological tradition.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn90",
      "id": "ch1fn_90"
    }
  }, [_vm._v("90")])]), _vm._v(" Schürmann goes so far as to surmise, “Heidegger is to be read backward, from the last to the first writings. By reading him in this way, one glimpses precisely the motives and paths "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("that led him to raise the question of being for its own sake and out of itself, motives arising from the singular, and paths prompted by the many ways of accentuating the internal conflict arising from singularization.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn91",
      "id": "ch1fn_91"
    }
  }, [_vm._v("91")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If one appreciates the extent to which Heidegger’s notion of time is shaped by this unwavering sense of singularity, then it is clearly inaccurate to label his thinking as a “regressive path,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn92",
      "id": "ch1fn_92"
    }
  }, [_vm._v("92")])]), _vm._v(" since the beginning to which one relapses is always a new and more primeval beginning than the one from which one has departed. The individuals responsible for initiating the second beginning are described as still bringing with them “the past of the concealed history of being, that detour (as it may seem) metaphysics had to take through beings so as "), _c('i', [_vm._v("not")]), _vm._v(" to attain being and thus to come to an end which is strong enough for the plight leading toward the other beginning. This beginning at the same time leads back into the originariness ["), _c('i', [_vm._v("Ursprünglichkeit")]), _vm._v("] of the first beginning and transforms the past into something not lost.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn93",
      "id": "ch1fn_93"
    }
  }, [_vm._v("93")])]), _vm._v(" The way to the future is a detour ("), _c('i', [_vm._v("Umweg")]), _vm._v(") to the past but not in the sense of just going back. The temporal markers of old and new are drastically altered. The old is not the archaic, as understood in historiological terms, but rather that which, as manifest in historical confrontation and meditation, “cannot be surpassed in essentiality by anything younger.” Analogously, the new is not the modern that is currently in vogue, but the “freshness of the originariness of the re-beginning, that which ventures out into the concealed future of the first beginning and thus cannot at all be ‘new’ but must be even "), _c('i', [_vm._v("older")]), _vm._v(" than the old.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn94",
      "id": "ch1fn_94"
    }
  }, [_vm._v("94")])]), _vm._v(" Already in the "), _c('i', [_vm._v("Prolegomena zur Geschichte des Zeitbegriffs")]), _vm._v(", the published version of the lecture course given at the University of Marburg in the summer semester of 1925, Heidegger taught that the portrayal of tradition as genuine repetition ("), _c('i', [_vm._v("echte Wiederholung")]), _vm._v("), in contrast to traditionalism ("), _c('i', [_vm._v("Traditionalismus")]), _vm._v("), does not presume an uncritical revisiting of the past, but rather a return that “goes back "), _c('i', [_vm._v("prior")]), _vm._v(" to the questions which were posed in history, and the questions raised by the past are once again originally appropriated. This possibility of assuming history can then also show that the assumption of the question of the sense of being is not merely an external repetition of the question which the Greeks already raised. If this formulation of the question of being is a genuine one, then the repetition must rather bring us to understand that the Greek formulation of the question was conditioned and provisional and, what is more, had to be so.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn95",
      "id": "ch1fn_95"
    }
  }, [_vm._v("95")])]), _vm._v(" From the specific case of grappling with the philosophical question about being raised by the ancient Greeks, we can induce the following general maxim: to appropriate the past originally is not merely to repeat the past derivatively, but it is to apprehend the unique circumstances that occasioned the past so that it will be reclaimed from a perspective that is always responsive to and changing in accord with the moment at hand. As James Ward observed, “Retrieval is never an exercise in nostalgia and is certainly not, in Heidegger, a moment in the economy of conservatism.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn96",
      "id": "ch1fn_96"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the Heideggerian perspective, as we find in Rosenzweig as well, albeit with the crucial difference that the latter blatantly utilized the theological categories of creation and redemption,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn97",
      "id": "ch1fn_97"
    }
  }, [_vm._v("97")])]), _vm._v(" we decidedly cannot say of the end that it shall be precisely as it was in the beginning; the beginning itself is transformed by the projection into the future that is the eternally evolving and constantly regenerated end. The temporal cyclicality—a facet of Heidegger’s hermeneutic circle—does not involve relapsing to where one has been, a mere repetition of patterns, but it is rather a reverting to where one has not been and indeed where one can never be. To attend to the past as “the coming of what has been” ("), _c('i', [_vm._v("die Ankunft des Gewesen")]), _vm._v(") is not to commemorate the “passing of the past” ("), _c('i', [_vm._v("das Vergehen")]), _vm._v(") but rather to appropriate “the gathering of what endures” ("), _c('i', [_vm._v("die Versammlung des Währenden")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn98",
      "id": "ch1fn_98"
    }
  }, [_vm._v("98")])]), _vm._v(" In the celebrated language of the aphorism attributed to Heraclitus, ποταμοῖσι τοῖσιν αὐτοῖσιν ἐμβαίνουσιν ἕτερα καὶ ἕτερα ὕδατα ἐπιρρεῖ, “As they step into the same rivers, other and still other waters flow upon them.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn99",
      "id": "ch1fn_99"
    }
  }, [_vm._v("99")])]), _vm._v(" The statement is better known by the Platonic paraphrase in the "), _c('i', [_vm._v("Cratylus")]), _vm._v(" 402a, “Heraclitus, I believe, says that all things pass and nothing stays [πάντα χωρεῖ καὶ οὐδὲν μένει], and comparing existing things to the flow of a river, he says you could not step twice into the same river [δὶς ἐς τὸν αὐτὸν ποταμὸν οὐκ ἂν ἐμβαίης].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn100",
      "id": "ch1fn_100"
    }
  }, [_vm._v("100")])]), _vm._v(" The original dictum, however, is more paradoxical than "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("Plato’s rendering: ontically, the river remains the same precisely on account of its fluctuating waters; if the waters stop flowing, the river would lose its identity as a river. The stepping differently into the same waters, therefore, instructs us about the permanence of impermanence, and this is precisely the mode of eternality that intersects with time, thereby transmuting temporality into diremptive luminosity, the clearing within which the nonrepresentable presentness shines forth as anticipation of the past and recollection of the future. From the “unique and primordial essence of temporality” spring the most extreme contraries ("), _c('i', [_vm._v("Gegensätze")]), _vm._v("), decisive renunciation ("), _c('i', [_vm._v("entschiedene Verzichten")]), _vm._v(") and unconditional awaiting ("), _c('i', [_vm._v("unbedingte Erharren")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn101",
      "id": "ch1fn_101"
    }
  }, [_vm._v("101")])]), _vm._v(" The motion of time is not a calculable metric but the swaying between the abdication that is an anticipation and the anticipation that is an abdication. The origin is determined by the telos in such a way that both termini are opened—the end in the beginning and the beginning in the end. By anticipating the past and recollecting the future, we are attuned to a mode of time that deviates from the customary chronology determined by a narrative linearity that dominates both the historicist conception of time and the psychologistic conception of identity. If regression is the operative term, then we must proclaim, in the spirit of Heraclitus, that the way back is the way forward. In Heidegger’s own language, which lends credence to the aforecited remark of Schürmann, “We still get closer to what "), _c('i', [_vm._v("is")]), _vm._v(" if we think everything in reverse—assuming, of course, that we have, in advance, an eye for how differently everything then faces us. A mere reversal, made for its own sake, reveals nothing.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn102",
      "id": "ch1fn_102"
    }
  }, [_vm._v("102")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leaving aside the political ramifications of the prominence Heidegger apportions to the confrontation between the two beginnings, one initiated by the Greeks and the other allocated to the Germans, what is necessary to emphasize is his avowal of the paradox that only what is unique is repeatable, "), _c('i', [_vm._v("Nur das Einmalige ist wieder-holbar")]), _vm._v(", whence it follows that repetition “does not mean the stupid superficiality and impossibility of the mere occurrence of the "), _c('i', [_vm._v("same")]), _vm._v(" for a second and third time. Indeed the beginning can never be apprehended as the "), _c('i', [_vm._v("same")]), _vm._v(", since it reaches ahead and thus encroaches differently each time on that which it itself initiates.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn103",
      "id": "ch1fn_103"
    }
  }, [_vm._v("103")])]), _vm._v(" The temporal line is here inverted, for the beginning, which is typically located in the past, is understood as the futural initiation of the inaugural event. The transposition of time—the destiny of the past is the effect of rather than the cause of the fate of the future"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn104",
      "id": "ch1fn_104"
    }
  }, [_vm._v("104")])]), _vm._v("—undergirds Heidegger’s stance regarding the historicity of Dasein. The “purely historical view” that tradition is what is handed down to us from the past is a “self-deception” in which we are ensnared as long as we are not thinking. Tradition, when considered authentically, is the reality that comes toward us and not the reality that lies behind us. The openness of the past bolsters our ability to hear the language of previous thinkers in the present so that we can enter into a face-to-face conversation ("), _c('i', [_vm._v("Zwiesprache")]), _vm._v(") with them."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn105",
      "id": "ch1fn_105"
    }
  }, [_vm._v("105")])]), _vm._v(" To think of time in this way is to acquiesce to the “time of thinking,” which stands in contrast to the “time of calculation,” a chronometric measure of history that is inessential ("), _c('i', [_vm._v("wesenlos")]), _vm._v("). Only the former affords one the opportunity to think within the “sphere of tradition” ("), _c('i', [_vm._v("Spielraum der Überlieferung")]), _vm._v("), which “prevails when it frees us from thinking back ["), _c('i', [_vm._v("Nachdenken")]), _vm._v("] to a thinking forward ["), _c('i', [_vm._v("Vordenken")]), _vm._v("], which is no longer a planning. Only when we turn thoughtfully toward what has already been thought, will we be turned to use for what must still be thought.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn106",
      "id": "ch1fn_106"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a letter to Eugen Fink from March 30, 1966, Heidegger wrote that to merit being called a student, one must “succeed in experiencing anew the same matter of thinking, experiencing it as ancient and as sheltering something most ancient within it. Such an experience continues to be determined by the tradition and by the spirit of the present age.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn107",
      "id": "ch1fn_107"
    }
  }, [_vm._v("107")])]), _vm._v(" To think anew that which is ancient, this is the exhortation of one who wishes to embark on the path of phenomenological thinking. The latter is not a “particular direction of philosophy,” but a method, a way to pursue knowledge, the possibility for “thinking to attain the ‘things themselves’ [‘"), _c('i', [_vm._v("Sachen selbst")]), _vm._v("’], or to put it more clearly: to attain the matter of thinking ["), _c('i', [_vm._v("zu der Sache des Denkens")]), _vm._v("].”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn108",
      "id": "ch1fn_108"
    }
  }, [_vm._v("108")])]), _vm._v(" For Heidegger, the Husserlian directive of going back to the things themselves ("), _c('i', [_vm._v("zu den Sachen selbst")]), _vm._v(") can be realized only when one thinks what is sheltered unexpectedly as ancient in this matter of thinking, an experience determined equivalently by the tradition of the past and the spirit of the current moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("The path has led us to a profound irony. On the one hand, as the publication of some volumes of the "), _c('i', [_vm._v("Schwarze Hefte")]), _vm._v(" has demonstratively proven, Heidegger disparagingly reprimands Judaism as a religious culture that is beholden exclusively to a mathematical-technological sense of time, a classification that corresponds to their privileging the historicist orientation ("), _c('i', [_vm._v("Historismus")]), _vm._v("), which denies them proper access to history ("), _c('i', [_vm._v("Geschichte")]), _vm._v(");"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn109",
      "id": "ch1fn_109"
    }
  }, [_vm._v("109")])]), _vm._v(" on the other hand, his own posture with respect to history accords well with the dialogical foundation of the experience of time that shaped the rabbinic conception of the Oral Torah, which in turn provided the ideational and sociological framework for the notion of tradition approved by the kabbalists. The temporal apperception shared by rabbinic sages, kabbalistic masters, and Heidegger fosters intergenerational dialogue by allowing one to blend with—or, in a more contemporary vernacular, to channel—the spiritual demeanor of a luminary from a previous era."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn110",
      "id": "ch1fn_110"
    }
  }, [_vm._v("110")])]), _vm._v(" The rabbinic and kabbalistic notion of the oral tradition, which complements and expands the written scripture, is well captured in the words of Heidegger cited above, the new refers to the concealed future of the beginning, and hence it is older than the old."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn111",
      "id": "ch1fn_111"
    }
  }, [_vm._v("111")])]), _vm._v(" The sharp scholarly distinction between innovative and conservative dissolves in light of this hermeneutical principle: what is old is old because it is new, and what is new is new because it is old.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interestingly, the affinity between Heidegger and Jewish thought on this point was already noted by Alexander Altmann, who proposed in the essay “Was ist jüdische Theologie?” (1933) that “the existential moments, adduced by Heidegger, of ‘heritage’ ("), _c('i', [_vm._v("Erbe")]), _vm._v(") and ‘destiny’ ("), _c('i', [_vm._v("Schicksal")]), _vm._v(") could prove to be decisive for an understanding of Jewish existence.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn112",
      "id": "ch1fn_112"
    }
  }, [_vm._v("112")])]), _vm._v(" Altmann was quick to add that the Heideggerian structures")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("are not quite adequate for the singular phenomenon of Jewish existence if they are understood as purely ontological immanent entities. Rather, in the Jewish case these concepts display a very conscious turning toward the transcendent moment of divine revelation. It is characteristic of the Jewish people that they are conscious of their heritage, as well as of their destiny, believing that they are always being addressed anew by God in the course of history. Israel stands anew time and again before the ineradicable givenness of its spiritual heritage which it must somehow master and satisfactorily incorporate."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn113",
      "id": "ch1fn_113"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The “tragic singularity” of the Jewish destiny consists of the need to heed de novo the “actuality” that was revealed in the foundational command of the monotheistic faith, “Hear O Israel, the Lord our God, the Lord is one” (Deuteronomy 6:4)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn114",
      "id": "ch1fn_114"
    }
  }, [_vm._v("114")])]), _vm._v(" One must hear again and again the divine command, albeit always from a new perspective calibrated to the impending of the future in the theophanous moment at hand. The tensiveness of time implied in the ever-evolving tradition, based on the never-ending revelation, thus consists of the simultaneity of past, present, and future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A succinct articulation of this idea, which has molded the scholastic piety of rabbinic culture for centuries, is offered by Joseph B. Soloveitchik in his philosophically nuanced account of the typologies of human nature, the first and the second Adam, which are elicited eisegetically from the scriptural narratives about the creation of humanity in the opening two chapters of Genesis: through participation in the faith community (the destiny of Adam II), one can be delivered from the existential angst of being condemned to the ephemerality of the now (the condition of Adam I). Covenantal time is both retrospective and prospective, affording an individual the chance to reexperience the promise of the past and to anticipate the hope of the future in the present in a manner that mimics the eternality of God—signified by the Tetragrammaton—wherein the boundaries separating before, now, and after dissipate."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn115",
      "id": "ch1fn_115"
    }
  }, [_vm._v("115")])]), _vm._v(" From within the covenantal community, writes Soloveitchik, “not only contemporary individuals but generations are engaged in a colloquy, and each single experience of time is three-dimensional, manifesting itself in memory, actuality, and anticipatory tension.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn116",
      "id": "ch1fn_116"
    }
  }, [_vm._v("116")])]), _vm._v(" The Jewish conception of tradition ("), _c('i', [_vm._v("masorah")]), _vm._v(") revolves about this “paradoxical time awareness,” which “involves the individual in the historic performance of the past and makes him also participate in the dramatic action of an unknown future.” The temporality proper to members of this community, therefore, is “not only a formal succession "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("within the framework of calendaric time but the union of the three grammatical tenses in an all-embracing time experience.… Covenantal man begins to find redemption from insecurity and to feel at home in the continuum of time.… He is no longer an evanescent being. He is rooted in everlasting time, in eternity itself.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn117",
      "id": "ch1fn_117"
    }
  }, [_vm._v("117")])]), _vm._v(" Eternity is not the timeless opposition to time but the elongation of time realized in the recycling of what is still to come, the expectation of the past through the commemoration of the future. The future thus repeatedly interrupts the present, but interruption does not signal an unmitigated rupture of the past. The timeswerve of circular linearity—also attested in Rosenzweig"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn118",
      "id": "ch1fn_118"
    }
  }, [_vm._v("118")])]), _vm._v("—dictates that without continuity we could not discern discontinuity. The two elements—which we can also refer to as synchrony and diachrony—coincide in the coalescence of the three temporal modes in the interminable becoming of the moment, which is called the “Lord’s world day” ("), _c('i', [_vm._v("Welttag des Herrn")]), _vm._v(")."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn119",
      "id": "ch1fn_119"
    }
  }, [_vm._v("119")])]), _vm._v(" In his description of the eternal God ("), _c('i', [_vm._v("der ewige Gott")]), _vm._v("), which names not a reified state of being but the perpetual process of coming to be, linked to the central events of his religious phenomenology, Rosenzweig affirms a concept of simultaneity ("), _c('i', [_vm._v("Gleichzeitigkeit")]), _vm._v(") that reverses the timeline—or, to be more precise, transmutes the line into a circle that is open at both ends—in a manner that parallels Heidegger’s notion of equiprimordiality:")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Do not Creation, Revelation, Redemption mean the same thing that it means for God? Because for God, the times of that day are his own experiences ["), _c('i', [_vm._v("eigne Erlebnisse")]), _vm._v("]; for him, the Creation of the world is becoming the Creator ["), _c('i', [_vm._v("das Schöpferwerden")]), _vm._v("]; Revelation becoming manifest ["), _c('i', [_vm._v("das Offenbar-werden")]), _vm._v("], Redemption becoming the Redeemer ["), _c('i', [_vm._v("das Erlöserwerden")]), _vm._v("]. He becomes in this way till the end. All that happens is a becoming in him ["), _c('i', [_vm._v("Alles was geschieht, ist an ihm Werden")]), _vm._v("]. And yet, since everything that happens, happens simultaneously ["), _c('i', [_vm._v("gleichzeitig")]), _vm._v("], and really Revelation is not later than Creation, and just for this reason even Redemption is not later than the two, therefore that becoming of God is not a self-transformation ["), _c('i', [_vm._v("Sichverändern")]), _vm._v("] for him, nor growth ["), _c('i', [_vm._v("Wachsen")]), _vm._v("], nor increase ["), _c('i', [_vm._v("Zunehmen")]), _vm._v("] but he is from the beginning and is at every moment and is always coming; and it is only because of this simultaneousness ["), _c('i', [_vm._v("dieses Zugleichs")]), _vm._v("] of his everlasting-being all the time and eternally, that the whole must be designated as a becoming ["), _c('i', [_vm._v("das Ganze als ein Werden bezeichnen")]), _vm._v("]."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn120",
      "id": "ch1fn_120"
    }
  }, [_vm._v("120")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The temporal depiction of the eternality of the divine as the simultaneous and continual becoming of the past, present, and future serves as a model for the temporality experienced by the eternal people in the circular linearity of their sacramental life. For Rosenzweig, the Jewish liturgical calendar transforms time from a linear to a cyclical progression, which is a prefiguration of eternity; participation in Jewish ritual affords the eternal people the task of fulfilling their metahistorical destiny in the circular rotation of time, which is lived experientially as a linear succession that is nevertheless an “inversion of the temporal sequence” ("), _c('i', [_vm._v("Verkehrung der Zeitfolge")]), _vm._v(") that is “God’s time” ("), _c('i', [_vm._v("Gottes Zeit")]), _vm._v("), which “establishes the life of the eternal people.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn121",
      "id": "ch1fn_121"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Its eternal life … constantly anticipates the end and makes it therefore into the beginning. In this reversal ["), _c('i', [_vm._v("Umkehrung")]), _vm._v("] it denies time as resolutely as possible and places itself outside of it. To live in time means to live between beginning and end. He who would want to live outside of time—and he who wants to live not that which is temporary, but an eternal life in time, must want this—he who therefore wants this must deny that “between.” Such a denial, however, would have to be active, so that there would result not merely a not-living-in time ["), _c('i', [_vm._v("Nicht-in-der-Zeit-Leben")]), _vm._v("], but a positive living-eternally ["), _c('i', [_vm._v("Ewig-Leben")]), _vm._v("]. And the active denial would take place solely in the reversal. To reverse a between means to make its after into the before and its before into the after, the end into the beginning, the beginning into the end. And the eternal people does that. It already lives for itself as if it were the whole world and as if the world were finished; it celebrates in its Sabbaths the sabbatical completion of the world and makes it into the base and starting point of its existence. But that which would be temporally only a starting point, the Law, this it sets as the goal. So it does not experience the between, although it naturally, really naturally, lives in it. It experiences precisely the reversal of the between, and so it disavows the omnipotence of the between and denies time in this way, and the same time is experienced on the eternal way."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn122",
      "id": "ch1fn_122"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("For the Jewish people, who live beyond history, the beginning is the end, and the end the beginning. The surpassing of time is experienced in the fullness of the moment that has no before or after. Linear time is eternalized in the circular rhythms of sacred time, a process exemplified especially in the celebration of Sabbath, which instantiates the coalescence of past, present, and future, the temporal correlates of creation, revelation, and redemption. In the life of the Jew, who lives in and from the end, time has been proleptically redeemed and the experience of the between fulfilled. The disavowal of time—or what Levinas referred to as the deformalization of the abstract aspects of time and the consequent concretization of the structures of experience"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn123",
      "id": "ch1fn_123"
    }
  }, [_vm._v("123")])]), _vm._v("—does not imply an abrogation or even a dialectical surpassing of temporality, but rather its radical deepening, an eradication of time by rooting oneself more firmly in the ground of time. Eternity, accordingly, is not the metaphysical overcoming of or existential escape from time but rather the merging of the three-dimensional structure of lived temporality through eternalization of the present in the continuous becoming of the being that has always been what is yet to come."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn124",
      "id": "ch1fn_124"
    }
  }, [_vm._v("124")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Recasting the view shared by Rosenzweig and Soloveitchik in terms of Heidegger’s notion of the moment as the recuperation of what is unique, which may well reflect Kierkegaard’s view of repetition or Nietzsche’s eternal return,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn125",
      "id": "ch1fn_125"
    }
  }, [_vm._v("125")])]), _vm._v(" we can say that what is unique in each moment is precisely what is repeatable. The dual deportment of tradition as malleable and durable—malleable in its durability and durable in its malleability—rests on the assumption that each moment instantiates the compresence of the recollection of the past, the actuality of the present, and the anticipation of the future. What is actual about the moment is the inversion of this rectilinearity to the extent that it promotes the memory of what will be and the expectancy of what was. Accordingly, the mandate to remember, which legitimately can be called a central pillar of Jewish ritual and self-understanding, comprises not the nostalgic reclamation of a past sealed in its factical obstinacy, but an auspicious proclamation of a future foreseen in its evental unforseeability. The compresence, as Heidegger noted, is not the result of the accumulation ("), _c('i', [_vm._v("Anhäufung")]), _vm._v(") or sequence ("), _c('i', [_vm._v("Abfolge")]), _vm._v(") of the three ecstasies of time but rather of their equiprimordiality ("), _c('i', [_vm._v("Gleichursprünglichkeit")]), _vm._v("); that is, the convergence arises as a result of the temporality that “temporalizes itself out of the authentic future … in such a way that, futurally having-been ["), _c('i', [_vm._v("zukünftig gewesen")]), _vm._v("], it first arouses the present ["), _c('i', [_vm._v("Gegenwart")]), _vm._v("]. "), _c('i', [_vm._v("The primary phenomenon of primordial and authentic temporality is the future")]), _vm._v(".”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn126",
      "id": "ch1fn_126"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I will evaluate Heidegger’s tempocentrism in "), _c('span', {
    attrs: {
      "href": "#/text/9780253042569_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 6")]), _vm._v(", but what must be borne in mind here is that he was well aware that the future cannot be severed from the other two modalities of time. Most telling is the locution "), _c('i', [_vm._v("futurally having-been")]), _vm._v(", an expression that insinuates the transposal of the causal order such that "), _c('i', [_vm._v("the past is the effect of the future rather than the future being the effect of the past")]), _vm._v(", a reversal of temporal causality that is resonant with similar strategies in psychoanalytic theory, especially the Freudian concept of "), _c('i', [_vm._v("nachträglich")]), _vm._v(", rendered by Lacan as "), _c('i', [_vm._v("l’après coup")]), _vm._v(", that is, “after the fact,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn127",
      "id": "ch1fn_127"
    }
  }, [_vm._v("127")])]), _vm._v(" the deferred action that assumes the character of the future perfect tense ("), _c('i', [_vm._v("futur antérieur")]), _vm._v(") in place of the present perfect tense. In Lacan’s own words: “What is realized in my history is neither the past definite as what was, since it is no more, nor even the perfect as what has been in what I am, but the future anterior as what I will have been, given what I am in the process of becoming.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn128",
      "id": "ch1fn_128"
    }
  }, [_vm._v("128")])]), _vm._v(" According to this construal of time, the symptom does not relate primarily to an occurrence in the past but rather to an event that awaits its futural unfolding."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn129",
      "id": "ch1fn_129"
    }
  }, [_vm._v("129")])]), _vm._v(" Lacan thus tenders a corrective to the time-function of the logic implied by Freud’s idea of repeating ("), _c('i', [_vm._v("Wiederholen")]), _vm._v(") and remembering ("), _c('i', [_vm._v("Erinnerung")]), _vm._v("), according to which “the real is that which always comes back to the same place—to the place where the subject in so far as he thinks, where the "), _c('i', [_vm._v("res cogitans")]), _vm._v(", does not meet it.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn130",
      "id": "ch1fn_130"
    }
  }, [_vm._v("130")])]), _vm._v(" To remember, in its deepest assonance, is to repeat, but to repeat, as I have noted several times, means to come back to the same place where one has always never been. One cannot but be struck by the conceptual proximity of Lacan’s privileging of the future to the view of temporality prioritized by Heidegger—especially pertinent is the Heideggerian notion of the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_vm._v("“"), _c('i', [_vm._v("remembering expectation")]), _vm._v(" [erinnernde Erharren],” that is, awaiting a call of beyng ("), _c('i', [_vm._v("einen Zuruf des Seyns")]), _vm._v(") by recollecting a hidden belonging to beyng ("), _c('i', [_vm._v("eine verhüllte Zugehörigkeit zum Seyn")]), _vm._v("), the remembrance of what is to come as the temporalization ("), _c('i', [_vm._v("Zeitigung")]), _vm._v(") of the “dispensation of the (hesitant) self-withholding ["), _c('i', [_vm._v("Fügung des Sichversagens")]), _vm._v(" ("), _c('i', [_vm._v("des zögernden")]), _vm._v(")]” that “a-byssally grounds the domain of decision ["), _c('i', [_vm._v("gründet ab-gründigerweise den Entscheidungsbereich")]), _vm._v("]”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn131",
      "id": "ch1fn_131"
    }
  }, [_vm._v("131")])]), _vm._v("—and I should add, the kabbalistic conception of time as the "), _c('i', [_vm._v("retroactive not yet")]), _vm._v(", an idea that I have argued also betrays affinity with the Derridean trace."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn132",
      "id": "ch1fn_132"
    }
  }, [_vm._v("132")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The routine attitude presumes both the irreversibility of time and its spatial homogenization into a series of now-points."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn133",
      "id": "ch1fn_133"
    }
  }, [_vm._v("133")])]), _vm._v(" Heidegger refers to this notion of the temporal as the “successive flowing away of the ‘now’ out of the ‘not yet now’ into the ‘no longer now’” as the “representational idea of time … which is standard throughout the metaphysics of the West.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn134",
      "id": "ch1fn_134"
    }
  }, [_vm._v("134")])]), _vm._v(" The intransient nature of time so calculated consists in its periodic passing away. Technically speaking—as Heidegger put it in “Zeit und Sein,” a lecture delivered at the University of Freiburg on January 31, 1962—from the metaphysical outlook, which coincides with our ordinary and inauthentic sense of time, past and future are "), _c('i', [_vm._v("me on ti")]), _vm._v(", that is, “something which is not ["), _c('i', [_vm._v("etwas nicht Seiendes")]), _vm._v("], though not an absolute nullity ["), _c('i', [_vm._v("schlechthin Nichtiges")]), _vm._v("], but rather something present ["), _c('i', [_vm._v("Anwesendes")]), _vm._v("] which lacks something ["), _c('i', [_vm._v("dem etwas fehlt")]), _vm._v("]. This lack is named with the ‘no longer now’ [‘"), _c('i', [_vm._v("nicht mehr")]), _vm._v("’] and the ‘not yet now’ [‘"), _c('i', [_vm._v("noch nicht")]), _vm._v("’]. Viewed in this way, time appears as the succession of nows ["), _c('i', [_vm._v("Nacheinander der Jetzt")]), _vm._v("], each of which, barely named, disappears into the ‘ago’ and is already pursued by the ‘soon.’”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn135",
      "id": "ch1fn_135"
    }
  }, [_vm._v("135")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quotidian time is experienced as a string of nows aligned in sequential procession, and hence there is an inescapable asymmetry between the obdurate past and the variable future. By contrast, authentic time is lived from the future retrieval of the past in the present."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn136",
      "id": "ch1fn_136"
    }
  }, [_vm._v("136")])]), _vm._v(" It is in this sense that tradition is thinking forward and not thinking backward, a thinking that calls to the past as the restoration of that which convenes us from the future. Common to Heidegger and to a dominant orientation within rabbinic Judaism, amplified in kabbalistic literature, is a conception of tradition built on the basis of a sense of history wherein the synchronic and the diachronic axes of time intersect irrevocably at the point where the present—in truth not a point but more like a ripple—temporalizes itself both as the anticipatory reminiscence of the future awaiting the occurrence of the past and as the recollective anticipating of the past awaiting the revival of the future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The position articulated by Heidegger can well serve as an elucidation of the philosophical underpinnings of the midrashic proclivity to unearth meaning homiletically from the text rather than by appeal to an independent conceptual system, an approach that has informed Jewish thought for millennia and is clearly what inspired the kabbalistic sensibility as well. As Scholem memorably characterized the rabbinic method in his discussion of revelation and tradition, “Truth is given once and for all, and it is laid down with precision. Fundamentally, truth merely needs to be transmitted.… The effort of the seeker after truth consists not in having new ideas but rather in subordinating himself to the continuity of the tradition of the divine word and in laying open what he receives from it in the context of his own time. In other words: Not system but "), _c('i', [_vm._v("commentary")]), _vm._v(" is the legitimate form through which truth is approached.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn137",
      "id": "ch1fn_137"
    }
  }, [_vm._v("137")])]), _vm._v(" "), _c('i', [_vm._v("Pace")]), _vm._v(" Scholem, I would argue that it is erroneous to separate tradition and revelation in the history of Judaism, and hence, it is not at all obvious that the mediated and conditional status of the former inevitably necessitates the inability to experience the immediacy and unconditionality of the latter. The rabbinic understanding of a continuing revelation, which unfolds through an unbroken chain of interpretation, is not based on a static conception of a timeless Torah set in opposition to time and therefore resistant to the fluctuation of historical contingency. Rather, it is predicated on a conception of temporality that calls into question the aligning of events chronoscopically in a sequence stretched invariably between before and after. The rabbinic hermeneutic advocates a notion of time that is circular in its linearity and linear in its circularity."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn138",
      "id": "ch1fn_138"
    }
  }, [_vm._v("138")])]), _vm._v(" The study of Torah demands that one be able to imagine each day, indeed each moment of each day, as a potential renewal of the Sinaitic theophany, an idea that "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_vm._v("is derived from, or hyperliterally linked to, the words “On this day they came to the desert of Sinai” (Exodus 19:1); that is, “on this day” ("), _c('i', [_vm._v("ba-yom ha-zeh")]), _vm._v("), and not merely “on the day” ("), _c('i', [_vm._v("ba-yom")]), _vm._v("), to indicate that it is incumbent on future readers to look upon the holy writ as if it were given afresh each time it is studied. Every interpretative endeavor is a reenactment of the revelatory experience, albeit from a unique vantage point."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn139",
      "id": "ch1fn_139"
    }
  }, [_vm._v("139")])]), _vm._v(" One can take hold of the ancient truth, therefore, only as the truth that is yet to be disclosed, a truth renewed in the gesticulation of its genuine iteration; the eternity of Torah consists precisely of this temporal resilience.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The midrashic mindset inculcates the interweaving of time and hermeneutics in the discernment of the discontinuity of continuity that characterizes the rabbinic approach to the scriptural verse subject to continual reinterpretation and, even more significantly, to continual rewriting. Consider in this light Heidegger’s remark, “The poetry of the poet or the treatise of the thinker stands within its own proper unique word. It compels us to perceive this word again and again as if we were hearing it for the first time. These newborn words transpose us in every case to a new shore.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn140",
      "id": "ch1fn_140"
    }
  }, [_vm._v("140")])]), _vm._v(" Heidegger’s poetic thinking shares with the rabbinic-kabbalistic hermeneutic the assumption that the uniqueness of the word triggers the need to hear it again repetitively as if it were uttered for the first time, a transporting to the new shore where one has already not been. Critical to this strategy of reading is the spatial bridging of past and future in the present constituted transcendentally within the immanence of consciousness. Phenomenologically speaking, what has been and what will be have no temporal density apart from the noematic lived experience of the moment, but the latter has no ideational content except through the noetic synthesis of the intentional acts of retention and protention, which point respectively to the past and the future crisscrossing in the perceptual present that cannot be represented as presence inasmuch as it always exceeds what can be presented, the now, we might say, that is interminably not-now, the temporal interlude that cannot be fathomed conceptually or empirically.")]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "ch1fn1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_1"
    }
  }, [_vm._v("1")]), _vm._v(". I am here referring to Moshe Idel, who has doggedly sought to discredit my way of thinking by labeling it a form of essentialism, monochromatism, or pansymbolism that obfuscates multivalency and hermeneutic diversity. See, for instance, Idel, "), _c('i', [_vm._v("Absorbing Perfections")]), _vm._v(", pp. 580–81n135; Idel, "), _c('i', [_vm._v("Kabbalah and Eros")]), _vm._v(", pp. 100–1, 128–31; Idel, "), _c('i', [_vm._v("Kabbalah in Italy")]), _vm._v(", pp. 312, 449n106; Idel, "), _c('i', [_vm._v("Ben")]), _vm._v(", pp. 619–20. This is not the context to argue point by point, text by text, but let me state that Idel’s criticism suffers from flattening my methodology. One may quibble with any scholarly position but it should not be hastily ignored without consideration of the details upon which it is based. To list assorted symbolic approaches and to petition Derridean "), _c('i', [_vm._v("différance")]), _vm._v(", as Idel does, is neither a serious theoretical challenge to my thinking nor a sophisticated reading of deconstruction. For a partial rejoinder to Idel’s criticism, see Wolfson, “Structure,” and Wolfson, “Retroactive Not Yet,” pp. 30–31. It is well to recall the paraphrase of the statement in Terence’s "), _c('i', [_vm._v("Phormio")]), _vm._v(" in the "), _c('i', [_vm._v("Theological-Political Treatise")]), _vm._v(" of Spinoza, "), _c('i', [_vm._v("Collected Works")]), _vm._v(", p. 249: “As the old adage goes, you can’t say anything so correctly that someone can’t distort it by misinterpretation.” The sagacity of this comment is as relevant today as when it was first uttered.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "ch1fn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_2"
    }
  }, [_vm._v("2")]), _vm._v(". My discussion here is a summary of the more detailed analysis in Wolfson, "), _c('i', [_vm._v("Dream")]), _vm._v(", pp. 23–24, and Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. xiii–xiv.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "ch1fn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_3"
    }
  }, [_vm._v("3")]), _vm._v(". Derrida, "), _c('i', [_vm._v("Points")]), _vm._v(", p. 393.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "ch1fn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_4"
    }
  }, [_vm._v("4")]), _vm._v(". Nancy, "), _c('i', [_vm._v("Gravity of Thought")]), _vm._v(", p. 64. The hermeneutical point enunciated by Nancy regarding the marking of difference through identity is consistent with a basic assumption of scientific methodology: comparison of divergent phenomena is only possible if there is contiguity in the divergence. For instance, consider the following response in Rovelli, "), _c('i', [_vm._v("Order of Time")]), _vm._v(", p. 40, to the question of how we can determine a fixed standard—the privileged time of a real present—to measure the movement of dissimilar objects by two clocks if duration is always relative to the movement of something with a given trajectory: “The correct answer (rarely given) is this: in motion relative to the "), _c('i', [_vm._v("only")]), _vm._v(" reference in which the point in space where the two clocks separate is the same point in space where they get back together. There is only a single straight line between two events in spacetime, from A to B: it’s the one along which "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_vm._v("time is maximum, and the speed "), _c('i', [_vm._v("relative to this line")]), _vm._v(" is the one that slows time. If the clocks separate and are not brought together again, there is no point asking which one is fast and which one is slow. If they come together, they can be compared, and the speed of each one becomes a well-defined notion” (emphasis in original). Underlying Rovelli’s comment is the notion of simultaneity articulated by Einstein in conjunction with his theory of special relativity; that is, the now of the extended present, which is neither past nor future, is not absolute but relative to the observer’s state of motion. See Rovelli, "), _c('i', [_vm._v("Order of Time")]), _vm._v(", pp. 218n27 and 222n62; and in more detail in Rovelli, "), _c('i', [_vm._v("Reality")]), _vm._v(", pp. 69–77. The shortness of the duration of the intermediate zone of the extended present, determined in the distance from a given reference event, is commensurate with the smallness of the scale by and in which quantum gravity is manifest. See Rovelli, "), _c('i', [_vm._v("Reality")]), _vm._v(", pp. 71 and 153.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "ch1fn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_5"
    }
  }, [_vm._v("5")]), _vm._v(". Chevalier, "), _c('i', [_vm._v("Scorpions")]), _vm._v(", p. 4. The comment of Chevalier is previously cited and discussed in Wolfson, "), _c('i', [_vm._v("Language")]), _vm._v(", pp. 89–90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "ch1fn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_6"
    }
  }, [_vm._v("6")]), _vm._v(". Clancey, "), _c('i', [_vm._v("Conceptual Coordination")]), _vm._v(", p. 68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "ch1fn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_7"
    }
  }, [_vm._v("7")]), _vm._v(". Northoff, "), _c('i', [_vm._v("Minding the Brain")]), _vm._v(", p. 85.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "ch1fn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_8"
    }
  }, [_vm._v("8")]), _vm._v(". Laruelle, "), _c('i', [_vm._v("Philosophies of Difference")]), _vm._v(", pp. 70–71: “As affected by non-being, Being will remain undetermined in opposition to any ‘metaphysical’ type of determination. This latter concerns itself with the particularity of beings. The transcendental or unifying (-unified) All will thus be ‘ontically’ indeterminable, that is, more rigorously, indeterminable in the mode of ontic multiplicity. This indetermination … is not decided in relation to beings in general, but only in relation to beings inasmuch as in general they are multiple and particular: to think the intrinsic variety of Being itself is thus not to wish to break its (necessary) relation to beings.… Difference in general is a chiasmus and, in its superior or transcendental phase, we know that the chiasmus conserves itself, that it remains an invariant in the passage from ontic diversity to transcendental unity, that the One appears and affirms itself, certainly not in ‘itself’ but in the form of unifying Difference, of the indivision of Nothingness and Being, in the transcendental and no longer metaphysical sense of these words.… Being remains in every way determined, that is, relative to beings and ‘beings’ themselves in turn (this is the reversibility of ontological Difference).” See also Laruelle, “Generic as Predicate”; and Laruelle, "), _c('i', [_vm._v("Principles of Non-Philosophy")]), _vm._v(", p. 196: “Thought-in-One obligates us to distinguish between the systematic necessity of a body of rules, a still ‘transcendent’ necessity which works to the benefit of philosophies … and a necessity and universality without fold that we say forms a "), _c('i', [_vm._v("Uni")]), _vm._v("-verse ["), _c('i', [_vm._v("Uni-vers")]), _vm._v("] (uni-versal, unilateral, etc.).… If philosophy thinks ‘system’, non-philosophy thinks ‘uni-verse’ (this evidently concerns transcendental concepts belonging to the theory of thought, not empirico-regional concepts) and the Universe perhaps ‘opposed’ in particular to the auto-positional ‘World’ and to the cosmo-political essence of philosophy.… Non-philosophy only knows immanent impossibilities (pragmatic and theoretical) but not prohibitions; axioms and hypotheses that are real-in-the-last-instance but not imperatives.” Compare the analysis in Smith, “Thinking from the One.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "ch1fn9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_9"
    }
  }, [_vm._v("9")]), _vm._v(". For a different approach to the systematic and integrative nature of medieval kabbalistic speculation as a mode of thinking constellated by metaphysical structures, see Idel, “On Some Forms,” pp. xxxvii–xlv.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_10"
    }
  }, [_vm._v("10")]), _vm._v(". My embrace of a logic of dialetheism to articulate thinking the unthinkable at the limits of thought and saying the unsayable at the limits of speech is indebted to the analysis of Priest, "), _c('i', [_vm._v("Beyond the Limits of Thought")]), _vm._v(". See the summary of his method on p. 3: “This book is about a certain kind of limit, not the limits of physical endeavours like running a mile, but the limits of the mind. I will call them limits of thought.… One might also describe them as conceptual limits, since they concern the limits of our concepts.… For the present, some examples will suffice to indicate what I have in mind: the limit of what can be expressed; the limit of what can be described or conceived; the limit of what can be known; the limit of iteration of some operation or other, the infinite in its mathematical sense. Limits of this kind provide boundaries beyond which certain conceptual processes (describing, knowing, iterating, etc.) cannot go; a sort of conceptual "), _c('i', [_vm._v("ne plus ultra")]), _vm._v(". The thesis of this book is that such limits are dialetheic; that is, that they are the subject, or locus, of true contradictions. The contradiction, in each case, is simply to the effect that the conceptual processes in question "), _c('i', [_vm._v("do")]), _vm._v(" cross these boundaries. Thus, the limits of thought are boundaries which cannot be crossed, but yet which are crossed” (emphasis in original). In defiance of the logical principle of noncontradiction, the neologism "), _c('i', [_vm._v("dialetheia")]), _vm._v(" signifies that there are true contradictions and thus a statement can be both true and false, the contradictory nature of which is syllogistically diagrammed in the form of “α and it is not the case that α.” See Priest, "), _c('i', [_vm._v("In Contradiction")]), _vm._v(", pp. 3–6. For an extended discussion of dialetheism and the problem of truth and falsity, see ibid., pp. 53–72. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("The logical and epistemological repercussions of dialetheism are explored critically in the studies in Priest, Beall, and Armour-Garb, eds., "), _c('i', [_vm._v("Law of Non-Contradiction")]), _vm._v(". See as well Jones, “Dialetheism, Paradox, and Nāgārjuna’s Way of Thinking.” The dialetheic approach, in my view, renders Husserl’s attempt to distinguish the psychological possibility of subjectively thinking that a proposition and its negation are both true, on the one hand, from the a priori logical impossibility of proposing this to be the case, on the other hand, to be a distinction without a difference; that is to say, if it is thinkable that α and ¬α are true at the same time and in the same relation, then it compels us to advance a different logic that would challenge whether the law of noncontradiction is an a priori truth. Concerning Husserl’s discussion of this law and the contrast between the psychological-subjective and the logical-objective, see Moran, "), _c('i', [_vm._v("Edmund Husserl")]), _vm._v(", pp. 107–8.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_11"
    }
  }, [_vm._v("11")]), _vm._v(". This theme has been articulated from numerous vantage points in my scholarly œuvre. See Wolfson, "), _c('i', [_vm._v("Abraham Abulafia")]), _vm._v(", p. 20; "), _c('i', [_vm._v("Language")]), _vm._v(", pp. 86–94; "), _c('i', [_vm._v("Alef")]), _vm._v(", pp. 55–61; “Mythopoeic Imagination”; "), _c('i', [_vm._v("Open Secret")]), _vm._v(", pp. 22–24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_12"
    }
  }, [_vm._v("12")]), _vm._v(". Gadamer, "), _c('i', [_vm._v("Truth and Method")]), _vm._v(", p. 293. See below, nn. 51–52. Gadamer’s rendering of the Heideggerian hermeneutical circle bears similarity to the relation between knowing and being in the notion of the hermeneutical spiral elaborated by Hart, "), _c('i', [_vm._v("Unfinished Man and the Imagination")]), _vm._v(", pp. 60–68. On the nexus of time and hermeneutics from the perspective of analytic philosophy, see Rödl, "), _c('i', [_vm._v("Categories of the Temporal")]), _vm._v(". The author’s hypothesis is that time is the form of knowledge in which understanding and sensibility are united, and hence the forms of the finite intellect are forms of temporal thought or what he calls the categories of the temporal. Insofar as all thought is generic, and the subject of a generic thought is a substance form that is a feature of a predicative unity dependent on the anticipatory contingency of the progressive nature of movement, the atemporal logic of inferential relations—and the implicit presumption that truth is timeless—must be grounded in a temporal logic (pp. 172–73, 175–80). Betraying the influence of Wittgenstein’s "), _c('i', [_vm._v("Philosophical Investigations")]), _vm._v(", Rödl argues that thought is inherently temporal not in virtue of its content but in virtue of its form of predication. The grammatical forms of time consciousness consist of the bipolar predication of tense and the tripolar predication of aspect (9–10). Alternatively expressed, human thought is tensed in relation to the persistent substance and the changeable state. Summarizing his perspective, Rödl writes, “An intellect that depends on intuition does not think from nowhere, but by means of time. Thereby it is also temporal in the sense that it represents its object as temporal. Both aspects of its temporality are inseparable” (p. 74). Time-consciousness is thus the unity of sensibility and understanding. See ibid, p. 80: “Finite thought represents its object as temporal, because thought that depends on intuition is situational, and situational thought is of the temporal. Hence, the forms in virtue of which thought has sensory content are forms in virtue of which it relates to the temporal, and the pure concepts of the finite intellect are categories of the temporal.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_13"
    }
  }, [_vm._v("13")]), _vm._v(". Derrida and Ferraris, "), _c('i', [_vm._v("Taste for the Secret")]), _vm._v(", p. 47. See Schuback, “Hermeneutics of Tradition,” pp. 70–72: “Transmission of tradition shows omitting or reveals concealing the non-world pulsating in the self-evidence and communicability of the world in tradition. In its system of familiarity and security, the system of self-evidence where everything fits well together and can be perfectly explicated, showing no need for further explanation or inquiry, the world is always passing on and thereby always exposed to a loss.… The loss of the world implicated in a life after death and the not yet of a world in a life before birth casts the world of tradition as the world of an in-between, a world without world that appears as a world of rest, a world resting in continuous tradition.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_14"
    }
  }, [_vm._v("14")]), _vm._v(". Derrida, “Abraham’s Melancholy,” p. 156 (emphasis in original). On the term "), _c('i', [_vm._v("paleonymy")]), _vm._v(", see also Derrida, "), _c('i', [_vm._v("Dissemination")]), _vm._v(", pp. 6n6, 18nn20–21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_15"
    }
  }, [_vm._v("15")]), _vm._v(". Derrida, "), _c('i', [_vm._v("Positions")]), _vm._v(", p. 57.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_16"
    }
  }, [_vm._v("16")]), _vm._v(". Leahy, "), _c('i', [_vm._v("Novitas Mundi")]), _vm._v(", p. 4. This section is a highly abbreviated version of the much more detailed analysis in Wolfson, “Thinking Now Occurring.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_17"
    }
  }, [_vm._v("17")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §36, p. 165 ("), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 171; all references are to the Niemeyer edition unless otherwise noted): “This Greek interpretation of the existential genesis of science is not a matter of chance. It brings to explicit understanding what was prefigured in the statement of Parmenides: τὸ γὰρ αὐτὸ νοεῖν ἐστίν τε καὶ εἶναι. Being is what shows itself in pure, intuitive perception, and only this seeing discovers being. Primordial and genuine truth lies in pure intuition. This thesis henceforth remains the foundation of Western philosophy. The Hegelian dialectic has its motivation in it, and only on its basis is that dialectic possible.” See Heidegger, "), _c('i', [_vm._v("Introduction to Metaphysics")]), _vm._v(", p. 154 ("), _c('i', [_vm._v("Einführung in die Metaphysik")]), _vm._v(", p. 154), where the dictum of Parmenides is designated the “guiding principle ["), _c('i', [_vm._v("Leitsatz")]), _vm._v("] of Western philosophy.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn18"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_18"
    }
  }, [_vm._v("18")]), _vm._v(". Hegel, "), _c('i', [_vm._v("Science of Logic")]), _vm._v(", p. 25; "), _c('i', [_vm._v("Wissenschaft der Logik")]), _vm._v(", vol. 1, bk. 1, p. 29.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_19"
    }
  }, [_vm._v("19")]), _vm._v(". Leahy, "), _c('i', [_vm._v("Foundation")]), _vm._v(", p. 177 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_20"
    }
  }, [_vm._v("20")]), _vm._v(". For a related critique of Leahy, see Altizer, "), _c('i', [_vm._v("Apocalyptic Trinity")]), _vm._v(", p. 164. After noting that the total realization of the "), _c('i', [_vm._v("novitas mundi")]), _vm._v(" only occurs in Leahy’s “thinking now occurring for the first time,” Altizer counters, “Nevertheless, this radically new thinking is in deep continuity with a purely Catholic thinking, and is even in continuity with the radically Protestant thinking of Kierkegaard, for Leahy’s is unquestionably a Christian thinking, and the first Christian thinking since Hegel’s which is a universal thinking.” This is not to say that Altizer denies the novelty of the new thinking promulgated by Leahy; on the contrary, he extols that newness by insisting that Leahy is “a truly postmodern thinker even as Hegel is a truly modern thinker.” I agree, however, with Altizer’s insistence that the radically new thinking is in continuity with older Christian sources.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_21"
    }
  }, [_vm._v("21")]), _vm._v(". Leahy, "), _c('i', [_vm._v("Novitas Mundi")]), _vm._v(", p. xi.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_22"
    }
  }, [_vm._v("22")]), _vm._v(". Ibid., p. 6 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_23"
    }
  }, [_vm._v("23")]), _vm._v(". Ibid., pp. 7–8 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_24"
    }
  }, [_vm._v("24")]), _vm._v(". Leahy, "), _c('i', [_vm._v("Faith and Philosophy")]), _vm._v(", p. 115 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_25"
    }
  }, [_vm._v("25")]), _vm._v(". Ibid., p. 143.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_26"
    }
  }, [_vm._v("26")]), _vm._v(". Ibid., p. 146.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_27"
    }
  }, [_vm._v("27")]), _vm._v(". Ibid., pp. 146–47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_28"
    }
  }, [_vm._v("28")]), _vm._v(". Leahy, "), _c('i', [_vm._v("Beyond Sovereignty")]), _vm._v(", p. 232.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_29"
    }
  }, [_vm._v("29")]), _vm._v(". Leahy, "), _c('i', [_vm._v("Faith and Philosophy")]), _vm._v(", p. 147 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_30"
    }
  }, [_vm._v("30")]), _vm._v(". Falque, "), _c('i', [_vm._v("Metamorphosis of Finitude")]), _vm._v(", p. ix. For a more technical formulation of this point, see Peirce, “Some Consequences of Four Incapacities,” in "), _c('i', [_vm._v("Collected Papers")]), _vm._v(", 5.284, p. 170: “It does not, therefore, follow, because a new constituent of thought gets the uppermost that the train of thought which it displaces is broken off altogether. On the contrary, from our second principle, that there is no intuition or cognition not determined by previous cognitions, it follows that the striking in of a new experience is never an instantaneous affair, but is an "), _c('i', [_vm._v("event")]), _vm._v(" occupying time, and coming to pass by a continuous process. Its prominence in consciousness, therefore, must probably be the consummation of a growing process; and if so, there is no sufficient cause for the thought which has been the leading one just before, to cease abruptly and instantaneously.… There is no exception, therefore, to the law that every thought-sign is translated or interpreted in a subsequent one, unless it be that all thought comes to an abrupt and final end in death” (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_31"
    }
  }, [_vm._v("31")]), _vm._v(". Said, "), _c('i', [_vm._v("Beginnings")]), _vm._v(", pp. 72–73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_32"
    }
  }, [_vm._v("32")]), _vm._v(". Ibid., p. xvii (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_33"
    }
  }, [_vm._v("33")]), _vm._v(". Husserl, "), _c('i', [_vm._v("Experience and Judgment")]), _vm._v(", p. 157 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_34"
    }
  }, [_vm._v("34")]), _vm._v(". Said, "), _c('i', [_vm._v("Beginnings")]), _vm._v(", pp. 48–49.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_35"
    }
  }, [_vm._v("35")]), _vm._v(". Husserl, "), _c('i', [_vm._v("On the Phenomenology of the Consciousness of Internal Time")]), _vm._v(", p. 9. For an alternative version, see Husserl, "), _c('i', [_vm._v("Phenomenology of Internal Time-Consciousness")]), _vm._v(", p. 28.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_36"
    }
  }, [_vm._v("36")]), _vm._v(". Husserl, "), _c('i', [_vm._v("On the Phenomenology of the Consciousness of Internal Time")]), _vm._v(", pp. 9–10. Compare Husserl, "), _c('i', [_vm._v("Phenomenology of Internal Time-Consciousness")]), _vm._v(", pp. 28–29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_37"
    }
  }, [_vm._v("37")]), _vm._v(". Husserl, "), _c('i', [_vm._v("Idea of Phenomenology")]), _vm._v(", p. 33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_38"
    }
  }, [_vm._v("38")]), _vm._v(". Ibid., p. 35.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_39"
    }
  }, [_vm._v("39")]), _vm._v(". Husserl, "), _c('i', [_vm._v("Phenomenology and the Crisis of Philosophy")]), _vm._v(", p. 146.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_40"
    }
  }, [_vm._v("40")]), _vm._v(". Sallis, "), _c('i', [_vm._v("Phenomenology and the Return to Beginnings")]), _vm._v(", p. 17 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_41"
    }
  }, [_vm._v("41")]), _vm._v(". Sallis, “Doublings,” p. 120. The position I have articulated regarding the circle opened at both termini is to be contrasted with the “closed temporal lines” implied in the scientific assumption (traceable to Kurt Gödel) that the structure of the light cones—the oblique lines that delimit the discrete phenomena that fill the gravitational field of spacetime—displays a continuous trajectory in the present toward the future that returns to the originating event of the past. See Rovelli, "), _c('i', [_vm._v("Order of Time")]), _vm._v(", pp. 52–53. On the illusory nature of the present and, by extension, of time more generally, see Rovelli, "), _c('i', [_vm._v("Seven Brief Lessons on Physics")]), _vm._v(", pp. 59–60; Rovelli, "), _c('i', [_vm._v("Reality")]), _vm._v(", pp. 175–83. Consider the summation offered by Rovelli, "), _c('i', [_vm._v("Reality")]), _vm._v(", pp. 182–83: “We must learn to think of the world not as something that changes in time.… Things change only in relation to one another. At a fundamental level, there is no time. Our sense of the common passage of time is only an approximation that is valid for our macroscopic scale. It derives from the fact that we perceive the world in a coarse-grained fashion. Thus, the world described by the theory is far from the one we are familiar with. There is no longer space that ‘contains’ the world, and no longer time ‘during the course of which’ events occur. There are elementary processes in which the quanta of space and matter continuously interact with one another. Just as a calm and clear Alpine lake is made up of a rapid dance of a myriad of minuscule water molecules, the illusion of being surrounded by continuous space and time is a product of a farsighted vision of a dense swarming of elementary processes.” And see the stark evaluation on p. 252, which underscores the gap separating our ordinary perception and the scientific perspective: “We are "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_vm._v("too used to thinking of reality as existing in time. We are beings who live in time: we dwell in time, and are nourished by it. We are an effect of this temporality, produced by average values of microscopic variables. But the limitations of our intuitions should not mislead us.… Time is an effect of our overlooking the physical microstates of things. Time is information we don’t have. Time is our ignorance.”")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_42"
    }
  }, [_vm._v("42")]), _vm._v(". Frey, "), _c('i', [_vm._v("Interruptions")]), _vm._v(", p. 23. See my similar formulation of the paradox of the temporality of the beginning in Wolfson, "), _c('i', [_vm._v("Alef")]), _vm._v(", pp. xiii, 131–32.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_43"
    }
  }, [_vm._v("43")]), _vm._v(". Derrida, "), _c('i', [_vm._v("Specters of Marx")]), _vm._v(", p. 163. See citation and discussion of some other Derridean sources on the nature of the beginning in Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 184–85, and the analysis of the circle and the trace in Protevi, "), _c('i', [_vm._v("Time and Exteriority")]), _vm._v(", pp. 76–110.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_44"
    }
  }, [_vm._v("44")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §65, p. 314 (emphasis in original); "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 329.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_45"
    }
  }, [_vm._v("45")]), _vm._v(". The view I have expressed here resembles the Deleuzian interpretation of Nietzsche’s doctrine of eternal recurrence. See Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", p. 12; Wolfson, “Retroactive Not Yet,” pp. 31–33. A similar interpretation of Nietzsche’s eternal return and its relationship to the moment as a subversion of the metaphysical motif of presence is offered by Wood, "), _c('i', [_vm._v("Deconstruction of Time")]), _vm._v(", pp. 11–35, esp. 26–30. For a different approach to the relationship between Heidegger and Deleuze on the question of repetition, difference, and self-disclosing singularity, see Scott, "), _c('i', [_vm._v("Time of Memory")]), _vm._v(", pp. 189–90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_46"
    }
  }, [_vm._v("46")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Fundamental Concepts")]), _vm._v(", p. 187; "), _c('i', [_vm._v("Grundbegriffe")]), _vm._v(", p. 276. Compare Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §11, p. 50 ("), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 51): “But since the positive sciences neither ‘can’ nor should wait for the ontological work of philosophy, the continuation of research ["), _c('i', [_vm._v("der Fortgang der Forschung")]), _vm._v("] will not be accomplished as ‘progress’ [‘"), _c('i', [_vm._v("Fortschritt")]), _vm._v("’]; but, rather, as the "), _c('i', [_vm._v("repetition")]), _vm._v(" [Wiederholung] and the ontologically more transparent purification of what has been ontically discovered” (emphasis in original). It is of interest in this context to recall the following observation made in the 1925–26 lectures on truth and time published as Heidegger, "), _c('i', [_vm._v("Logic: The Question")]), _vm._v(", p. 168 ("), _c('i', [_vm._v("Logik: Die Frage")]), _vm._v(", pp. 198–99): “And perhaps you notice how little of philosophy, as it has been practiced up to now, is a matter of philosophical reasoning—only in a few circles and to a limited extent—and how it is dominated much more by common sense. Philosophy can make good its claim to being a science (in fact the basic science) only if we drive common sense out of philosophical reasoning.” Heidegger would eventually abandon the classification of philosophy as science, but he preserved and expanded the contrast between the path of thinking and common sense. The upholding of circular reasoning is a primary example of that divergence.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_47"
    }
  }, [_vm._v("47")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings VII–XI")]), _vm._v(", p. 246 (emphasis in original); "), _c('i', [_vm._v("Überlegungen VII–XI")]), _vm._v(", p. 316.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_48"
    }
  }, [_vm._v("48")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings VII–XI")]), _vm._v(", p. 246; "), _c('i', [_vm._v("Überlegungen VII–XI")]), _vm._v(", p. 316.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_49"
    }
  }, [_vm._v("49")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings VII–XI")]), _vm._v(", p. 247 (emphasis in original); "), _c('i', [_vm._v("Überlegungen VII–XI")]), _vm._v(", p. 317. It stands to reason that Heidegger’s criticism of the more conventional cause-effect relationship was indebted to Schelling’s idea of "), _c('i', [_vm._v("Naturbegriffe")]), _vm._v(" as a form of freedom expressed as absolute self-action. See Matthews, "), _c('i', [_vm._v("Schelling’s Organic Form of Philosophy")]), _vm._v(", p. 19: “Exploding the linear causality of the mathematical categories, the multivalent causality of nature as a dynamic whole provides Schelling with an understanding of life, as absolute self-action, as the schema of freedom.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_50"
    }
  }, [_vm._v("50")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings VII–XI")]), _vm._v(", p. 247 (emphasis in original); "), _c('i', [_vm._v("Überlegungen VII–XI")]), _vm._v(", p. 317.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_51"
    }
  }, [_vm._v("51")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §32, pp. 145–46; "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 150. Compare the comments of Heidegger, "), _c('i', [_vm._v("On the Way to Language")]), _vm._v(", p. 51; "), _c('i', [_vm._v("Unterwegs zur Sprache")]), _vm._v(", p. 142. In that later work, Heidegger still affirms the inevitability of the circular motion of thinking—related specifically to the claim that the human being is the message bearer that comes from the very message toward which one is going—but he distances himself from the idea that the circle can give us an originary experience of the hermeneutic relation. On the hermeneutic circularity in Heidegger, see Gadamer, "), _c('i', [_vm._v("Truth and Method")]), _vm._v(", pp. 268–73; de Man, "), _c('i', [_vm._v("Blindness and Insight")]), _vm._v(", pp. 29–31.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_52"
    }
  }, [_vm._v("52")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §32, p. 148 (emphasis in original); "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 153. See Spanos, “Heidegger, Kierkegaard, and the Hermeneutic Circle”; Spanos, "), _c('i', [_vm._v("Heidegger and Criticism")]), _vm._v(", pp. 53–80; and Bontekoe, "), _c('i', [_vm._v("Dimensions of the Hermeneutic Circle")]), _vm._v(", pp. 62–91.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_53"
    }
  }, [_vm._v("53")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §63, pp. 301–2; "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 315.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_54"
    }
  }, [_vm._v("54")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §46, pp. 227–29; "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", pp. 235–37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_55"
    }
  }, [_vm._v("55")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §48, p. 233; "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 242. On the connection between death and the sense of mineness, see Winkler, “Time, Singularity and the Impossible.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_56"
    }
  }, [_vm._v("56")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §48, p. 236; "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 245.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_57"
    }
  }, [_vm._v("57")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §50, p. 241 (emphasis in original); "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 250.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_58"
    }
  }, [_vm._v("58")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §50, p. 241 (emphasis in original); "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 251.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn59"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_59"
    }
  }, [_vm._v("59")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Fundamental Concepts")]), _vm._v(", p. 187; "), _c('i', [_vm._v("Grundbegriffe")]), _vm._v(", p. 276. See the discussion on the relationship between logic and metaphysics in Heidegger, "), _c('i', [_vm._v("Heraclitus")]), _vm._v(", p. 193 ("), _c('i', [_vm._v("Heraklit")]), _vm._v(", pp. 252–53): “This determination of logic as the metaphysics of λόγος does not in fact bring clarity, but passes itself off as information only from out of a place of perplexity ["), _c('i', [_vm._v("eine Auskunft der Verlegenheit")]), _vm._v("]. But this perplexity in which we now find ourselves is unavoidable: for what metaphysics is can in large part only be illuminated through a clarification of the essence of ‘logic.’ At the same time, the opposite also holds true: what ‘logic’ is can only be clarified from out of the essence of metaphysics. We move, therefore, in a circle ["), _c('i', [_vm._v("Kreis")]), _vm._v("]. As soon as thinking enters into such a circular path, it is often—though not always—a sign that such thinking can abide in the realm of the essential ["), _c('i', [_vm._v("im Umkreis des Wesenhaften")]), _vm._v("], or can at least draw nearer to its outer precincts.” Compare Heidegger, "), _c('i', [_vm._v("Hölderlin’s Hymn")]), _vm._v(" “"), _c('i', [_vm._v("Remembrance")]), _vm._v(",” p. 42; "), _c('i', [_vm._v("Hölderlins Hymne")]), _vm._v(" “"), _c('i', [_vm._v("Andenken")]), _vm._v(",” p. 48. Commenting on Hölderlin’s use of the image of the blowing of the northeasterly wind in conjunction with the injunction to embark on a voyage, Heidegger writes: “Thus, the line ‘But go now and greet,’ is indeed departure. Certainly. But departure is not always ‘taking leave.’ Do we actually know what ‘departure’ is? Do we even know what the ‘blowing’ of the wind is, assuming that we do not simply mean the tangible movement of air? Blowing: a coming that goes, and, in going, comes. Departure is not mere release and empty remaining behind. Departure is also not a mere going away and vanishing.… Just as the blowing of the wind is a coming and going that reciprocally exceed one another, so the greeting is a remaining behind and yet a going with that reciprocally demand one another.” Heidegger’s eliciting from the image of the wind blowing the idea that the going is the coming, and the coming is the going, and that bidding farewell is not an end but the greeting of another commencement, coincides with his view that the way of thinking is marked by an open circularity such that departing is always at the same time returning and returning is always at the same time departing.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_60"
    }
  }, [_vm._v("60")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Fundamental Concepts")]), _vm._v(", p. 187; "), _c('i', [_vm._v("Grundbegriffe")]), _vm._v(", p. 276.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_61"
    }
  }, [_vm._v("61")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Fundamental Concepts")]), _vm._v(", p. 183; "), _c('i', [_vm._v("Grundbegriffe")]), _vm._v(", p. 272. Hass, “Ambiguity of Being,” argues that Heidegger’s essential thought, the question of being, must always remain ambiguous.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_62"
    }
  }, [_vm._v("62")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Country Path Conversations")]), _vm._v(", pp. 13–14; "), _c('i', [_vm._v("Feldweg-Gespräche")]), _vm._v(", p. 21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_63"
    }
  }, [_vm._v("63")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §29, p. 53; "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 66.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_64"
    }
  }, [_vm._v("64")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Four Seminars")]), _vm._v(", p. 79; "), _c('i', [_vm._v("Seminare")]), _vm._v(", p. 397.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_65"
    }
  }, [_vm._v("65")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Four Seminars")]), _vm._v(", p. 80; "), _c('i', [_vm._v("Seminare")]), _vm._v(", p. 399.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_66"
    }
  }, [_vm._v("66")]), _vm._v(". Derrida, "), _c('i', [_vm._v("Truth in Painting")]), _vm._v(", p. 32.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_67"
    }
  }, [_vm._v("67")]), _vm._v(". Ibid., 33 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_68"
    }
  }, [_vm._v("68")]), _vm._v(". Wood, "), _c('i', [_vm._v("Deconstruction of Time")]), _vm._v(", p. 217.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_69"
    }
  }, [_vm._v("69")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §74, p. 366 (emphasis in original); "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 385. For a wide-ranging study of this topic, see Ruin, "), _c('i', [_vm._v("Enigmatic Origins")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_70"
    }
  }, [_vm._v("70")]), _vm._v(". Husserl, "), _c('i', [_vm._v("Cartesian Meditations")]), _vm._v(", p. 75 (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_71"
    }
  }, [_vm._v("71")]), _vm._v(". For an analysis of the discussion of guilt and the irretrievable in "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", see Coyne, "), _c('i', [_vm._v("Heidegger’s Confessions")]), _vm._v(", pp. 144–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_72"
    }
  }, [_vm._v("72")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §65, p. 311 (emphasis in original); "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", pp. 325–26. Compare the passage from "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(" cited in ch. 6 at n. 74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_73"
    }
  }, [_vm._v("73")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §74, p. 367 (emphasis in original); "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 385. On Heidegger’s notion of repetition as the ontological structure of historicity, see Ruin, "), _c('i', [_vm._v("Enigmatic Origins")]), _vm._v(", pp. 82–83n28, 132–33. See also the analysis of repetition in light of Heidegger’s idea of anticipatory resolution (discussed in relation to both Kierkegaard and Deleuze) in Rot, “From Anxiety to Boredom,” pp. 152–62. For the possibility that Heidegger’s "), _c('i', [_vm._v("Wiederholung")]), _vm._v(" reflects the influence of Kierkegaard’s idea of repetition, see Spanos, “Heidegger, Kierkegaard, and the Hermeneutic Circle,” pp. 122–26, and Spanos, "), _c('i', [_vm._v("Heidegger and Criticism")]), _vm._v(", pp. 60–66. For discussion of the Kierkegaardian idea of repetition, see Melberg, “Repetition”; Crites, “Blissful Security”; Carlisle, "), _c('i', [_vm._v("Kierkegaard’s Philosophy of Becoming")]), _vm._v(", pp. 67–89; Ward, "), _c('i', [_vm._v("Augenblick")]), _vm._v(", pp. 1–33, esp. 11–15. On the affinity between Kierkegaard’s use of the notion of the eye-blink ("), _c('i', [_vm._v("øjeblik")]), _vm._v(") to shed light on the temporal paradox of the "), _c('i', [_vm._v("kairos")]), _vm._v(" as continuous and discontinuous, the moment manifesting both stasis and change, and Heidegger’s view of the now as the opening to the future as the retrieval of the unprecedented, see North, "), _c('i', [_vm._v("What Is the Present?")]), _vm._v(", pp. 31–32, 35–39.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_74"
    }
  }, [_vm._v("74")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §74, pp. 367–68 (emphasis in original); "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", pp. 385–86. See Mehta, "), _c('i', [_vm._v("Martin Heidegger")]), _vm._v(", pp. 282–83.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_75"
    }
  }, [_vm._v("75")]), _vm._v(". Heidegger returned to this theme in the 1955–56 lecture course at the University of Freiburg on the Leibnizian "), _c('i', [_vm._v("principium rationis")]), _vm._v(" that “nothing is without reason” ("), _c('i', [_vm._v("Nichts ist ohne Grund")]), _vm._v("). See Heidegger, "), _c('i', [_vm._v("Principle of Reason")]), _vm._v(", p. 89 ("), _c('i', [_vm._v("Satz vom Grund")]), _vm._v(", p. 132): “Nevertheless the history of Western thinking shows itself as the "), _c('i', [_vm._v("Geschick")]), _vm._v(" of being when and only when we glance back upon the whole of Western "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_vm._v("thinking "), _c('i', [_vm._v("from the point of view of the leap")]), _vm._v(" and when we recollectively preserve it as the "), _c('i', [_vm._v("Geschick")]), _vm._v(" of being that has-been.… The leap leaves the realm from which one leaps while at the same time recollectively regaining anew what has been left such that what has-been becomes, for the first time, something we cannot lose. That into which the leap anticipatorily leaps is not some region of things present at hand into which one can simply step. Rather, it is the realm of what first approaches as worthy of thought. But this approach is also shaped by the traits of what has-been, and only because of this is it discernible” (emphasis in original). And compare Heidegger, "), _c('i', [_vm._v("Principle of Reason")]), _vm._v(", p. 102 ("), _c('i', [_vm._v("Satz vom Grund")]), _vm._v(", p. 153): “If it rigidifies, a legacy ["), _c('i', [_vm._v("Überlieferung")]), _vm._v("] can degenerate into a burden and a handicap. It can become this because a legacy is genuinely, as its name says, a delivering ["), _c('i', [_vm._v("Liefern")]), _vm._v("] in the sense of "), _c('i', [_vm._v("liberare")]), _vm._v(", of liberating ["), _c('i', [_vm._v("Befreiung")]), _vm._v("]. As a liberating ["), _c('i', [_vm._v("Befreien")]), _vm._v("], a legacy raises concealed riches of what has-been ["), _c('i', [_vm._v("Gewesenen")]), _vm._v("] into the light of day, even if this light is at first only that of a hesitant dawn.”")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_76"
    }
  }, [_vm._v("76")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Identity and Difference")]), _vm._v(", p. 72; German text: p. 141. On the sense of return implicit in the originary reflection of thinking as the task to think what is to-be-thought in the future, see the passage from Heidegger’s "), _c('i', [_vm._v("Heraklit")]), _vm._v(" cited in ch. 4 n. 14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_77"
    }
  }, [_vm._v("77")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Essence of Truth")]), _vm._v(", p. 7; "), _c('i', [_vm._v("Vom Wesen der Wahrheit")]), _vm._v(", pp. 9–10.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_78"
    }
  }, [_vm._v("78")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings II–VI")]), _vm._v(", p. 144; "), _c('i', [_vm._v("Überlegungen II–VI")]), _vm._v(", p. 196.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_79"
    }
  }, [_vm._v("79")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings II–VI")]), _vm._v(", p. 257; "), _c('i', [_vm._v("Überlegungen II–VI")]), _vm._v(", p. 353.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_80"
    }
  }, [_vm._v("80")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings VII–XI")]), _vm._v(", p. 201 (emphasis in original); "), _c('i', [_vm._v("Überlegungen VII–XI")]), _vm._v(", p. 260.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_81"
    }
  }, [_vm._v("81")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §29, p. 53; "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 66.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_82"
    }
  }, [_vm._v("82")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Basic Questions")]), _vm._v(", p. 38; "), _c('i', [_vm._v("Grundfragen")]), _vm._v(", pp. 40–41. The view of the origin against which Heidegger is philosophizing is well summarized by Kant, "), _c('i', [_vm._v("Religion within the Boundaries of Mere Reason")]), _vm._v(", p. 61: “Origin (the first origin) is the descent of an effect from its first cause, i.e. from that cause which is not in turn the effect of another cause of the same kind. It can be considered as either "), _c('i', [_vm._v("origin according to reason")]), _vm._v(", or "), _c('i', [_vm._v("origin according to time")]), _vm._v(". In the first meaning, only the effect’s "), _c('i', [_vm._v("being")]), _vm._v(" is considered; in the second, its "), _c('i', [_vm._v("occurrence")]), _vm._v(", and hence, as an event, it is referred to its "), _c('i', [_vm._v("cause in time")]), _vm._v("” (emphasis in original). From Heidegger’s perspective, both senses are guilty of ontologizing the origin as if it were a being subject to temporal and spatial determinism.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_83"
    }
  }, [_vm._v("83")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §33, p. 58 (emphasis in original); "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 73. For my previous discussions of this aphorism, see Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 243–44; Wolfson, “Retroactive Not Yet,” pp. 33–34. Compare the anecdote about Socrates in Heidegger, "), _c('i', [_vm._v("Zollikon Seminars")]), _vm._v(", p. 24 ("), _c('i', [_vm._v("Zollikoner Seminare: Protokolle")]), _vm._v(", p. 30): “A widely traveled sophist asks Socrates: ‘Are you still here and still saying the same thing? You are making light of the matter.’ Socrates answers: ‘No, you sophists are making light of it because you are always saying what’s new and the very latest [news]. You always say something different. To say the same thing is what’s difficult. To say the same thing about the same thing is the most difficult ["), _c('i', [_vm._v("Das Schwere aber ist, das Selbe zu sagen und das allerschwerste: vom Selben das Selbe zu sagen")]), _vm._v("].’” For an alternative version, see Heidegger, "), _c('i', [_vm._v("Zollikoner Seminare")]), _vm._v(", p. 143: “Das Schwerste ist nicht nur, das Selbe zu sagen—sondern über das Selbe—das Selbe sagen,” “The hardest thing is not just to say the same thing, but to say the same about the same thing.” Heidegger is alluding to the comment of Socrates to Callicles in Plato, "), _c('i', [_vm._v("Gorgias")]), _vm._v(" 491b, in "), _c('i', [_vm._v("Collected Dialogues")]), _vm._v(", p. 273: “For you claim that I keep saying the same things, and reproach me with it, but I make the opposite statement of you, that you never say the same things about the same subjects.” As the translators of the "), _c('i', [_vm._v("Zollikon Seminars")]), _vm._v(" note, the anecdote about Socrates is mentioned as well in Heidegger, "), _c('i', [_vm._v("What Is a Thing?")]), _vm._v(", pp. 73–74 ("), _c('i', [_vm._v("Frage Nach dem Ding")]), _vm._v(", p. 74), to elucidate the point that the most difficult learning is to come to know the ground of what we already know. Sophistry consists of pretending that one is always offering something novel, whereas genuine thinking ensues from saying the same thing about the same thing because only that kind of repetition amounts to genuine innovation.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_84"
    }
  }, [_vm._v("84")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Introduction to Metaphysics")]), _vm._v(", p. 41 (emphasis in original); "), _c('i', [_vm._v("Einführung in die Metaphysik")]), _vm._v(", p. 42. See Wolfson, “Revealing and Re/veiling,” pp. 33–34, and the sources that treat the paradox of the repetition of the origin in Heidegger cited op. cit., p. 34n35. See also Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 442–43n116.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_85"
    }
  }, [_vm._v("85")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §238, p. 293 (emphasis in original); "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 371.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_86"
    }
  }, [_vm._v("86")]), _vm._v(". Compare Heidegger, "), _c('i', [_vm._v("Zollikoner Seminare")]), _vm._v(", p. 322: “Das Endliche "), _c('i', [_vm._v("ist")]), _vm._v(" unendlich; die Unendlichkeit "), _c('i', [_vm._v("ist")]), _vm._v(" das Endliche. Das Endliche—als solches Negation der Negation,” “The finite "), _c('i', [_vm._v("is")]), _vm._v(" infinite; infinity "), _c('i', [_vm._v("is")]), _vm._v(" the finite. The finite—as such negation of negation.” See Löwith, “F. Rosenzweig and M. Heidegger,” pp. 76–77. For additional bibliographic information, see ch. 2, n. 75. Here I take issue with the contention of Strauss, "), _c('i', [_vm._v("Leo Strauss on Nietzsche’s")]), _vm._v(" Thus Spoke Zarathustra, p. 187. I concur with Strauss that “Heidegger’s "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_vm._v("criticism of Nietzsche is very exact and according to Nietzsche’s thought. It confirms primarily the doctrine of eternal return, because if that is dropped Nietzsche’s whole doctrine is finished.” I disagree, however, with Strauss’s further claim that Heidegger must totally reject the doctrine of the eternal return since “no reference to eternity is even possible.” While it is accurate to say that there is no conventional understanding of the eternal in Heidegger, that is, an eternality that is in opposition to temporality, it is not correct to deny that his conception of time as the replication of difference does affirm a sense of the eternalization of the temporal in a way that may be seen as a continuation of Kierkegaard and Nietzsche. See Ward, "), _c('i', [_vm._v("Augenblick")]), _vm._v(", pp. 97–124, esp. 120–22, and the text of Heidegger cited in ch. 6 at n. 231. On the importance of Kierkegaard in understanding the crucial difference between temporality and time in Heidegger, see Manchester, "), _c('i', [_vm._v("Temporality and Trinity")]), _vm._v(", pp. 10–17, and compare the discussion of temporality and eternity on pp. 55–60. There are phenomenological similarities as well between the Heideggerian (and, in my mind, kabbalistic) conception and the Buddhist teaching concerning the permanent impermanence of time to emerge from the coming to be and passing away of all conditioned entities ("), _c('i', [_vm._v("saṃskṛta")]), _vm._v(", "), _c('i', [_vm._v("saṃskāra")]), _vm._v(") in an uninterrupted and continuous flow ("), _c('i', [_vm._v("santāna")]), _vm._v("); see von Rospatt, "), _c('i', [_vm._v("Buddhist Doctrine of Momentariness")]), _vm._v(". On the theological attempt to attribute the notion of God’s temporality to Heidegger, see the analysis of Ogden, "), _c('i', [_vm._v("Reality of God")]), _vm._v(", pp. 144–63.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_87"
    }
  }, [_vm._v("87")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §23, pp. 46–47; "), _c('i', [_vm._v("Beiträge")]), _vm._v(", pp. 57–59. See Fell, “Heidegger’s Notion of Two Beginnings”; Stambaugh, "), _c('i', [_vm._v("Finitude of Being")]), _vm._v(", pp. 112–14. Heidegger, "), _c('i', [_vm._v("Heraclitus")]), _vm._v(", p. 37 ("), _c('i', [_vm._v("Heraklit")]), _vm._v(", p. 44), elicits from Heraclitus the notion of the “inceptual to-be-thought” ("), _c('i', [_vm._v("das anfänglich Zu-denkende")]), _vm._v("), an idea that well encapsulates the paradoxical relation of beginning and end in the Heideggerian hermeneutic of time: the inception is marked in perpetuity as that which is to be thought, and hence past and future converge in the present, albeit always in the sameness of their difference.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_88"
    }
  }, [_vm._v("88")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §20, p. 44; "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_89"
    }
  }, [_vm._v("89")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Ponderings VII–XI")]), _vm._v(", p. 196; "), _c('i', [_vm._v("Überlegungen VII–XI")]), _vm._v(", p. 254. Compare the paradoxical description of the poetic utterance as "), _c('i', [_vm._v("das dem Wort des Seyns nach-sagende Vorsagen")]), _vm._v(" in the essay “Die Einzigkeit des Dichters” (1943) in Heidegger, "), _c('i', [_vm._v("Zu Hölderlin")]), _vm._v(", p. 37. The hermeneutical claim that the word of the poet is a pre-saying that says after the word of beyng rests on the temporal assumption that the future is a repetition of the past in the present as that which is yet to be. In Heidegger’s mind, Hölderlin was the poet who uniquely achieved the ability to speak the word that is both predictive and commemorative; the poet’s calling is, quite literally, the “after-saying pre-saying of the issued invocation of beyng” ("), _c('i', [_vm._v("nachsagenden Vorsagen des ergangenen Rufes des Seyns")]), _vm._v("). The historical destiny ("), _c('i', [_vm._v("Schickung")]), _vm._v(") that sends forth the poetic saying is thus always emerging from the future, the time that is coming ("), _c('i', [_vm._v("aus der Zukunft Kommende: die kommende Zeit")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_90"
    }
  }, [_vm._v("90")]), _vm._v(". Schürmann, "), _c('i', [_vm._v("Broken Hegemonies")]), _vm._v(", p. 581. Compare Schürmann, “Brutal Awakening,” p. 94: “Yes, since for the phenomenologist of being, "), _c('i', [_vm._v("there is")]), _vm._v(" nothing other than singulars. This "), _c('i', [_vm._v("there is")]), _vm._v(", to be sure, is not nothing. It ‘is’ being itself qua event. But a universal and most intense being, which would be normative for everything else as it locates all things between the top and the bottom of a scale, lacks any phenomenality. Or, rather, it possesses only phantasmic phenomenality, as the one historical illusion” (emphasis in original).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_91"
    }
  }, [_vm._v("91")]), _vm._v(". Schürmann, "), _c('i', [_vm._v("Broken Hegemonies")]), _vm._v(", pp. 581–82. On the related appeal to read Heidegger’s corpus in a unified way despite his reference to the reversal of his path—a turn rather than a break—see the assessment of Schürmann in Critchley and Schürmann, "), _c('i', [_vm._v("On Heidegger’s Being and Time")]), _vm._v(", p. 58. See also below, n. 102.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_92"
    }
  }, [_vm._v("92")]), _vm._v(". Courtine, “Phenomenology and/or Tautology,” p. 241.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_93"
    }
  }, [_vm._v("93")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §259, pp. 342–43 (emphasis in original); "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 434.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_94"
    }
  }, [_vm._v("94")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §259, p. 343 (emphasis in original); "), _c('i', [_vm._v("Beiträge")]), _vm._v(", pp. 434–35.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_95"
    }
  }, [_vm._v("95")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("History of the Concept of Time")]), _vm._v(", p. 138 (emphasis in original); "), _c('i', [_vm._v("Prolegomena zur Geschichte des Zeitbegriffs")]), _vm._v(", p. 188. On the widespread view of history as repetition in the period of Heidegger’s "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", see Korab-Karpowicz, "), _c('i', [_vm._v("Presocratics")]), _vm._v(", pp. 37–41.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_96"
    }
  }, [_vm._v("96")]), _vm._v(". Ward, "), _c('i', [_vm._v("Heidegger’s Political Thinking")]), _vm._v(", p. 99.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn97"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_97"
    }
  }, [_vm._v("97")]), _vm._v(". Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", pp. 259–60 ("), _c('i', [_vm._v("Stern der Erlösung")]), _vm._v(", pp. 269–70): “Redemption is therefore the end before which all that has begun turns back to be engulfed in its beginning. It is only in this way that it is com-plete ["), _c('i', [_vm._v("Voll-endung")]), _vm._v("]. All that is still immediately attached to its beginning is not yet in the full sense actual ["), _c('i', [_vm._v("ist noch nicht im vollen Sinne tatsächlich")]), _vm._v("]; for the beginning whence it sprang can always draw it inside again. This is true for the thing that emerged as Yes of the Not-Nothing ["), _c('i', [_vm._v("Ja des Nichtnichts")]), _vm._v("] as well as for the act that emerged as No of the Nothing ["), _c('i', [_vm._v("Nein des Nichts")]), _vm._v("]. True permanence is "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_vm._v("always permanence projected into the future and upon the future. That which always was is not that which is lasting: the world was always; nor is it that which is constantly renewed: living experience ["), _c('i', [_vm._v("Erlebnis")]), _vm._v("] is always new; it is only that which is eternally coming: the Kingdom. It is not the thing ["), _c('i', [_vm._v("Sache")]), _vm._v("], it is not the act ["), _c('i', [_vm._v("Tat")]), _vm._v("], it is only the fact ["), _c('i', [_vm._v("Tatsache")]), _vm._v("] that is secure against falling back into the Nothing” (translation slightly modified). Redemption signifies the end that completes the beginning but that beginning whence the end springs forth is renewed continually by that which is both coming eternally and anticipated at every moment. Compare Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", p. 243; "), _c('i', [_vm._v("Stern der Erlösung")]), _vm._v(", pp. 252–53"), _c('i'), _vm._v(". Permanence, therefore, is not a matter of the past but rather of that which is projected into the future. On the shared notion in Rosenzweig and Heidegger of the present gaining its meaning in terms of the future, see Gordon, "), _c('i', [_vm._v("Rosenzweig and Heidegger")]), _vm._v(", pp. 197–98.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn98"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_98"
    }
  }, [_vm._v("98")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("On the Way to Language")]), _vm._v(", p. 54; "), _c('i', [_vm._v("Unterwegs zur Sprache")]), _vm._v(", p. 146.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1",
    attrs: {
      "id": "ch1fn99"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_99"
    }
  }, [_vm._v("99")]), _vm._v(". Kahn, "), _c('i', [_vm._v("Art and Thought of Heraclitus")]), _vm._v(", pp. 52–53; and see analysis on p. 223.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn100"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_100"
    }
  }, [_vm._v("100")]), _vm._v(". Greek original and English translation as cited in Graham, "), _c('i', [_vm._v("Texts of Early Greek Philosophy")]), _vm._v(", pp. 158–59. For discussion of the Platonic paraphrase of the Heraclitean dictum, see Kahn, "), _c('i', [_vm._v("Art and Thought of Heraclitus")]), _vm._v(", pp. 168–69.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_101"
    }
  }, [_vm._v("101")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Hölderlin’s Hymns")]), _vm._v(" “"), _c('i', [_vm._v("Germania")]), _vm._v("” "), _c('i', [_vm._v("and")]), _vm._v(" “"), _c('i', [_vm._v("The Rhin")]), _vm._v("e,” p. 106; "), _c('i', [_vm._v("Hölderlins Hymnen")]), _vm._v(" “"), _c('i', [_vm._v("Germanien")]), _vm._v("” "), _c('i', [_vm._v("und")]), _vm._v(" “"), _c('i', [_vm._v("Der Rhein")]), _vm._v(",” p. 117.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn102"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_102"
    }
  }, [_vm._v("102")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Off the Beaten Track")]), _vm._v(", p. 21 (emphasis in original); "), _c('i', [_vm._v("Holzwege")]), _vm._v(", p. 29. Here again there is an interesting affinity between Heidegger and Rosenzweig, who reported that he accepted the suggestion of reading his "), _c('i', [_vm._v("magnum opus")]), _vm._v(" in reverse from the end to the beginning. See Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 43–44, and references cited on pp. 311–12nn72–74. Finally, it is worth mentioning Heidegger’s remark in a letter to Karl Löwith from August 1927 that he was not interested in charting the “development” of his work on the basis of “the sequence of lecture courses and what is only communicated in them” because this “shortwinded consideration forgets the central perspectives and impulses at work both backwards and forwards.” I have availed myself of the translation of this letter in Kisiel, “"), _c('i', [_vm._v("Kriegsnotsemester")]), _vm._v(" 1919,” p. 160. Consider also the parenthetical aside in Heidegger, "), _c('i', [_vm._v("Heraclitus")]), _vm._v(", p. 50 ("), _c('i', [_vm._v("Heraklit")]), _vm._v(", p. 64): “That is why thinkers, and only thinkers, have the experience that they one day come to understand themselves better in light of what they have already thought, in such a way that the entire edifice of their earlier thought suddenly collapses, even though they always think the same. But this ‘same’ is not the boring emptiness of the identical ["), _c('i', [_vm._v("Gleichen")]), _vm._v("], which is only a semblance of the same ["), _c('i', [_vm._v("ein Anschein des Selben")]), _vm._v("]. There are those, however, who do not know of the restiveness of the same, and who are proud of the fact that they, at seventy, still think the same as what they already thought and knew as high school students.” Despite Heidegger’s own aversion to temporalizing his work in a chronological manner, scholarship on him—including, ironically, the aforementioned study by Kisiel, which documents the hermeneutic breakthrough in Heidegger’s intellectual biography—has been dominated by precisely such an approach. This is most evident in the repeated distinction between the presumed earlier and later stages of Heideggerian thought. For notable exceptions, see Schürmann, "), _c('i', [_vm._v("Broken Hegemonies")]), _vm._v(", pp. 581–82, and Sheehan, "), _c('i', [_vm._v("Making Sense")]), _vm._v(". Summarizing the content of his study (p. 23), Sheehan states his argument is based on three theses: (1) Heidegger’s work is phenomenological from beginning to end; (2) what Heidegger means by "), _c('i', [_vm._v("das Sein")]), _vm._v(" is the intelligibility of things or their meaningful presence ("), _c('i', [_vm._v("Anwesen")]), _vm._v(") to human intelligence; and (3) the final goal, the thing itself, is what makes this intelligibility possible, "), _c('i', [_vm._v("das Ermöglichende")]), _vm._v(", that is, that which enables the materiality of ex-sistence to assume the appearance of, or to light up as, the thrown-open clearing.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn103"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_103"
    }
  }, [_vm._v("103")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §20, p. 45 (emphasis in original); "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn104"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_104"
    }
  }, [_vm._v("104")]), _vm._v(". Arendt, "), _c('i', [_vm._v("Life of the Mind")]), _vm._v(", 2:43, suggested that Heidegger’s insight that the past has its origin in the future is already evident in Hegel. Compare Comay, "), _c('i', [_vm._v("Mourning Sickness")]), _vm._v(", p. 65. Commenting on Hegel’s statement that “the deed is not imperishable” ("), _c('i', [_vm._v("die Tat ist nicht das Unvergängliche")]), _vm._v("), Comay writes, “The double negative actually conceals a triple negative: the deed (or fact) is not in-trans-ient. The negation of the negation is not a return to substantial positivity, but rather an exposure to irrecuperable transience. Time remains irreversible.… The obduracy of the deed remains, but it no longer confronts me as a stony obstacle.… The event is historicized: instead of determining the future, the past is freed to receive a new meaning from the future.” See as well Kolb, “Circulation and Constitution at the End of History.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn105"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_105"
    }
  }, [_vm._v("105")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("What Is Called Thinking?")]), _vm._v(", pp. 76–77; "), _c('i', [_vm._v("Was Heißt Denken")]), _vm._v("?, pp. 82–83.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn106"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_106"
    }
  }, [_vm._v("106")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Identity and Difference")]), _vm._v(", p. 41; German text: p. 106. The threads of the calculative orientation and politics are intertwined in Heidegger’s thought. On this entanglement, see Elden, "), _c('i', [_vm._v("Speaking against Number")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn107"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_56",
      "title": "56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_107"
    }
  }, [_vm._v("107")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Fundamental Concepts")]), _vm._v(", p. 368; "), _c('i', [_vm._v("Grundbegriffe")]), _vm._v(", p. 534.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_108"
    }
  }, [_vm._v("108")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Fundamental Concepts")]), _vm._v(", p. 367; "), _c('i', [_vm._v("Grundbegriffe")]), _vm._v(", p. 534. Compare the related but somewhat different formulation in the address “Dank an die Heimatstadt Meßkirch,” delivered September 27, 1959, and printed in Heidegger, "), _c('i', [_vm._v("Reden und Andere Zeugnisse")]), _vm._v(", pp. 558–59: “Denn der Weg im Denken ist nicht nur eine Methode, sondern der Weg gehört im Denken zur Sache selbst, was ich Ihnen kurz so deutlich mache, daß der Übergang meiner kurzen Worte vom Dank zum Denken nicht so schwer ist, wenn man denkt. Denn Danken und Denken sind nicht nur dasselbe Wort, sondern dieselbe Sache.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn109"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_109"
    }
  }, [_vm._v("109")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Überlegungen VII–XI")]), _vm._v(", pp. 96–97. I have elaborated on this topic in Wolfson, "), _c('i', [_vm._v("Duplicity")]), _vm._v(", pp. 87–108.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn110"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_110"
    }
  }, [_vm._v("110")]), _vm._v(". From a different vantagepoint, and without probing the primary sources, Goodman, “Give the Word,” p. 157, suggested in passing that Heidegger’s essential thinking and the kabbalah “have the same temporal and receptive contours.” This accords with my own view that kabbalists and Heidegger both presume a conception of time that casts the past as open in the present and therefore renders tradition as a thinking forward rather than a thinking backward. Consider Heidegger, "), _c('i', [_vm._v("On the Way to Language")]), _vm._v(", p. 31 ("), _c('i', [_vm._v("Unterwegs zur Sprache")]), _vm._v(", p. 117): “What you learned there has been learned in turn by listening to the thinker’s thinking. Each man is in each instance in dialogue with his forebears, and perhaps even more and in a more hidden manner with those who will come after him.” The historical nature of what Heidegger calls the “thinking dialogue” with previous thinkers is to be contrasted with the historiographical reports of the past. Relevant here is the study of Dolgopolski, "), _c('i', [_vm._v("Open Past")]), _vm._v(". The author’s claim that the dialogical conversations in the Talmud are driven by, and toward, an open past that is radically different from the futuristic orientation of chronological time bears much affinity with my understanding of Heideggerian hermeneutics. Although Heidegger’s tempocentrism is oriented toward the future, the future is privileged to the extent that it is the standpoint whence the past can be reconvened as the not yet rather than the no longer. As I have argued elsewhere, Heidegger’s embrace of circularity to explain the hermeneutical structure of human understanding and the attendant comportment of temporality is such that distending into the future is an anticipatory leap in the present back to the ground of the past where one is already standing, a return to where one has always never been. See Wolfson, "), _c('i', [_vm._v("Duplicity")]), _vm._v(", pp. 5, 103–4, 116. The genuine legacy of tradition, on this score, is a liberating gesture that delivers us to the past and thereby discloses by bringing to light that which is concealed in darkness. See above, n. 75. The pliability of the past is what distinguishes authentic from inauthentic time. For his part, Dolgopolski, "), _c('i', [_vm._v("Open Past")]), _vm._v(", pp. 21–33, contrasts the ontological-homogenic approach of Heidegger to the heterogenic perspective on the relation of thinking and memory that he elicits from the Jewish tradition exemplified in talmudic literature. See ibid., pp. 92, 312–13nn5–6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn111"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_111"
    }
  }, [_vm._v("111")]), _vm._v(". See above, n. 94.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn112"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_112"
    }
  }, [_vm._v("112")]), _vm._v(". Altmann, "), _c('i', [_vm._v("Meaning of Jewish Existence")]), _vm._v(", p. 54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn113"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_113"
    }
  }, [_vm._v("113")]), _vm._v(". Ibid., pp. 54–55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn114"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_114"
    }
  }, [_vm._v("114")]), _vm._v(". Ibid., p. 55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_115"
    }
  }, [_vm._v("115")]), _vm._v(". Soloveitchik, "), _c('i', [_vm._v("Lonely Man of Faith")]), _vm._v(", p. 68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn116"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_116"
    }
  }, [_vm._v("116")]), _vm._v(". Ibid., pp. 68–69.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn117"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_117"
    }
  }, [_vm._v("117")]), _vm._v(". Ibid. See analysis in Wolfson, “Eternal Duration,” pp. 226–28. The affinity between Soloveitchik and Heidegger is discussed at length on pp. 208–12n37. The curious reader will find reference there to other scholars, who have weighed in on the similarities between these two thinkers.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_118"
    }
  }, [_vm._v("118")]), _vm._v(". See my brief comment in Wolfson, “Eternal Duration,” p. 228. For a more detailed comparison, see Cohen, “Halakah, Sacred Events, and Time Consciousness.” Cohen mentions my work on pp. 90–91n8. While he accepts that there is a circularity of time in both Rosenzweig and Soloveitchik, related to their shared assumption about the simultaneity of past, present, and future, Cohen maintains that only in Soloveitchik can one make an appeal “to the possibility of simultaneity even within a linear framework in his unique conception of individual repentance.” Cohen thus concludes that it is difficult to accept my alleged “conflation of linearity and circularity as simultaneous features of Rosenzweig’s conception of sacred time.” A careful examination of my work demonstrates that I have not argued that the juxtaposition of linearity and circularity implies their conflation; on the contrary, in the Heideggerian terms that have influenced my own thinking, juxtaposition is decidedly not conflation. What I have suggested is that one can adduce from Rosenzweig’s new thinking, as I have elicited from kabbalistic sources, that there is a dual deportment of time, the extending line that rotates like a sphere and the rotating sphere that extends like a line. See Wolfson, “Light Does Not Talk,” p. 93, and the revised version in Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", p. 44. To live halakhically, therefore, means to advance in time linearly but in a manner that repeats itself circularly. For a different approach to the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_57",
      "title": "57"
    }
  }, [_vm._v("circularity of the temporal in Rosenzweig’s thinking as a form of repetition that entails the incursion of eternity in time, see Braiterman, "), _c('i', [_vm._v("Shape of Revelation")]), _vm._v(", pp. 133–65, esp. 162–65. In some respect, his analysis of the image of the spiral in Buber’s "), _c('i', [_vm._v("Ich und Du")]), _vm._v(" is closer to my reading of Rosenzweig. See Braiterman, p. 151: “Revelation works in a circle that spirals forward into the future.… The spiral is used to juxtapose the extreme sensitivity to decay observed by the severest critics of modern society alongside the hope in radical renewal.… While the motion is profoundly circular, the spiral plot allows the circle to move forward into the future of redemption. Time is unstuck.” On the depiction of Judaism as embracing an idea of eternity-in-time, enacted through the cyclical recurrence of the liturgical calendar, see also Gibbs, "), _c('i', [_vm._v("Correlations")]), _vm._v(", pp. 108–11; Gordon, “Franz Rosenzweig,” pp. 135–37; Schindler, "), _c('i', [_vm._v("Zeit")]), _vm._v(", pp. 348–52, 359–70, 382, 385–86; Biemann, "), _c('i', [_vm._v("Inventing New Beginnings")]), _vm._v(", pp. 212–17; Pollock, "), _c('i', [_vm._v("Franz Rosenzweig and the Systematic Task of Philosophy")]), _vm._v(", pp. 276–83; Lin, "), _c('i', [_vm._v("Intersubjectivity of Time")]), _vm._v(", pp. 144–47. For a different perspective on Rosenzweig’s construal of the sacred time of ritual, see Mosès, "), _c('i', [_vm._v("System and Revelation")]), _vm._v(", pp. 170–200, and my criticism in Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 57–58.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn119"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_119"
    }
  }, [_vm._v("119")]), _vm._v(". Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", pp. 276–77; "), _c('i', [_vm._v("Stern der Erlosung")]), _vm._v(", p. 287.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn120"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_120"
    }
  }, [_vm._v("120")]), _vm._v(". Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", p. 277; "), _c('i', [_vm._v("Stern der Erlosung")]), _vm._v(", pp. 287–88.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn121"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_121"
    }
  }, [_vm._v("121")]), _vm._v(". Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", p. 443; "), _c('i', [_vm._v("Stern der Erlosung")]), _vm._v(", p. 467. Simultaneity is correlated most pristinely with the eternity of the Jewish people, but Rosenzweig does attribute this comportment to the temporality experienced by Christians, the eternal way, expressed in the act of brotherly love. Compare Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", pp. 366–67 ("), _c('i', [_vm._v("Stern der Erlösung")]), _vm._v(", pp. 383–84): “Simultaneousness ["), _c('i', [_vm._v("Gleichzeitigkeit")]), _vm._v("] is something that does not exist at all in temporality ["), _c('i', [_vm._v("Zeitlichkeit")]), _vm._v("]. In temporality there is only before and after; the moment someone beholds himself can only precede or follow the moment he beholds another; simultaneous beholding of oneself and another in the same moment is impossible. That is the deepest reason why in the pagan world that is of course precisely temporality, it was impossible to love one’s neighbor as oneself. But in eternity ["), _c('i', [_vm._v("Ewigkeit")]), _vm._v("] there is simultaneousness. That from the shore all time is simultaneous ["), _c('i', [_vm._v("alle Zeit gleichzeitig ist")]), _vm._v("] goes without saying. But even time that, as eternal way, leads from eternity to eternity admits of simultaneousness. For only insofar as it is center between eternity and eternity is it possible for people to meet in it. He who therefore beholds himself on the way is at the same point, namely the exact central point ["), _c('i', [_vm._v("Mittelpunkte")]), _vm._v("], of time. The brotherliness is that which transposes men into this central point.” The matter of simultaneity with respect to the universality and the particularity of the Jewish people is applied to the triad of God, human, and world in Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", pp. 324–25 ("), _c('i', [_vm._v("Stern der Erlösung")]), _vm._v(", pp. 339–40): “For that which is singular ["), _c('i', [_vm._v("das Einzelne")]), _vm._v("] in itself is not eternal for all that, because the whole is outside of it and can only affirm itself in its individuality ["), _c('i', [_vm._v("Einzelheit")]), _vm._v("] by fitting in the whole somehow as part. An individuality therefore that wanted to be eternal as well would have to have the universe entirely in itself. And that would mean that the Jewish people gathers in its own bosom the elements God world man of which of course the universe consists.… God, man, world must have in themselves the difference through which they become God, man, world of the one people, for this one people ["), _c('i', [_vm._v("ein Volk")]), _vm._v("] must be a unique people ["), _c('i', [_vm._v("einziges Volk")]), _vm._v("]. They must conceal the polar oppositions in themselves in order to be able to be singular, definite, something particular, a God, a human, a world, and yet simultaneously ["), _c('i', [_vm._v("zugleich")]), _vm._v("] everything, God, man, the whole world.” On the temporalization of God in Rosenzweig’s idea of redemption, see Gordon, "), _c('i', [_vm._v("Rosenzweig and Heidegger")]), _vm._v(", p. 205. For a different perspective on the temporality of existence in Rosenzweig’s new thinking and the embrace of a radical finitude ground in the nonidentity between thinking and being and the common sense of death, see Björk, "), _c('i', [_vm._v("Life Outside Life")]), _vm._v(", pp. 91–103.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn122"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_122"
    }
  }, [_vm._v("122")]), _vm._v(". Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", p. 443; "), _c('i', [_vm._v("Stern der Erlosung")]), _vm._v(", p. 467.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn123"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_123"
    }
  }, [_vm._v("123")]), _vm._v(". Levinas, "), _c('i', [_vm._v("Entre Nous")]), _vm._v(", pp. 118, 175–77, 232–33; idem, “Foreword,” in Mosès, "), _c('i', [_vm._v("System and Revelation")]), _vm._v(", pp. 21–22. Concerning this theme, see Smith, "), _c('i', [_vm._v("Toward the Outside")]), _vm._v(", pp. 106–8; Sugarman, “Emmanuel Levinas”; Morgan, "), _c('i', [_vm._v("Discovering Levinas")]), _vm._v(", pp. 219–27, esp. 220–21; Severson, "), _c('i', [_vm._v("Levinas’s Philosophy of Time")]), _vm._v(", pp. 10, 201–6, 238, 247, 264, 267–68, 336–37n2; Micali, “The Deformalization of Time”; Frangeskou, "), _c('i', [_vm._v("Levinas, Kant and the Problematic of Temporality")]), _vm._v(", pp. 8–9, 146–55. On Levinas’s analysis of the temporal ecstasies of past, present, and future in Rosenzweig, correlated with the theological categories of creation, revelation, and redemption, see Chanter, "), _c('i', [_vm._v("Time, Death, and the Feminine")]), _vm._v(", pp. 193–97; and compare Gibbs, “Present Imperative,” pp. 170–71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn124"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_124"
    }
  }, [_vm._v("124")]), _vm._v(". To be sure, in some passages, Rosenzweig demarcates the difference between the eternal life of Judaism and the eternal way of Christianity in terms that imply unequivocally that the former is removed from the web of time in contrast to the latter "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_58",
      "title": "58"
    }
  }, [_vm._v("whose mandate is to be enmeshed therein. A closer examination of these passages, however, suggests that the matter is more complex: insofar as both the star and its rays are necessary elements of the task of redemption, Jews must eternalize temporality through the liturgical calendar and Christians temporalize eternity by preparing for the kingdom in history by converting the pagan externally and internally. See Rosenzweig, "), _c('i', [_vm._v("Star of Redemption")]), _vm._v(", pp. 438–39 ("), _c('i', [_vm._v("Stern der Erlosung")]), _vm._v(", pp. 462–63): “Before God therefore, both, Jew and Christian, are workers on the same task. He cannot dispense with either. Between the two, he set an enmity for all time, and yet he binds them together in the narrowest reciprocity. To us, he gave eternal life by igniting in our heart the fire of the Star of his truth. He placed the Christians on the eternal way by making them hasten after the rays of that Star of his truth into all time until the eternal end. We see therefore in our heart the true likeness of truth ["), _c('i', [_vm._v("das treue Gleichnis der Wahrheit")]), _vm._v("], but for that we turn away from temporal life and the life of time turns away from us ["), _c('i', [_vm._v("doch wenden wir uns dafür vom zeitlichen Leben ab und das Leben der Zit sich von uns")]), _vm._v("]. They on the contrary follow the river of time, but they have the truth only behind them; they are certainly guided by it, for they follow its rays, but they do not see it with their eyes. The truth, the whole truth, belongs therefore neither to them nor to us. For though we indeed carry it in us, yet for this reason too we must first sink our glance into our own inside if we want to see it, and there we do see the Star, but not—the rays. And belonging to the whole truth would be that one would see not only its light, but also what is illuminated by it. They however are destined all the same for all time to see what is illuminated, not the light. And therefore we both have only a share in the whole truth.… Immediate sight of the whole truth comes only to him who sees it in God ["), _c('i', [_vm._v("Unmittelbare Schau der ganzen Wahrheit wird nur dem, der sie in Gott schaut")]), _vm._v("]. But this is a seeing beyond life ["), _c('i', [_vm._v("Das aber ist ein Schauen jenseits des Lebens")]), _vm._v("]. A living seeing of the truth, a seeing that is life at the same time, thrives even for us only out of the sinking into our own Jewish heart and even there only in the image and likeness ["), _c('i', [_vm._v("im Gleichnis und Abbild")]), _vm._v("]. And for them, for the sake of the living effect of truth, the live seeing is denied to them altogether. So we both, they like us, and we like them, are creatures just on this account that we do not see the whole truth. Just for this reason we remain within the limits of mortality. Just for this reason—we remain. And we of course want to remain. We of course want to live.” From the perspective of history, the whole truth—the seeing of God that is beyond life—belongs neither to the Jew nor to the Christian. Even for the Jew, who turns away from the temporal to fulfill the metahistorical destiny of the eternal people, the seeing of truth must be a seeing that is life, that is, the vision of truth in the form of the image and likeness confabulated in the heart. The manifestation of truth in the mirror of imagination, wherein truth is appearance and appearance is truth, relates to the creatureliness of the Jew, to the finitude and temporal comportment of being in the world, albeit as the people that is beyond the world. See Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", p. 45, and herein ch. 7 n. 199.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn125"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_125"
    }
  }, [_vm._v("125")]), _vm._v(". See above, nn. 73 and 86. For the influence on Rosenzweig of the Kierkegaardian motif of retrieval as rebirth, see Groiser, “Repetition and Renewal.” For the influence of Kierkegaard’s notion of the moment on Soloveitchik, see Herskowitz, “The Moment and the Future.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn126"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_126"
    }
  }, [_vm._v("126")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Being and Time")]), _vm._v(", §65, p. 314 (emphasis in original); "), _c('i', [_vm._v("Sein und Zeit")]), _vm._v(", p. 329.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn127"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_127"
    }
  }, [_vm._v("127")]), _vm._v(". Lacan, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 213; "), _c('i', [_vm._v("Écrits")]), _vm._v(", p. 256. By putting the focus on the restructuring of an event after the fact, Freud “declares that he considers it legitimate, in analyzing the processes, to elide the time intervals during which the event remains latent in the subject. That is to say, he annuls the "), _c('i', [_vm._v("times for understanding")]), _vm._v(" [temps pour comprendre] in favor of the "), _c('i', [_vm._v("moments of concluding")]), _vm._v(" [moments de conclure] which precipitate the subject’s meditation toward deciding the meaning to be attached to the early event” (Lacan, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 213; "), _c('i', [_vm._v("Écrits")]), _vm._v(", pp. 256–57). See Bistoen, Vanheule, and Craps, “Nachträglichkeit”; Nobus, "), _c('i', [_vm._v("Jacques Lacan")]), _vm._v(", pp. 86–87; Green, “Lacan: "), _c('i', [_vm._v("Nachträglichkeit")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn128"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_128"
    }
  }, [_vm._v("128")]), _vm._v(". Lacan, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 247; "), _c('i', [_vm._v("Écrits")]), _vm._v(", p. 300.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn129"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_129"
    }
  }, [_vm._v("129")]), _vm._v(". Lacan, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 711; "), _c('i', [_vm._v("Écrits")]), _vm._v(", p. 839.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn130"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_130"
    }
  }, [_vm._v("130")]), _vm._v(". Lacan, "), _c('i', [_vm._v("Four Fundamental Concepts")]), _vm._v(", p. 49. Lacan discusses at great length the unconscious, repeating, and remembering (pp. 17–64, esp. 48–51) to demonstrate the noncommutativity of repetition and memory in Freudian theory and to substantiate the further implication that the time-function related to these gestures is bound up with the signifying shaping of the real and hence must be viewed as a category that belongs only to the signifier (p. 40).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn131"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_131"
    }
  }, [_vm._v("131")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Contributions")]), _vm._v(", §242, p. 303 (emphasis in original); "), _c('i', [_vm._v("Beiträge")]), _vm._v(", p. 384. Interestingly, Lacan invokes Heidegger when he discusses the act of remembering ("), _c('i', [_vm._v("remémoration")]), _vm._v(") right before he mentions Freud’s "), _c('i', [_vm._v("Nachträglichkeit")]), _vm._v(". See Lacan, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 212 ("), _c('i', [_vm._v("Écrits")]), _vm._v(", p. 255): “In "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_59",
      "title": "59"
    }
  }, [_vm._v("Heideggerian language one could say that both types of remembering constitute the subject as "), _c('i', [_vm._v("gewesend")]), _vm._v("—that is, as being the one who has thus been. But in the internal unity of this temporalization, entities ["), _c('i', [_vm._v("l’étant")]), _vm._v("] mark the convergence of the having-beens ["), _c('i', [_vm._v("des ayant été")]), _vm._v("]. In other words, if other encounters are assumed to have occurred since any one of these moments having been, another entity would have issued from it that would cause him to have been altogether differently.” See the revealing remark in the seminar on Edgar Allan Poe’s “The Purloined Letter” in Lacan, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 15 ("), _c('i', [_vm._v("Écrits")]), _vm._v(", p. 21): “Thus, when we are open to hearing the way in which Martin Heidegger uncovers for us in the word "), _c('i', [_vm._v("alethes")]), _vm._v(" the play of truth, we merely rediscover a secret to which truth has always initiated her lovers, and through which they have learned that it is in hiding that she offers herself to them most "), _c('i', [_vm._v("truly")]), _vm._v("” (emphasis in original). See Janicaud, "), _c('i', [_vm._v("Heidegger in France")]), _vm._v(", p. 131. On Heidegger’s notion of truth and revelation, see Lacan, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 136; "), _c('i', [_vm._v("Écrits")]), _vm._v(", p. 166, and the comment on the true, the real, and Heidegger’s term "), _c('i', [_vm._v("echt")]), _vm._v(" in Lacan, "), _c('i', [_vm._v("Sinthome")]), _vm._v(", pp. 69 and 229n7. And compare Lacan, "), _c('i', [_vm._v("Anxiety")]), _vm._v(", p. 8: “There stands Heidegger. With my play on the word "), _c('i', [_vm._v("jeter")]), _vm._v(", it was precisely to him and his originative dereliction that I was closest.” See ibid., pp. 79 and 90. Heidegger is also mentioned explicitly by Lacan, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 262 ("), _c('i', [_vm._v("Écrits")]), _vm._v(", p. 318), in his explanation of how death should be considered a limit. And in another passage, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 323 ("), _c('i', [_vm._v("Écrits")]), _vm._v(", pp. 387–88), Lacan elucidates Freud’s "), _c('i', [_vm._v("Bejahung")]), _vm._v(" as the primal condition wherein something of the real ("), _c('i', [_vm._v("réel")]), _vm._v(") offers itself up to the revelation of being ("), _c('i', [_vm._v("révélation de l’être")]), _vm._v(") by referring to Heidegger’s language of “to be let-be” ("), _c('i', [_vm._v("soit laissé-être")]), _vm._v("). On Heidegger and the meaning of the verb "), _c('i', [_vm._v("to be")]), _vm._v(" in its various conjugations, see Lacan, "), _c('i', [_vm._v("Psychoses")]), _vm._v(", pp. 300–1. See as well the revealing comment, "), _c('i', [_vm._v("Écrits: First Complete Edition")]), _vm._v(", p. 438 ("), _c('i', [_vm._v("Écrits")]), _vm._v(", pp. 527–28), where in the context of calling for a reexamination of the human situation in the midst of beings ("), _c('i', [_vm._v("la situation de l’homme dans l’étant")]), _vm._v("), Lacan clarifies his use of a Heideggerianism: “When I speak of Heidegger, or rather when I translate him, I strive to preserve the sovereign signifierness ["), _c('i', [_vm._v("significance souveraine")]), _vm._v("] of the speech he proffers.” Mention should be made of Lacan’s translation of Heidegger’s essay on the Heraclitean fragment on the “Logos” published in "), _c('i', [_vm._v("La Psychanalyse")]), _vm._v(". See Lacan, "), _c('i', [_vm._v("Psychoses")]), _vm._v(", p. 124; Roudinesco, "), _c('i', [_vm._v("Jacques Lacan")]), _vm._v(", pp. 229–30; Lippi, “Héraclite, Lacan”; Janicaud, "), _c('i', [_vm._v("Heidegger in France")]), _vm._v(", p. 453n121; Krell, “Is There a Heidegger?” The relationship between Heidegger and Lacan has been discussed by various scholars. For a representative list, see Casey and Woody, “Hegel, Heidegger, Lacan”; Richardson, “Psychoanalysis and the Being-Question”; Boothby, "), _c('i', [_vm._v("Death and Desire")]), _vm._v(", pp. 203–21; Riera, “Abyssal Grounds”; Roudinesco, "), _c('i', [_vm._v("Jacques Lacan")]), _vm._v(", pp. 219–31; Egginton, "), _c('i', [_vm._v("Philosopher’s Desire")]), _vm._v(", pp. 65, 110–12; Žižek, "), _c('i', [_vm._v("Less Than Nothing")]), _vm._v(", pp. 859–903. Compare Derrida, "), _c('i', [_vm._v("Heidegger: la question")]), _vm._v(", p. 97; and see now Derrida, "), _c('i', [_vm._v("Heidegger: The Question")]), _vm._v(", p. 56. Derrida illumines the co-belonging of being and language in Heidegger’s thought by citing two passages from Lacan. Regarding the personal interactions of Heidegger and Lacan, see Roudinesco, "), _c('i', [_vm._v("Jacques Lacan & Co")]), _vm._v(", pp. 298–99. On Heidegger and Freudian psychotherapy, see discussion and citation of other relevant sources, especially the work of Medard Boss, in Wolfson, “Not Yet Now,” p. 163n138, to which I would add Richardson, “Heidegger and Psychoanalysis”; Brencio, “World, Time and Anxiety”; and Brencio, “Heidegger and Binswanger.” For further references, see ch. 7 n. 114.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn132"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_132"
    }
  }, [_vm._v("132")]), _vm._v(". Wolfson, “Retroactive Not Yet,” pp. 44–50. On the Freudian "), _c('i', [_vm._v("Nachträglichkeit")]), _vm._v(" and the Derridean trace, see Major, "), _c('i', [_vm._v("Lacan avec Derrida")]), _vm._v(", p. vi; Hamrit, “Nachträglichkeit.” For an attempt to discern a common approach to time in Heidegger, Derrida, and Lacan—or what is referred to more specifically as the spacing at the heart of temporality—see Egginton, "), _c('i', [_vm._v("Philosopher’s Desire")]), _vm._v(", pp. 106–38. An independent, but somewhat related, question is the influence of kabbalah on Lacan. See Haddad, “Judaism,” pp. 203–4. The author suggests that the source of Lacan’s knowledge of kabbalah was Elie Benamozegh’s "), _c('i', [_vm._v("Israël et l’humanité")]), _vm._v(". See also the intriguing passage of Lacan in "), _c('i', [_vm._v("Four Fundamental Concepts of Psychoanalysis")]), _vm._v(" on the phallic symbolism of the "), _c('i', [_vm._v("fundamentum")]), _vm._v(" in the kabbalah, cited in Wolfson, "), _c('i', [_vm._v("Language")]), _vm._v(", p. 482n119.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn133"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_133"
    }
  }, [_vm._v("133")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Concept of Time")]), _vm._v(" (McNeill trans.), pp. 17–18.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn134"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_134"
    }
  }, [_vm._v("134")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("What Is Called Thinking?")]), _vm._v(", p. 99; "), _c('i', [_vm._v("Was Heißt Denken")]), _vm._v("?, p. 82.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn135"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_135"
    }
  }, [_vm._v("135")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("On Time and Being")]), _vm._v(", p. 11; "), _c('i', [_vm._v("Zur Sache des Denkens")]), _vm._v(", p. 15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn136"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_136"
    }
  }, [_vm._v("136")]), _vm._v(". Dastur, "), _c('i', [_vm._v("Heidegger and the Question of Time")]), _vm._v(", pp. 37–38. Many others have written about Heidegger’s thinking about time, but here I would like to mention the analysis in Harman, "), _c('i', [_vm._v("Quadruple Object")]), _vm._v(", pp. 54–57. I agree with Harman that Heidegger rejects both the idea of time as a sequence of discrete now-points as well as the Bergsonian idea of a continual flux. But I do not accept his argument that Heidegger espouses a form of occasionalism wherein the only thing "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_60",
      "title": "60"
    }
  }, [_vm._v("that is real is a frozen moment that is “torn in three directions,” a present that has nothing to do with the real past or future and hence is a “temporality without time.” Heidegger’s notion of equiprimordiality enunciates a genuine convergence of the three "), _c('i', [_vm._v("ecstases")]), _vm._v(" of time in the moment that projects to the future and thereby affords one the possibility of reclaiming the past in the present. Far from being a temporality without time, the Heideggerian temporality is saturated with an overabundance of time that renders each moment past, present, and future all at once.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn137"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_137"
    }
  }, [_vm._v("137")]), _vm._v(". Scholem, "), _c('i', [_vm._v("Messianic Idea")]), _vm._v(", p. 289 (emphasis in original). See the analysis in Wolfson, "), _c('i', [_vm._v("Giving")]), _vm._v(", pp. 55–56.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn138"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_138"
    }
  }, [_vm._v("138")]), _vm._v(". Wolfson, "), _c('i', [_vm._v("Alef")]), _vm._v(", p. 60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn139"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_139"
    }
  }, [_vm._v("139")]), _vm._v(". Ibid., pp. 64–65.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote2",
    attrs: {
      "id": "ch1fn140"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#ch1fn_140"
    }
  }, [_vm._v("140")]), _vm._v(". Heidegger, "), _c('i', [_vm._v("Parmenides")]), _vm._v(", p. 12; "), _c('i', [_vm._v("Parmenides")]), _vm._v(" [GA 54], p. 18. The similarity between Heideggerian and rabbinic hermeneutics extends as well to the use of wordplay to elicit new meaning and the underlying assumption that interpretation is a form of translation in the sense of transporting and thereby transforming the past. The point is made effectively by Fay, "), _c('i', [_vm._v("Heidegger: The Critique of Logic")]), _vm._v(", p. 56: “Heidegger, then, is not interested in going back to word roots to determine with the exactness of the philologist the meaning of a word. The work of the philosopher, at least as he conceives of the task of philosophy, starts where the work of philology stops, or more precisely the one is on the level of what Heidegger calls "), _c('i', [_vm._v("Historie")]), _vm._v(", determination of what the past was as past ("), _c('i', [_vm._v("Vergangenheit")]), _vm._v("), while the other is not interested in the past as past, but sees it as somehow living still ("), _c('i', [_vm._v("Gewesenheit")]), _vm._v(") and influencing the present and future. But if the future is to be shaped according to its authentic possibilities the past cannot be simply taken over in an imitative, essentially uncreative, repetition.” If we were to substitute the word "), _c('i', [_vm._v("exegesis")]), _vm._v(" for philosophy, then Fay’s observation would be a perfectly apt description of the hermeneutical foundation of the midrashic effort of rabbinic sages through the centuries to interpret the scriptural word, an enterprise that is aimed not at repetitively uncovering meaning of the text to establish the past mimetically as it was but rather to invest it eisegetically with new meaning, to shape the present and future by laying bare what is still always to be thought in what was previously spoken. I again note the irony of my argument: notwithstanding Heidegger’s unyielding neglect of Jewish sources, the path of his own thinking, and indeed the transition from the metaphysical reasoning of philosophy in the past to the meditative thought he ascribes to the new beginning in the future, shares much with the midrashic method of the rabbis.")])])])])])])])])])])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9780253042583',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(121)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(123);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 123 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.79cb187c9aa50267a113.js